import { useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import * as XLSX from 'xlsx';
import { BASE_URL } from "../../config/axios";
import axios from "axios";
import { handleErrorToast, formatCurrencyIndian, ProgressModal, } from "../CustomFunctions";
import { formatDate } from "../Date";
import { Modal } from "react-bootstrap";
import './downloadButton.css';
import { UploadIcon } from "../AllSvg"
import { X, Download, FileText, Shield, Landmark, Building2, Clock, FileCheck, Award, Flag, HardDrive, FileArchive, DownloadCloud, HardDriveDownload, Upload, FileSpreadsheet, FileUp, Info, Loader, UploadCloud, AlertCircle, Car, Package } from 'lucide-react';

import JSZip from "jszip";
// import { formatCurrencyIndian, getMonthName, handleErrorToast, sortProjects, ViewRequestStatus, ViewRequestRemarks } from '../CustomFunctions';
const UploadSiteProject = ({ id, getProject, ProjectList, getContractorProjects }) => {



    const [show, setShow] = useState(false);
    const [fileName, setFileName] = useState("");
    const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});

    const bulktableRef = useRef(null);
    const handleDownload = () => {
        const table = bulktableRef.current;
        const wb = XLSX.utils.table_to_book(table, { sheet: "Project Details" });
        const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.ms-excel",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Project Detail Format.xls";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleClose = () => {
        setFileName("")
        setExcelJson(null)
        setDocErrors({})
        setShow(false)
    };
    const handleShow = () => setShow(true);

    // Function to handle file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check for valid file type
            const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
            if (!validFileTypes.includes(file.type)) {
                setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
                setFileName("");
                return;
            }

            setFileName(file.name);
            readExcel(file); // Convert the file to JSON
        } else {
            setFileName("");
        }
    };

    const checkForDuplicates = (data) => {
        const sitecodes = new Map();
        const duplicates = [];

        // Track positions of each insurance number
        data.forEach((i, index) => {
            const projectcode = i.site_prcode;
            if (sitecodes.has(projectcode)) {
                // If the insurance number already exists, add the current position to its list
                sitecodes.get(projectcode).push(index + 1); // index + 1 for 1-based position
            } else {
                // If it's the first time seeing this insurance number, initialize its position list
                sitecodes.set(projectcode, [index + 1]);
            }
        });

        // Now, filter out only the numbers that appear more than once
        sitecodes.forEach((positions, projectcode) => {
            if (positions.length > 1) {
                duplicates.push(`\Site Project Code :${projectcode} is found in position(s) ${positions.join(", ")}`);
            }
        });

        return duplicates;
    };


    const readExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0]; // Use the first sheet
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

            const headers = json[0];
            const rows = json.slice(1);

            const convertToYYYYMMDD = (input) => {
                try {
                    let date;

                    // Handle Excel serial dates
                    if (typeof input === "number") {
                        const excelEpoch = new Date(1900, 0, 1); // Excel epoch starts on Jan 1, 1900
                        const daysOffset = input - 1; // Subtract 1 because of leap year bug
                        date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
                    } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
                        // Format: YYYY.MM.DD
                        const [year, month, day] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
                        // Format: DD.MM.YYYY
                        const [day, month, year] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else {
                        // Default parsing for other formats
                        date = new Date(input);
                    }

                    if (isNaN(date.getTime())) {
                        throw new Error('Invalid date format');
                    }

                    // Format the date as YYYY-MM-DD
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                    const day = String(date.getDate()).padStart(2, '0');

                    return `${year}-${month}-${day}`;
                } catch (error) {
                    return null; // Return null for invalid dates
                }
            };

            // Create a formatted JSON object based on headers and row values
            const formattedJson = rows.map((row) => {
                const obj = {};
                headers.forEach((header, index) => {

                    if (["agreement_date", "commencement_date", "loa_award_date", "actual_completion_date", "schedule_completion_date", "actual_construction_completion_date", "schedule_construction_completion_date", "bid_due_date"].includes(header) && row[index] && typeof row[index] === "number") {
                        obj[header] = convertToYYYYMMDD(row[index]); // Convert date
                    } else {
                        obj[header] = row[index] !== undefined ? row[index] : null;
                    }
                });
                return obj;
            });


            // Ensure the input to checkForDuplicates is an array
            const duplicates = checkForDuplicates(formattedJson);

            if (duplicates.length > 0) {
                // Toast notification with line breaks for each duplicate
                toast.error(
                    `Duplicate Projects found:\n${duplicates.join("\n")}`,
                    {
                        autoClose: 5000, // Close toast after 5 seconds
                    }
                );
            }


            // Set the formatted JSON data to state
            setExcelJson(formattedJson);
        };
        reader.readAsArrayBuffer(file);

    };

    // Function to handle the upload button click
    const handleUpload = async () => {

        if (excelJson) {
            const duplicates = checkForDuplicates(excelJson);

            if (duplicates.length > 0) {
                toast.error(`Duplicate Data found:\n ${duplicates.join(", ")}`, {
                    autoClose: 5000,
                });
            }
            const loadingToastId = toast.loading("Uploading: Please wait...");
            try {
                const res = await axios.post(`${BASE_URL}/siteproject/projectbulkuploadadd/`, excelJson);
                if (res.status === 200) {
                    await getProject();
                    await getContractorProjects();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Projects uploaded successfully.");

                } else {
                    toast.dismiss(loadingToastId);
                    toast.error("Failed to add data!");
                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                toast.dismiss(loadingToastId);
            }
        } else {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
        }
    };





    return (
        <>

            <button title="Upload" className="model-button   font-weight500   model-button-print" onClick={handleShow} style={{ margin: "2px" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                    <g fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                        <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                    </g>
                </svg>
            </button>

            <Modal show={show} dialogClassName="ourcompany-model">

                <Modal.Body>
                    <div className="flex-row align-center">

                        <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Upload Bulk Project Data in format :</Modal.Title> </h1>


                        <button onClick={handleDownload} className="model-button-download model-button font-weight500">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Format
                        </button>

                    </div>

                    <div className="table-css-white-background" style={{ display: "none" }}>
                        <table ref={bulktableRef} className="nested-table-lightblue">
                            <thead>
                                <tr className="custom-table-head-tr">
                                    <th className="align-left">site_prcode</th>
                                    <th className="table-heading-text">project_name</th>
                                    <th className="table-heading-text">project_short_name</th>
                                    <th className="table-heading-text">location</th>
                                    <th className="table-heading-text">sub_company</th>
                                    <th className="table-heading-text">work_type</th>
                                    <th className="table-heading-text">bid_due_date</th>
                                    <th className="table-heading-text">commencement_date</th>
                                    <th className="table-heading-text">loa_award_date</th>
                                    <th className="table-heading-text">actual_construction_completion_date</th>
                                    <th className="table-heading-text">schedule_construction_completion_date</th>
                                    <th className="table-heading-text">agreement_date</th>
                                    <th className="table-heading-text">concern_person_name</th>
                                    <th className="table-heading-text">tender_id</th>
                                    <th className="table-heading-text">actual_completion_date</th>
                                    <th className="table-heading-text">schedule_completion_date</th>
                                    <th className="table-heading-text">remark</th>
                                    <th className="table-heading-text">project_length</th>
                                    <th className="table-heading-text">consultancy_fees</th>
                                    <th className="table-heading-text">contract_mode</th>
                                    <th className="table-heading-text">jv</th>
                                    <th className="table-heading-text">lead</th>
                                    <th className="table-heading-text">our_share</th>
                                    <th className="table-heading-text">association</th>
                                    <th className="table-heading-text">client_name</th>
                                    <th className="table-heading-text">project_key_point</th>
                                    <th className="table-heading-text">ro</th>
                                    <th className="align-right">ro_address</th>
                                    <th className="align-right">piu_address</th>
                                    <th className="align-right">project_duration</th>
                                    <th className="align-right">our_role</th>
                                    <th className="align-right">site_office_address</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th className="align-left">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-right">-</th>
                                    <th className="align-right">-</th>
                                    <th className="align-right">-</th>
                                    <th className="align-right">-</th>
                                    <th className="align-right">-</th>
                                    <th className="align-right">-</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="table-css-white-background scroll-container"
                    >
                        <div className="table-container scrollbar" style={{ width: "100%" }}>
                            <table className="nested-table-lightblue" style={{ margin: "0px" }}>
                                <thead className="table-heading">
                                    <tr className="custom-table-head-tr modal-padding-heading">
                                        <th className="table-heading-text">Project Code</th>
                                        <th className="table-heading-text">Project Name</th>
                                        <th className="table-heading-text">Project Short Name</th>
                                        <th className="table-heading-text">Location</th>
                                        <th className="table-heading-text">Sub Company</th>
                                        <th className="table-heading-text">Work Type</th>
                                        <th className="table-heading-text">Bid Due Date</th>
                                        <th className="table-heading-text">Commencement Date</th>
                                        <th className="table-heading-text">LOA Award Date</th>
                                        <th className="table-heading-text">Actual Construction Completion Date</th>
                                        <th className="table-heading-text">Schedule Construction Completion Date</th>
                                        <th className="table-heading-text">Agreement Date</th>
                                        <th className="table-heading-text">Concern Person Name</th>
                                        <th className="table-heading-text">Tender ID</th>
                                        <th className="table-heading-text">Actual Completion Date</th>
                                        <th className="table-heading-text">Schedule Completion Date</th>
                                        <th className="table-heading-text">Remark</th>
                                        <th className="table-heading-text">Project Length</th>
                                        <th className="table-heading-text">Consultancy Fees</th>
                                        <th className="table-heading-text">Contract Mode</th>
                                        <th className="table-heading-text">JV</th>
                                        <th className="table-heading-text">Lead</th>
                                        <th className="table-heading-text">Our Share</th>
                                        <th className="table-heading-text">Association</th>
                                        <th className="table-heading-text">Client Name</th>
                                        <th className="table-heading-text">Project Key Point</th>
                                        <th className="table-heading-text">RO</th>
                                        <th className="table-heading-text">RO Address</th>
                                        <th className="table-heading-text">PIU Address</th>
                                        <th className="table-heading-text">Project Duration</th>
                                        <th className="table-heading-text">Our Role</th>
                                        <th className="table-heading-text">Site Office Address</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {excelJson?.map((project, index) => (
                                        <tr key={index} className="modal-padding-heading">
                                            <th className="table-heading-text">{project.site_prcode}</th>
                                            <th className="table-heading-text">{project.project_name}</th>
                                            <th className="table-heading-text">{project.project_short_name}</th>
                                            <th className="table-heading-text">{project.location}</th>
                                            <th className="table-heading-text">{project.sub_company}</th>
                                            <th className="table-heading-text">{project.work_type}</th>
                                            <th className="table-heading-text">{project.bid_due_date}</th>
                                            <th className="table-heading-text">{project.commencement_date}</th>
                                            <th className="table-heading-text">{project.loa_award_date}</th>
                                            <th className="table-heading-text">{project.actual_construction_completion_date}</th>
                                            <th className="table-heading-text">{project.schedule_construction_completion_date}</th>
                                            <th className="table-heading-text">{project.agreement_date}</th>
                                            <th className="table-heading-text">{project.concern_person_name}</th>
                                            <th className="table-heading-text">{project.tender_id}</th>
                                            <th className="table-heading-text">{project.actual_completion_date}</th>
                                            <th className="table-heading-text">{project.schedule_completion_date}</th>
                                            <th className="table-heading-text">{project.remark}</th>
                                            <th className="table-heading-text">{project.project_length}</th>
                                            <th className="table-heading-text">{project.consultancy_fees}</th>
                                            <th className="table-heading-text">{project.contract_mode}</th>
                                            <th className="table-heading-text">{project.jv}</th>
                                            <th className="table-heading-text">{project.lead}</th>
                                            <th className="table-heading-text">{project.our_share}</th>
                                            <th className="table-heading-text">{project.association}</th>
                                            <th className="table-heading-text">{project.client_name}</th>
                                            <th className="table-heading-text">{project.project_key_point}</th>
                                            <th className="table-heading-text">{project.ro}</th>
                                            <th className="table-heading-text">{project.ro_address}</th>
                                            <th className="table-heading-text">{project.piu_address}</th>
                                            <th className="table-heading-text">{project.project_duration}</th>
                                            <th className="table-heading-text">{project.our_role}</th>
                                            <th className="table-heading-text">{project.site_office_address}</th>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                        </div>
                    </div>

                    <div className="flex-column field-cont-div">
                        <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
                            Upload File
                        </label>
                        <label
                            htmlFor="document_file"
                            className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                                }`}
                        >
                            <svg
                                className="pdf-input"
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                                    stroke="#707070"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </label>
                        <input
                            id="document_file"
                            name="document_file"
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileChange}
                            className="file-inputs align-center"
                            style={{ display: "none", position: "relative" }}
                        />
                        {fileName && <p className="file-name align-center">{fileName}</p>}
                        <br />
                        {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
                    </div>

                    <h4>References:</h4>
                    <div className="reference-container">
                        <div className="reference-section">
                            <p className="reference-title">General:</p>
                            <ul className="arrow-list">
                                <li>Site prcode should be unique</li>

                            </ul>
                        </div>
                        <div className="reference-section">
                            <p className="reference-title">For Work Type use one of these:</p>
                            <ul className="arrow-list">
                                <li>construction consultant</li>
                                <li>operations & maintenance consultant</li>
                                <li>safety consultant</li>
                                <li>dpr</li>
                            </ul>
                        </div>
                        <div className="reference-section">
                            <p className="reference-title">For Our Role use one of these:</p>
                            <ul className="arrow-list">
                                <li>active</li>
                                <li>partially</li>
                                <li>silent</li>
                            </ul>
                        </div>
                        <div className="reference-section">
                            <p className="reference-title">For Contract Mode use one of these:</p>
                            <ul className="arrow-list">
                                <li>epc</li>
                                <li>ham</li>
                                <li>bot</li>
                            </ul>
                        </div>
                        <div className="date-section">
                            <p className="date-text">All Dates should be in DD-MM-YYYY format</p>
                        </div>
                    </div>


                    <div className="button-models">
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Upload
                        </button>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};
const UploadLetterBulk = ({ id, getLetters, site_prcode, contractor_name, letterBy }) => {




    const [show, setShow] = useState(false);
    const [fileName, setFileName] = useState("");
    const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});

    const bulktableRef = useRef(null);
    const handleDownload = () => {
        const table = bulktableRef.current;
        const wb = XLSX.utils.table_to_book(table, { sheet: "Letter Details" });
        const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.ms-excel",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Letter Details Format.xls";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleClose = () => {
        setFileName("")
        setExcelJson(null);
        setDocErrors({});
        setShow(false);
    };
    const handleShow = () => setShow(true);

    // Function to handle file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check for valid file type
            const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
            if (!validFileTypes.includes(file.type)) {
                setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
                setFileName("");
                return;
            }

            setFileName(file.name);
            readExcel(file); // Convert the file to JSON
        } else {
            setFileName("");
        }
    };

    const checkForDuplicates = (data) => {
        const lettersData = new Map();
        const duplicates = [];

        data.forEach((i, index) => {
            const letterNumber = i.letter_num;
            if (lettersData.has(letterNumber)) {
                lettersData.get(letterNumber).push(index + 1); // index + 1 for 1-based position
            } else {
                lettersData.set(letterNumber, [index + 1]);
            }
        });

        lettersData.forEach((positions, letterNumber) => {
            if (positions.length > 1) {
                duplicates.push(`\n Letter Number:${letterNumber} is found in position(s) ${positions.join(", ")}`);
            }
        });

        return duplicates;
    };


    const readExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0]; // Use the first sheet
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

            const headers = json[0];
            const rows = json.slice(1);

            const convertToYYYYMMDD = (input) => {
                try {
                    let date;

                    // Handle Excel serial dates
                    if (typeof input === "number") {
                        const excelEpoch = new Date(1900, 0, 1); // Excel epoch starts on Jan 1, 1900
                        const daysOffset = input - 1; // Subtract 1 because of leap year bug
                        date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
                    } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
                        // Format: YYYY.MM.DD
                        const [year, month, day] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
                        // Format: DD.MM.YYYY
                        const [day, month, year] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else {
                        // Default parsing for other formats
                        date = new Date(input);
                    }

                    if (isNaN(date.getTime())) {
                        throw new Error('Invalid date format');
                    }

                    // Format the date as YYYY-MM-DD
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                    const day = String(date.getDate()).padStart(2, '0');

                    return `${year}-${month}-${day}`;
                } catch (error) {
                    return null; // Return null for invalid dates
                }
            };
            // Create a formatted JSON object based on headers and row values
            const formattedJson = rows.map((row) => {
                const obj = {};
                headers.forEach((header, index) => {
                    if (["letter_date"].includes(header) && row[index] && typeof row[index] === "number") {
                        obj[header] = convertToYYYYMMDD(row[index]); // Convert date
                    } else {
                        obj[header] = row[index] !== undefined ? row[index] : null;
                    }
                });

                // If project_id exists, inject it into each row
                if (site_prcode) {
                    obj["project"] = site_prcode;
                }

                if (letterBy) {
                    obj["workperformedby"] = letterBy;
                }
                if (letterBy === "contractor") {
                    if (contractor_name) {
                        obj["contractor"] = contractor_name;
                    }
                }

                return obj;
            });

            const duplicates = checkForDuplicates(formattedJson);

            if (duplicates.length > 0) {
                toast.error(
                    `Duplicate Letter Numbers found:\n${duplicates.join("\n")}`,
                    {
                        autoClose: 5000, // Close toast after 5 seconds
                    }
                );
            }


            setExcelJson(formattedJson);
        };
        reader.readAsArrayBuffer(file);
    };








    const handleUpload = async () => {

        if (excelJson) {

            const duplicates = checkForDuplicates(excelJson);

            if (duplicates.length > 0) {
                toast.error(`Duplicate Data found! Policy Number ${duplicates.join(", ")}`, {
                    autoClose: 5000,
                });
            }

            const loadingToastId = toast.loading("Uploading: Please wait...");

            try {
                const res = await axios.post(`${BASE_URL}/siteproject/letterbulkuploadadd/`, excelJson);
                if (res.status === 200) {
                    await getLetters();
                    handleClose();
                    toast.success("Letters Data Added Successfully");
                    toast.dismiss(loadingToastId);
                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                toast.dismiss(loadingToastId);
            }
        } else {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
        }
    };






    return (
        <>


            <button
                className="clearbutton"
                onClick={handleShow}
            >
                <span className="transition"></span>
                <span className="gradient"></span>
                <span className="label">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                        <g fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                            <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                        </g>
                    </svg>
                </span>
            </button>

            <Modal show={show} dialogClassName="ourcompany-model">

                <Modal.Body>
                    <div className="flex-row align-center">

                        <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Upload Bulk Letter Data in format :</Modal.Title> </h1>


                        <button onClick={handleDownload} className="model-button-download model-button font-weight500">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Format
                        </button>

                    </div>
                    <div className="table-css-white-background" style={{ display: "none" }}>
                        <table ref={bulktableRef} className="nested-table-lightblue">
                            <thead>
                                <tr className="custom-table-head-tr">
                                    {site_prcode ? "" :
                                        <th className="align-left">project</th>
                                    }
                                    <th className="align-center">letter_num</th>
                                    <th className="align-center">reply_by</th>
                                    <th className="align-center">subject</th>
                                    <th className="align-center">letter_date</th>
                                    <th className="align-center">status</th>
                                    {letterBy ? "" :
                                        <th className="align-center">workperformedby</th>
                                    }
                                    <th className="align-center">lettertype</th>
                                    <th className="align-center">letterExchange</th>
                                    <th className="align-center">letterdepartment</th>
                                    <th className="align-center">letter_from</th>
                                    <th className="align-center">letter_to</th>
                                    {contractor_name ? "" :
                                        <th className="align-center">contractor</th>
                                    }

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    {site_prcode ? "" :
                                        <th className="align-left">-</th>
                                    }
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    {letterBy ? "" :
                                        <th className="align-center">-</th>
                                    }
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    {contractor_name ? "" :
                                        <th className="align-center">-</th>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="table-css-white-background scroll-container">
                        <div className="table-container scrollbar" style={{ width: "100%" }}>
                            <table className="nested-table-lightblue" style={{ margin: "0px" }}>
                                <thead className="table-heading">
                                    <tr className="modal-padding-heading custom-table-head-tr">
                                        {!site_prcode && <th className="table-heading-text">Project Code</th>}
                                        <th className="table-heading-text">Letter Number</th>
                                        <th className="table-heading-text">Reply By</th>
                                        <th className="table-heading-text">Subject</th>
                                        <th className="table-heading-text">Letter Date</th>
                                        <th className="table-heading-text">Status</th>
                                        {!letterBy && <th className="table-heading-text">Work Performed By</th>}
                                        <th className="table-heading-text">Letter Type</th>
                                        <th className="table-heading-text">Letter Exchange</th>
                                        <th className="table-heading-text">Letter Department</th>
                                        <th className="table-heading-text">Letter From</th>
                                        <th className="table-heading-text">Letter To</th>
                                        {!contractor_name && <th className="table-heading-text">Contractor</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {excelJson?.map((letter, index) => (
                                        <tr key={index} className="modal-padding-heading">
                                            {!site_prcode && <th className="table-heading-text">{letter.project}</th>}
                                            <th className="table-heading-text">{letter.letter_num}</th>
                                            <th className="table-heading-text">{letter.reply_by}</th>
                                            <th className="table-heading-text">{letter.subject}</th>
                                            <th className="table-heading-text">{letter.letter_date}</th>
                                            <th className="table-heading-text">{letter.status}</th>
                                            {!letterBy && <th className="table-heading-text">{letter.workperformedby}</th>}
                                            <th className="table-heading-text">{letter.lettertype}</th>
                                            <th className="table-heading-text">{letter.letterExchange}</th>
                                            <th className="table-heading-text">{letter.letterdepartment}</th>
                                            <th className="table-heading-text">{letter.letter_from}</th>
                                            <th className="table-heading-text">{letter.letter_to}</th>
                                            {!contractor_name && <th className="table-heading-text">{letter.contractor}</th>}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="flex-column field-cont-div">
                        <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
                            Upload File
                        </label>
                        <label
                            htmlFor="document_file"
                            className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                                }`}
                        >
                            <svg
                                className="pdf-input"
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                                    stroke="#707070"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </label>
                        <input
                            id="document_file"
                            name="document_file"
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileChange}
                            className="file-inputs align-center"
                            style={{ display: "none", position: "relative" }}
                        />
                        {fileName && <p className="file-name align-center">{fileName}</p>}
                        <br />
                        {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
                    </div>


                    <h4>References:</h4>
                    <div className="reference-container">
                        <div className="reference-section">
                            <p className="reference-title">General</p>
                            <ul className="arrow-list">
                                <li>Letter number should be unique.</li>
                                {letterBy ? "" : <>
                                    {!site_prcode &&
                                        (
                                            <>
                                                <li>Fill existing project only.</li>
                                                <li>In project field fill site prcode only.</li>
                                            </>
                                        )
                                    }
                                    <li>Insert existing contractor only.</li>
                                    <li>In contractor fill contractor name.</li>
                                    <li>Add contractor name only if the value of work performed by is "contractor"</li>
                                </>
                                }
                            </ul>
                        </div>
                        <div className="reference-section">
                            <p className="reference-title">For Letter Exchange use one of these:</p>
                            <ul className="arrow-list">
                                <li>send</li>
                                <li>receive</li>
                            </ul>
                        </div>
                        <div className="reference-section">
                            <p className="reference-title">For Reply By use one of these:</p>
                            <ul className="arrow-list">
                                <li>HO</li>
                                <li>SO</li>
                            </ul>
                        </div>
                        <div className="reference-section">
                            <p className="reference-title">For Letter Type use one of these:</p>
                            <ul className="arrow-list">
                                <li>show-cause</li>
                                <li>informative</li>
                                <li>eot</li>
                                <li>cos</li>
                                <li>billing</li>
                                <li>design</li>
                                <li>ncr</li>
                                <li>other</li>
                            </ul>
                        </div>
                        {letterBy ? "" :
                            <div className="reference-section">
                                <p className="reference-title">For Work Performed By use one of these:</p>
                                <ul className="arrow-list">
                                    <li>contractor</li>
                                    <li>consultant</li>
                                </ul>
                            </div>
                        }
                        <div className="date-section">
                            <p className="date-text">All Dates should be in DD-MM-YYYY format</p>
                        </div>
                    </div>

                    <div className="button-models">
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Upload
                        </button>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};
// const VehicleModelBulk = ({ id, getVehicle, site_prcode }) => {



//     const [show, setShow] = useState(false);
//     const [fileName, setFileName] = useState("");
//     const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
//     const [docErrors, setDocErrors] = useState({});
//     const [docInputState, setDocInputState] = useState({});

//     const bulktableRef = useRef(null);
//     const handleDownload = () => {
//         const table = bulktableRef.current;
//         const wb = XLSX.utils.table_to_book(table, { sheet: "Vehicle Details" });
//         const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

//         const blob = new Blob([s2ab(wbout)], {
//             type: "application/vnd.ms-excel",
//         });
//         const url = window.URL.createObjectURL(blob);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = "Vehicle Details Format.xls";
//         a.click();
//         window.URL.revokeObjectURL(url);
//     };

//     const s2ab = (s) => {
//         const buf = new ArrayBuffer(s.length);
//         const view = new Uint8Array(buf);
//         for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
//         return buf;
//     };

//     const handleClose = () => {
//         setFileName("")
//         setExcelJson(null)
//         setDocErrors({})
//         setShow(false)
//     };
//     const handleShow = () => setShow(true);

//     // Function to handle file change
//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             // Check for valid file type
//             const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
//             if (!validFileTypes.includes(file.type)) {
//                 setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
//                 setFileName("");
//                 return;
//             }

//             setFileName(file.name);
//             readExcel(file); // Convert the file to JSON
//         } else {
//             setFileName("");
//         }
//     };



//     const readExcel = (file) => {
//         const reader = new FileReader();
//         reader.onload = (e) => {
//             const data = new Uint8Array(e.target.result);
//             const workbook = XLSX.read(data, { type: "array" });

//             const sheetName = workbook.SheetNames[0]; // Use the first sheet
//             const worksheet = workbook.Sheets[sheetName];
//             const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

//             const headers = json[0];
//             const rows = json.slice(1);



//             // Create a formatted JSON object based on headers and row values
//             const formattedJson = rows.map((row) => {
//                 const obj = {};
//                 headers.forEach((header, index) => {

//                     obj[header] = row[index] !== undefined ? row[index] : null;
//                 });
//                 if (site_prcode) {
//                     obj["project"] = site_prcode;
//                 }
//                 return obj;
//             });


//             // Set the formatted JSON data to state
//             setExcelJson(formattedJson);
//         };
//         reader.readAsArrayBuffer(file);
//     };


//     // Function to handle the upload button click
//     const handleUpload = async () => {
//         if (excelJson) {
//             const loadingToastId = toast.loading("Uploading: Please wait...");

//             try {
//                 const res = await axios.post(`${BASE_URL}/siteproject/vehiclebulkupload/`, excelJson);
//                 if (res.status === 200) {
//                     await getVehicle();
//                     handleClose();
//                     toast.success("Vehicles Data Added Successfully");
//                     toast.dismiss(loadingToastId);
//                 }
//             } catch (err) {
//                 handleErrorToast(err);
//             } finally {
//                 toast.dismiss(loadingToastId);
//             }
//         } else {
//             setDocErrors({ document_file: "Please upload a valid Excel file." });
//         }
//     };







//     return (
//         <>

//             <button title="Upload" className="model-button   font-weight500   model-button-print eqqual-hieght" onClick={handleShow} style={{ margin: "2px" }}>
//                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
//                     <g fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
//                         <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
//                     </g>
//                 </svg>
//             </button>

//             <Modal show={show} dialogClassName="ourcompany-model">

//                 <Modal.Body>
//                     <div className="flex-row align-center">

//                         <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Upload Bulk Vehicle Data in format :</Modal.Title> </h1>


//                         <button onClick={handleDownload} className="model-button-download model-button font-weight500">
//                             <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
//                                 <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
//                                     <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
//                                 </g>
//                             </svg>
//                             {"  "} Format
//                         </button>

//                     </div>
//                     <div className="table-css-white-background" style={{ display: "none" }}>
//                         <table ref={bulktableRef} className="nested-table-lightblue">
//                             <thead>
//                                 <tr className="custom-table-head-tr">
//                                     {site_prcode ? "" :
//                                         <th className="align-left">project</th>
//                                     }
//                                     <th className="align-center">name</th>
//                                     <th className="align-center">vehicle_num</th>
//                                     <th className="align-center">fixed_km</th>
//                                     <th className="align-center">fixed_bill_amt</th>
//                                     <th className="align-center">extra_amt_above_fix_km</th>
//                                     <th className="align-center">bank_name</th>
//                                     <th className="align-center">account_holder_name</th>
//                                     <th className="align-center">account_num</th>
//                                     <th className="align-center">ifsc_code</th>
//                                     <th className="align-center">pan_card</th>
//                                     <th className="align-center">gst_num</th>
//                                     <th className="align-center">address</th>
//                                     <th className="align-center">mobile</th>
//                                     <th className="align-center">km_per_lit</th>
//                                     <th className="align-center">fuel_price</th>

//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr>
//                                     {site_prcode ? "" :
//                                         <th className="align-left">-</th>
//                                     }
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>

//                     <div className="table-css-white-background scroll-container">
//                         <div className="table-container scrollbar" style={{ width: "100%" }}>
//                             <table className="nested-table-lightblue" style={{ margin: "0px" }}>
//                                 <thead>
//                                     <tr className="custom-table-head-tr  modal-padding-heading">
//                                         {site_prcode ? "" :
//                                             <th className="table-heading-text">Project</th>
//                                         }
//                                         <th className="table-heading-text">Vehicle Name</th>
//                                         <th className="table-heading-text">Vehicle Num</th>
//                                         <th className="table-heading-text">Fixed Km</th>
//                                         <th className="table-heading-text">Fixed Bill Amt</th>
//                                         <th className="table-heading-text">Extra Amt Above Fix Km</th>
//                                         <th className="table-heading-text">Bank Name</th>
//                                         <th className="table-heading-text">Account Holder Name</th>
//                                         <th className="table-heading-text">Account Num</th>
//                                         <th className="table-heading-text">IFSC Code</th>
//                                         <th className="table-heading-text">PAN Card</th>
//                                         <th className="table-heading-text">GST Num</th>
//                                         <th className="table-heading-text">Address</th>
//                                         <th className="table-heading-text">Mobile</th>
//                                         <th className="table-heading-text">Km Per Lit</th>
//                                         <th className="table-heading-text">Fuel Price</th>

//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {excelJson?.map((vehicle, index) => (
//                                         <tr key={index} className="modal-padding-heading">
//                                             {site_prcode ? "" :
//                                                 <th className="table-body">{vehicle.project}</th>
//                                             }
//                                             <th className="table-body">{vehicle.name}</th>
//                                             <th className="table-body">{vehicle.vehicle_num}</th>
//                                             <th className="table-body">{vehicle.fixed_km}</th>
//                                             <th className="table-body">{vehicle.fixed_bill_amt}</th>
//                                             <th className="table-body">{vehicle.extra_amt_above_fix_km}</th>
//                                             <th className="table-body">{vehicle.bank_name}</th>
//                                             <th className="table-body">{vehicle.account_holder_name}</th>
//                                             <th className="table-body">{vehicle.account_num}</th>
//                                             <th className="table-body">{vehicle.ifsc_code}</th>
//                                             <th className="table-body">{vehicle.pan_card}</th>
//                                             <th className="table-body">{vehicle.gst_num}</th>
//                                             <th className="table-body">{vehicle.address}</th>
//                                             <th className="table-body">{vehicle.mobile}</th>
//                                             <th className="table-body">{vehicle.km_per_lit}</th>
//                                             <th className="table-body">{vehicle.fuel_price}</th>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>

//                     <div className="flex-column field-cont-div">
//                         <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
//                             Upload File
//                         </label>
//                         <label
//                             htmlFor="document_file"
//                             className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
//                                 }`}
//                         >
//                             <svg
//                                 className="pdf-input"
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 width="15"
//                                 height="15"
//                                 viewBox="0 0 20 20"
//                                 fill="none"
//                             >
//                                 <path
//                                     d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
//                                     stroke="#707070"
//                                     strokeWidth="2"
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                 />
//                             </svg>
//                         </label>
//                         <input
//                             id="document_file"
//                             name="document_file"
//                             type="file"
//                             accept=".xlsx, .xls"
//                             onChange={handleFileChange}
//                             className="file-inputs align-center"
//                             style={{ display: "none", position: "relative" }}
//                         />
//                         {fileName && <p className="file-name align-center">{fileName}</p>}
//                         <br />
//                         {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
//                     </div>
//                     <h4>References:</h4>
//                     <div className="reference-container">
//                         <div className="reference-section">
//                             {/* <p className="reference-title">General:</p> */}
//                             <ul className="arrow-list">
//                                 {site_prcode ? "" :
//                                     <li>In project field use valid site prcode.</li>
//                                 }

//                                 <li>In name field fill the name of the vehicle.</li>
//                             </ul>
//                         </div>

//                     </div>
//                     <div className="button-models">
//                         <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
//                             Cancel
//                         </button>
//                         <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
//                             <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
//                                 <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
//                                     <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
//                                 </g>
//                             </svg>
//                             {"  "} Upload
//                         </button>
//                     </div>
//                     <ToastContainer
//                         position="top-center"
//                         autoClose={1000}
//                         hideProgressBar={false}
//                         newestOnTop={true}
//                         closeOnClick
//                         rtl={false}
//                         pauseOnFocusLoss
//                         draggable
//                         pauseOnHover
//                     />
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// };

const VehicleModelBulk = ({ id, getVehicle, site_prcode }) => {

    const [show, setShow] = useState(false);
    const [fileName, setFileName] = useState("");
    const [fileSize, setFileSize] = useState("");
    const [excelJson, setExcelJson] = useState(null);
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});
    const [isDragging, setIsDragging] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const fileInputRef = useRef(null);

    const formatFileSize = (bytes) => {
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    };

    const handleDownload = () => {
        const headers = [site_prcode ? null : "project", "name", "vehicle_num", "fixed_km", "fixed_bill_amt", "extra_amt_above_fix_km", "bank_name", "account_holder_name", "account_num", "ifsc_code", "pan_card", "gst_num", "address", "mobile", "km_per_lit", "fuel_price"].filter(Boolean);

        const data = [
            headers,
            [],
            ["REFERENCES:"],
            [],
            ["GENERAL INSTRUCTIONS:"],
            ...(site_prcode ? [] : [["   • In Project field use a valid site prcode."]]),
            ["   • Vehicle number should be unique."],
            ["   • Fill name with the name of the vehicle."],
            ["   • Mobile numbers should have 10 digits, no +91."],
            ["   • PAN card should have 10 digits with no spaces."],
        ];

        const ws = XLSX.utils.aoa_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Vehicle Format");

        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Vehicle_Upload_Format.xlsx";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleClose = () => {
        setFileName("");
        setFileSize("");
        setExcelJson(null);
        setDocErrors({});
        setDocInputState({});
        setShow(false);
    };

    const handleShow = () => setShow(true);

    const handleRemoveFile = () => {
        setFileName("");
        setFileSize("");
        setExcelJson(null);
        setDocErrors({});
        setDocInputState({});
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const processFile = (file) => {
        if (!file) return;
        const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
        if (!validFileTypes.includes(file.type)) {
            setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
            setFileName("");
            setFileSize("");
            return;
        }

        setFileName(file.name);
        setFileSize(formatFileSize(file.size));
        setDocErrors({});
        setDocInputState({ document_file: "green" });
        readExcel(file);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        processFile(file);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const file = e.dataTransfer.files[0];
        processFile(file);
    };

    const readExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const headerIndex = jsonData.findIndex(row => row.includes("name") && row.includes("vehicle_num"));

            if (headerIndex === -1) {
                toast.error("Header row not found in Excel");
                return;
            }

            const slicedData = jsonData.slice(headerIndex);

            const filteredRows = slicedData.filter(row => {
                const firstCell = row[0]?.toString().trim() || "";
                return (
                    row.length > 0 &&
                    firstCell !== "REFERENCES:" &&
                    !firstCell.includes("GENERAL INSTRUCTIONS") &&
                    !/^[•\-*]/.test(firstCell)
                );
            });

            const [headers, ...dataRows] = filteredRows;
            const finalData = dataRows.map(row =>
                Object.fromEntries(headers.map((key, i) => [key, row[i] ?? ""]))
            );

            const formattedJson = finalData.map((row) => {
                const obj = {};
                headers.forEach((header) => {
                    obj[header] = row[header] !== undefined ? row[header] : null;
                });

                if (site_prcode) {
                    obj["project"] = site_prcode;
                }

                return obj;
            });

            formattedJson.forEach((item, index) => {
                if (typeof item !== 'object' || item === null) {
                    toast.error(`Row ${index + 2} in Excel is invalid.`);
                }
            });

            setExcelJson(formattedJson);
        };

        reader.readAsArrayBuffer(file);
    };

    const handleUpload = async () => {
        if (excelJson) {
            setShowProgressModal(true);
            setUploadProgress(0);

            const loadingToastId = toast.loading("Uploading: Please wait...");

            let progress = 0;
            const interval = setInterval(() => {
                progress += 10;
                if (progress >= 100) {
                    progress = 100;
                    clearInterval(interval);
                }
                setUploadProgress(progress);
            }, 100);

            try {
                const res = await axios.post(`${BASE_URL}/siteproject/vehiclebulkupload/`, excelJson);
                if (res.status === 200) {
                    await getVehicle();
                    toast.dismiss(loadingToastId);
                    toast.success("Vehicles Data Added Successfully");
                    handleClose();
                }
            } catch (err) {
                clearInterval(interval);
                setUploadProgress(0);
                handleError(err, loadingToastId);
            } finally {
                clearInterval(interval);
                setTimeout(() => {
                    setShowProgressModal(false);
                }, 1500);
                toast.dismiss(loadingToastId);
            }
        } else {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
        }
    };

    const handleError = (err, loadingToastId) => {
        toast.dismiss(loadingToastId);
        handleErrorToast(err);
    };

    return (
        <>
            <style>{`
                .ub-upload-zone {
                    border: 2px dashed #c7cdd6;
                    border-radius: 14px;
                    background: #fafbfd;
                    padding: 32px 20px;
                    text-align: center;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    position: relative;
                }
                .ub-upload-zone:hover {
                    border-color: #6366f1;
                    background: #f5f5ff;
                }
                .ub-upload-zone.dragging {
                    border-color: #6366f1;
                    background: #eef0ff;
                    transform: scale(1.01);
                }
                .ub-upload-zone.has-error {
                    border-color: #e11d48;
                    background: #fff1f2;
                }
                .ub-upload-icon-circle {
                    width: 56px;
                    height: 56px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #6366f1, #8b5cf6);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 14px;
                    color: white;
                    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.3);
                }
                .ub-upload-title {
                    font-size: 15px;
                    font-weight: 600;
                    color: #1f2937;
                    margin: 0 0 4px;
                }
                .ub-upload-subtitle {
                    font-size: 13px;
                    color: #6b7280;
                    margin: 0;
                }
                .ub-upload-browse {
                    color: #6366f1;
                    font-weight: 600;
                    text-decoration: underline;
                }
                .ub-file-card {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    background: #f0fdf4;
                    border: 1px solid #bbf7d0;
                    border-radius: 12px;
                    padding: 14px 16px;
                    margin-top: 12px;
                    animation: ub-fade-in 0.25s ease;
                }
                .ub-file-icon {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    background: #16a34a;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    flex-shrink: 0;
                }
                .ub-file-info {
                    flex: 1;
                    min-width: 0;
                }
                .ub-file-name {
                    font-size: 14px;
                    font-weight: 600;
                    color: #1f2937;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .ub-file-size {
                    font-size: 12px;
                    color: #6b7280;
                }
                .ub-file-remove {
                    background: none;
                    border: none;
                    cursor: pointer;
                    color: #9ca3af;
                    padding: 6px;
                    border-radius: 8px;
                    display: flex;
                    transition: all 0.15s ease;
                    flex-shrink: 0;
                }
                .ub-file-remove:hover {
                    background: #fee2e2;
                    color: #dc2626;
                }
                @keyframes ub-fade-in {
                    from { opacity: 0; transform: translateY(-4px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .ub-preview-wrap {
                    border: 1px solid #e5e7eb;
                    border-radius: 14px;
                    overflow: hidden;
                    margin-top: 8px;
                }
                .ub-preview-scroll {
                    overflow-x: auto;
                    max-height: 340px;
                    overflow-y: auto;
                }
                .ub-preview-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 13px;
                    white-space: nowrap;
                }
                .ub-preview-table thead th {
                    position: sticky;
                    top: 0;
                    background: #f8fafc;
                    color: #475569;
                    font-weight: 600;
                    text-align: left;
                    padding: 10px 14px;
                    border-bottom: 2px solid #e2e8f0;
                    z-index: 1;
                }
                .ub-preview-table tbody td {
                    padding: 9px 14px;
                    color: #334155;
                    border-bottom: 1px solid #f1f5f9;
                }
                .ub-preview-table tbody tr:nth-child(even) {
                    background: #fbfcfe;
                }
                .ub-preview-table tbody tr:hover {
                    background: #f0f4ff;
                }
                .ub-preview-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 10px 4px;
                }
                .ub-preview-badge {
                    background: #eef2ff;
                    color: #4338ca;
                    font-size: 12px;
                    font-weight: 600;
                    padding: 4px 10px;
                    border-radius: 999px;
                }
                .ub-download-row {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background: #f8fafc;
                    border: 1px solid #e5e7eb;
                    border-radius: 12px;
                    padding: 14px 16px;
                    margin-bottom: 18px;
                    gap: 12px;
                }
                .ub-download-row p {
                    margin: 0;
                    font-size: 13.5px;
                    color: #475569;
                }
            `}</style>

            <button title="Upload" className="btn-animated" onClick={handleShow} style={{ margin: "2px" }}>
                <UploadCloud size={16} style={{ marginRight: "6px" }} /> Bulk Upload
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Upload" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal model-width80vw" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Upload size={24} />
                            </div>
                            <div>
                                <Modal.Title>Upload Bulk Vehicle Data</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Upload multiple vehicles at once using the Excel format</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body">

                        <div className="ub-download-row">
                            <p><FileText size={14} style={{ marginRight: '6px', verticalAlign: 'middle' }} />
                                Download the Excel template, fill in vehicle details, then upload it below.
                            </p>
                            <button onClick={handleDownload} className="btn-primaryy" type="button" style={{ flexShrink: 0 }}>
                                <Download size={16} />
                                <span>Format</span>
                            </button>
                        </div>

                        <div className="section-title">
                            <Upload size={18} />
                            <h4>Upload File</h4>
                        </div>

                        <div
                            className={`ub-upload-zone ${isDragging ? 'dragging' : ''} ${docErrors.document_file ? 'has-error' : ''}`}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            onClick={() => fileInputRef.current?.click()}
                        >
                            <div className="ub-upload-icon-circle">
                                <Upload size={24} />
                            </div>
                            <p className="ub-upload-title">
                                Drag & drop your Excel file here
                            </p>
                            <p className="ub-upload-subtitle">
                                or <span className="ub-upload-browse">browse</span> to choose a file &nbsp;·&nbsp; .xlsx or .xls
                            </p>
                            <input
                                ref={fileInputRef}
                                id="document_file"
                                name="document_file"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                            />
                        </div>

                        {docErrors.document_file && (
                            <div className="tab-error-message" style={{ marginTop: '10px' }}>
                                <AlertCircle size={14} />
                                <span>{docErrors.document_file}</span>
                            </div>
                        )}

                        {fileName && !docErrors.document_file && (
                            <div className="ub-file-card">
                                <div className="ub-file-icon">
                                    <FileText size={20} />
                                </div>
                                <div className="ub-file-info">
                                    <div className="ub-file-name">{fileName}</div>
                                    <div className="ub-file-size">{fileSize}{excelJson ? ` · ${excelJson.length} records found` : ''}</div>
                                </div>
                                <button type="button" className="ub-file-remove" onClick={handleRemoveFile} title="Remove file">
                                    <X size={18} />
                                </button>
                            </div>
                        )}

                        {excelJson && excelJson.length > 0 && (
                            <>
                                <div className="ub-preview-header">
                                    <div className="section-title" style={{ marginBottom: 0 }}>
                                        <Car size={18} />
                                        <h4 style={{ margin: 0 }}>Preview</h4>
                                    </div>
                                    <span className="ub-preview-badge">{excelJson.length} vehicles</span>
                                </div>

                                <div className="ub-preview-wrap">
                                    <div className="ub-preview-scroll  table-box scroll-container-table">
                                        <table className="ub-preview-table">
                                            <thead className="table-heading">
                                                <tr>
                                                    {site_prcode ? null : <th>Project</th>}
                                                    <th>Name</th>
                                                    <th>Vehicle Num</th>
                                                    <th>Fixed Km</th>
                                                    <th>Fixed Bill Amt</th>
                                                    <th>Extra Amt Above Fix Km</th>
                                                    <th>Bank Name</th>
                                                    <th>Account Holder Name</th>
                                                    <th>Account Num</th>
                                                    <th>IFSC Code</th>
                                                    <th>PAN Card</th>
                                                    <th>GST Num</th>
                                                    <th>Address</th>
                                                    <th>Mobile</th>
                                                    <th>Km Per Lit</th>
                                                    <th>Fuel Price</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {excelJson.map((vehicle, index) => (
                                                    <tr key={index}>
                                                        {site_prcode ? null : <td>{vehicle.project}</td>}
                                                        <td>{vehicle.name}</td>
                                                        <td>{vehicle.vehicle_num}</td>
                                                        <td>{vehicle.fixed_km}</td>
                                                        <td>{vehicle.fixed_bill_amt}</td>
                                                        <td>{vehicle.extra_amt_above_fix_km}</td>
                                                        <td>{vehicle.bank_name}</td>
                                                        <td>{vehicle.account_holder_name}</td>
                                                        <td>{vehicle.account_num}</td>
                                                        <td>{vehicle.ifsc_code}</td>
                                                        <td>{vehicle.pan_card}</td>
                                                        <td>{vehicle.gst_num}</td>
                                                        <td>{vehicle.address}</td>
                                                        <td>{vehicle.mobile}</td>
                                                        <td>{vehicle.km_per_lit}</td>
                                                        <td>{vehicle.fuel_price}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="form-actions">
                            <button type="button" className="btn-secondaryy" onClick={handleClose}>
                                Cancel
                            </button>
                            <button type="button" className="btn-primaryy" onClick={handleUpload} disabled={!excelJson}>
                                <Upload size={18} />
                                <span>Upload</span>
                            </button>
                        </div>

                        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

const UploadOfficeRentBulk = ({ id, getOfficeRent }) => {

    const [show, setShow] = useState(false);
    const [fileName, setFileName] = useState("");
    const [fileSize, setFileSize] = useState("");
    const [excelJson, setExcelJson] = useState(null);
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});
    const [isDragging, setIsDragging] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const fileInputRef = useRef(null);

    const formatFileSize = (bytes) => {
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    };

    const handleDownload = () => {
        const headers = ["project", "rent_amt", "agreement_duration", "agreement_date", "owner_name", "bank_name", "account_holder_name", "account_num", "ifsc_code", "pan_card", "gst_num", "address", "mobile"];

        const data = [
            headers,
            [],
            ["REFERENCES:"],
            [],
            ["GENERAL INSTRUCTIONS:"],
            ["   • In project field fill site prcode only."],
            ["   • Fill existing project only."],
            ["   • Agreement Duration should be number of months."],
            ["   • All Dates should be in DD-MM-YYYY format."],
        ];

        const ws = XLSX.utils.aoa_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Office Rent Format");

        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Office_Rent_Upload_Format.xlsx";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleClose = () => {
        setFileName("");
        setFileSize("");
        setExcelJson(null);
        setDocErrors({});
        setDocInputState({});
        setShow(false);
    };

    const handleShow = () => setShow(true);

    const handleRemoveFile = () => {
        setFileName("");
        setFileSize("");
        setExcelJson(null);
        setDocErrors({});
        setDocInputState({});
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const processFile = (file) => {
        if (!file) return;
        const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
        if (!validFileTypes.includes(file.type)) {
            setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
            setFileName("");
            setFileSize("");
            return;
        }

        setFileName(file.name);
        setFileSize(formatFileSize(file.size));
        setDocErrors({});
        setDocInputState({ document_file: "green" });
        readExcel(file);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        processFile(file);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const file = e.dataTransfer.files[0];
        processFile(file);
    };

    const readExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const headerIndex = jsonData.findIndex(row => row.includes("project") && row.includes("rent_amt"));

            if (headerIndex === -1) {
                toast.error("Header row not found in Excel");
                return;
            }

            const slicedData = jsonData.slice(headerIndex);

            const filteredRows = slicedData.filter(row => {
                const firstCell = row[0]?.toString().trim() || "";
                return (
                    row.length > 0 &&
                    firstCell !== "REFERENCES:" &&
                    !firstCell.includes("GENERAL INSTRUCTIONS") &&
                    !/^[•\-*]/.test(firstCell)
                );
            });

            const [headers, ...rows] = filteredRows;

            const convertToYYYYMMDD = (input) => {
                try {
                    let date;

                    if (typeof input === "number") {
                        const excelEpoch = new Date(1900, 0, 1);
                        const daysOffset = input - 1;
                        date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
                    } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
                        const [year, month, day] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
                        const [day, month, year] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else {
                        date = new Date(input);
                    }

                    if (isNaN(date.getTime())) {
                        throw new Error('Invalid date format');
                    }

                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');

                    return `${year}-${month}-${day}`;
                } catch (error) {
                    return null;
                }
            };

            const formattedJson = rows.map((row) => {
                const obj = {};
                headers.forEach((header, index) => {
                    if (["agreement_date"].includes(header) && row[index] && typeof row[index] === "number") {
                        obj[header] = convertToYYYYMMDD(row[index]);
                    } else {
                        obj[header] = row[index] !== undefined ? row[index] : null;
                    }
                });
                return obj;
            });

            setExcelJson(formattedJson);
        };
        reader.readAsArrayBuffer(file);
    };

    const handleUpload = async () => {
        if (excelJson) {
            setShowProgressModal(true);
            setUploadProgress(0);

            const loadingToastId = toast.loading("Uploading: Please wait...");

            let progress = 0;
            const interval = setInterval(() => {
                progress += 10;
                if (progress >= 100) {
                    progress = 100;
                    clearInterval(interval);
                }
                setUploadProgress(progress);
            }, 100);

            try {
                const res = await axios.post(`${BASE_URL}/siteproject/officerentbulkapi/`, excelJson);
                if (res.status === 200) {
                    await getOfficeRent();
                    toast.dismiss(loadingToastId);
                    toast.success("Office Rent Data Added Successfully");
                    handleClose();
                }
            } catch (err) {
                clearInterval(interval);
                setUploadProgress(0);
                handleError(err, loadingToastId);
            } finally {
                clearInterval(interval);
                setTimeout(() => {
                    setShowProgressModal(false);
                }, 1500);
                toast.dismiss(loadingToastId);
            }
        } else {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
        }
    };

    const handleError = (err, loadingToastId) => {
        toast.dismiss(loadingToastId);
        handleErrorToast(err);
    };

    return (
        <>
            <style>{`
                .ub-upload-zone {
                    border: 2px dashed #c7cdd6;
                    border-radius: 14px;
                    background: #fafbfd;
                    padding: 32px 20px;
                    text-align: center;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    position: relative;
                }
                .ub-upload-zone:hover {
                    border-color: #6366f1;
                    background: #f5f5ff;
                }
                .ub-upload-zone.dragging {
                    border-color: #6366f1;
                    background: #eef0ff;
                    transform: scale(1.01);
                }
                .ub-upload-zone.has-error {
                    border-color: #e11d48;
                    background: #fff1f2;
                }
                .ub-upload-icon-circle {
                    width: 56px;
                    height: 56px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #6366f1, #8b5cf6);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 14px;
                    color: white;
                    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.3);
                }
                .ub-upload-title {
                    font-size: 15px;
                    font-weight: 600;
                    color: #1f2937;
                    margin: 0 0 4px;
                }
                .ub-upload-subtitle {
                    font-size: 13px;
                    color: #6b7280;
                    margin: 0;
                }
                .ub-upload-browse {
                    color: #6366f1;
                    font-weight: 600;
                    text-decoration: underline;
                }
                .ub-file-card {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    background: #f0fdf4;
                    border: 1px solid #bbf7d0;
                    border-radius: 12px;
                    padding: 14px 16px;
                    margin-top: 12px;
                    animation: ub-fade-in 0.25s ease;
                }
                .ub-file-icon {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    background: #16a34a;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    flex-shrink: 0;
                }
                .ub-file-info {
                    flex: 1;
                    min-width: 0;
                }
                .ub-file-name {
                    font-size: 14px;
                    font-weight: 600;
                    color: #1f2937;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .ub-file-size {
                    font-size: 12px;
                    color: #6b7280;
                }
                .ub-file-remove {
                    background: none;
                    border: none;
                    cursor: pointer;
                    color: #9ca3af;
                    padding: 6px;
                    border-radius: 8px;
                    display: flex;
                    transition: all 0.15s ease;
                    flex-shrink: 0;
                }
                .ub-file-remove:hover {
                    background: #fee2e2;
                    color: #dc2626;
                }
                @keyframes ub-fade-in {
                    from { opacity: 0; transform: translateY(-4px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .ub-preview-wrap {
                    border: 1px solid #e5e7eb;
                    border-radius: 14px;
                    overflow: hidden;
                    margin-top: 8px;
                }
                .ub-preview-scroll {
                    overflow-x: auto;
                    max-height: 340px;
                    overflow-y: auto;
                }
                .ub-preview-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 13px;
                    white-space: nowrap;
                }
                .ub-preview-table thead th {
                    position: sticky;
                    top: 0;
                    background: #f8fafc;
                    color: #475569;
                    font-weight: 600;
                    text-align: left;
                    padding: 10px 14px;
                    border-bottom: 2px solid #e2e8f0;
                    z-index: 1;
                }
                .ub-preview-table tbody td {
                    padding: 9px 14px;
                    color: #334155;
                    border-bottom: 1px solid #f1f5f9;
                }
                .ub-preview-table tbody tr:nth-child(even) {
                    background: #fbfcfe;
                }
                .ub-preview-table tbody tr:hover {
                    background: #f0f4ff;
                }
                .ub-preview-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 10px 4px;
                }
                .ub-preview-badge {
                    background: #eef2ff;
                    color: #4338ca;
                    font-size: 12px;
                    font-weight: 600;
                    padding: 4px 10px;
                    border-radius: 999px;
                }
                .ub-download-row {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background: #f8fafc;
                    border: 1px solid #e5e7eb;
                    border-radius: 12px;
                    padding: 14px 16px;
                    margin-bottom: 18px;
                    gap: 12px;
                }
                .ub-download-row p {
                    margin: 0;
                    font-size: 13.5px;
                    color: #475569;
                }
            `}</style>

            <button title="Upload" className="btn-animated" onClick={handleShow} style={{ margin: "2px" }}>
                <UploadCloud size={16} style={{ marginRight: "6px" }} /> Bulk Upload
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Upload" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal model-width80vw" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Upload size={24} />
                            </div>
                            <div>
                                <Modal.Title>Upload Bulk Office Rent Data</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Upload multiple office rent records at once using the Excel format</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body">

                        <div className="ub-download-row">
                            <p><FileText size={14} style={{ marginRight: '6px', verticalAlign: 'middle' }} />
                                Download the Excel template, fill in office rent details, then upload it below.
                            </p>
                            <button onClick={handleDownload} className="btn-primaryy" type="button" style={{ flexShrink: 0 }}>
                                <Download size={16} />
                                <span>Format</span>
                            </button>
                        </div>

                        <div className="section-title">
                            <Upload size={18} />
                            <h4>Upload File</h4>
                        </div>

                        <div
                            className={`ub-upload-zone ${isDragging ? 'dragging' : ''} ${docErrors.document_file ? 'has-error' : ''}`}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            onClick={() => fileInputRef.current?.click()}
                        >
                            <div className="ub-upload-icon-circle">
                                <Upload size={24} />
                            </div>
                            <p className="ub-upload-title">
                                Drag & drop your Excel file here
                            </p>
                            <p className="ub-upload-subtitle">
                                or <span className="ub-upload-browse">browse</span> to choose a file &nbsp;·&nbsp; .xlsx or .xls
                            </p>
                            <input
                                ref={fileInputRef}
                                id="document_file"
                                name="document_file"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                            />
                        </div>

                        {docErrors.document_file && (
                            <div className="tab-error-message" style={{ marginTop: '10px' }}>
                                <AlertCircle size={14} />
                                <span>{docErrors.document_file}</span>
                            </div>
                        )}

                        {fileName && !docErrors.document_file && (
                            <div className="ub-file-card">
                                <div className="ub-file-icon">
                                    <FileText size={20} />
                                </div>
                                <div className="ub-file-info">
                                    <div className="ub-file-name">{fileName}</div>
                                    <div className="ub-file-size">{fileSize}{excelJson ? ` · ${excelJson.length} records found` : ''}</div>
                                </div>
                                <button type="button" className="ub-file-remove" onClick={handleRemoveFile} title="Remove file">
                                    <X size={18} />
                                </button>
                            </div>
                        )}

                        {excelJson && excelJson.length > 0 && (
                            <>
                                <div className="ub-preview-header">
                                    <div className="section-title" style={{ marginBottom: 0 }}>
                                        <Building2 size={18} />
                                        <h4 style={{ margin: 0 }}>Preview</h4>
                                    </div>
                                    <span className="ub-preview-badge">{excelJson.length} records</span>
                                </div>

                                <div className="ub-preview-wrap">
                                    <div className="ub-preview-scroll  table-box scroll-container-table">
                                        <table className="ub-preview-table">
                                            <thead className="table-heading">
                                                <tr>
                                                    <th>Project</th>
                                                    <th>Rent Amt</th>
                                                    <th>Agreement Duration</th>
                                                    <th>Agreement Date</th>
                                                    <th>Owner Name</th>
                                                    <th>Bank Name</th>
                                                    <th>Account Holder Name</th>
                                                    <th>Account Num</th>
                                                    <th>IFSC Code</th>
                                                    <th>PAN Card</th>
                                                    <th>GST Num</th>
                                                    <th>Address</th>
                                                    <th>Mobile</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {excelJson.map((officerent, index) => (
                                                    <tr key={index}>
                                                        <td>{officerent.project}</td>
                                                        <td>{officerent.rent_amt}</td>
                                                        <td>{officerent.agreement_duration}</td>
                                                        <td>{officerent.agreement_date}</td>
                                                        <td>{officerent.owner_name}</td>
                                                        <td>{officerent.bank_name}</td>
                                                        <td>{officerent.account_holder_name}</td>
                                                        <td>{officerent.account_num}</td>
                                                        <td>{officerent.ifsc_code}</td>
                                                        <td>{officerent.pan_card}</td>
                                                        <td>{officerent.gst_num}</td>
                                                        <td>{officerent.address}</td>
                                                        <td>{officerent.mobile}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="form-actions">
                            <button type="button" className="btn-secondaryy" onClick={handleClose}>
                                Cancel
                            </button>
                            <button type="button" className="btn-primaryy" onClick={handleUpload} disabled={!excelJson}>
                                <Upload size={18} />
                                <span>Upload</span>
                            </button>
                        </div>

                        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

const UploadDesignation = ({ getDesignation, divisionList }) => {
    const [show, setShow] = useState(false);
    const [fileName, setFileName] = useState("");
    const [excelJson, setExcelJson] = useState(null);
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});
    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const bulktableRef = useRef(null);

    const handleDownload = () => {
        const table = bulktableRef.current;
        const wb = XLSX.utils.table_to_book(table, { sheet: "Designation Details" });
        const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });
        const blob = new Blob([s2ab(wbout)], { type: "application/vnd.ms-excel" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Designation Details Format.xls";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleClose = () => {
        setFileName("");
        setExcelJson(null);
        setDocErrors({});
        setShow(false);
    };
    const handleShow = () => setShow(true);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
            if (!validFileTypes.includes(file.type)) {
                setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
                setFileName("");
                return;
            }
            setFileName(file.name);
            setDocInputState({ document_file: "green" });
            setDocErrors({});
            readExcel(file);
        } else {
            setFileName("");
        }
    };

    const checkForDuplicates = (data) => {
        const designations = new Map();
        const duplicates = [];
        data.forEach((i, index) => {
            const designation = i.title;
            if (designations.has(designation)) {
                designations.get(designation).push(index + 1);
            } else {
                designations.set(designation, [index + 1]);
            }
        });
        designations.forEach((positions, designation) => {
            if (positions.length > 1) {
                duplicates.push(`\n Designation :${designation} is found in position(s) ${positions.join(", ")}`);
            }
        });
        return duplicates;
    };

    const readExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

            const headers = json[0];
            const rows = json.slice(1);

            const formattedJson = rows
                .map((row) => {
                    const obj = {};
                    headers.forEach((header, index) => {
                        obj[header] = row[index] !== undefined && row[index] !== null
                            ? String(row[index]).trim()
                            : null;
                    });
                    return obj;
                })
                .filter((row) => Object.values(row).some((value) => value !== null));

            // Validate required fields: sub_company, division, professional_type
            const invalidRows = formattedJson.filter(
                (row) => row['sub_company'] === null || row['division'] === null || row['professional_type'] === null
            );
            if (invalidRows.length > 0) {
                toast.error(
                    "Upload failed: Some rows are missing 'sub_company', 'division', or 'professional_type'. Please fix the data and try again.",
                    { autoClose: 3000 }
                );
                return;
            }

            const duplicates = checkForDuplicates(formattedJson);
            if (duplicates.length > 0) {
                toast.error(`Duplicate Designations found:\n${duplicates.join("\n")}`, { autoClose: 5000 });
            }

            setExcelJson(formattedJson);
        };
        reader.readAsArrayBuffer(file);
    };

    const handleUpload = async () => {
        if (!excelJson) {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
            return;
        }

        const duplicates = checkForDuplicates(excelJson);
        if (duplicates.length > 0) {
            toast.error(`Duplicate Data found:\n ${duplicates.join(", ")}`, { autoClose: 5000 });
        }

        setShowProgressModal(true);
        setLoading(true);
        setUploadProgress(0);

        const loadingToastId = toast.loading("Uploading: Please wait...");

        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            if (progress >= 100) {
                progress = 100;
                clearInterval(interval);
            }
            setUploadProgress(progress);
        }, 100);

        try {
            const res = await axios.post(`${BASE_URL}/siteproject/designationuploadbulk/`, excelJson);
            if (res.status === 200) {
                await getDesignation();
                toast.dismiss(loadingToastId);
                toast.success("Designation Data Added Successfully");
                handleClose();
            }
        } catch (err) {
            clearInterval(interval);
            setUploadProgress(0);
            handleErrorToast(err);
        } finally {
            clearInterval(interval);
            setTimeout(() => {
                setShowProgressModal(false);
            }, 1500);
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button title="Upload" className="model-button font-weight500 model-button-print" onClick={handleShow} style={{ margin: "2px", background: "black" }}>
                <Upload size={18} />
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Upload" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="lg">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <FileSpreadsheet size={22} />
                            </div>
                            <div>
                                <Modal.Title>Bulk Upload Site Designations</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>
                                    Upload multiple designations at once using Excel
                                </p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <ToastContainer position="top-center" autoClose={false} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

                    <Modal.Body className="modern-modal-body">
                        <div className="form-section">

                            {/* Format download */}
                            <div className="section-title" style={{ justifyContent: 'space-between', display: 'flex', alignItems: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <FileText size={18} />
                                    <h4>Required Format</h4>
                                </div>
                                <button onClick={handleDownload} className="btn-secondaryy" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                    <Download size={15} />
                                    Download Format
                                </button>
                            </div>

                            {/* Hidden table used only for XLSX export */}
                            <div style={{ display: "none" }}>
                                <table ref={bulktableRef}>
                                    <thead>
                                        <tr>
                                            <th>title</th>
                                            <th>professional_type</th>
                                            <th>division</th>
                                            <th>sub_company</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>-</th>
                                            <th>-</th>
                                            <th>-</th>
                                            <th>-</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Preview table */}
                            {excelJson && excelJson.length > 0 && (
                                <div className="table-wrapper-minimal table-box scroll-container-table" style={{ marginTop: '12px', marginBottom: '16px', maxHeight: '260px' }}>
                                    <table className="progress-table-minimal">
                                        <thead className="table-heading">
                                            <tr>
                                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                                <th className="col-period">Title</th>
                                                <th className="col-period">Professional Type</th>
                                                <th className="col-period">Division</th>
                                                <th className="col-period">Sub Company</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {excelJson.map((designation, index) => (
                                                <tr className="progress-row" key={index}>
                                                    <td className="col-sno text-start">{index + 1}.</td>
                                                    <td className="col-period">{designation.title || "-"}</td>
                                                    <td className="col-period">{designation.professional_type || "-"}</td>
                                                    <td className="col-period">{designation.division || "-"}</td>
                                                    <td className="col-period">{designation.sub_company || "-"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}

                            {/* File upload */}
                            <div className="form-field full-width" style={{ marginTop: '16px' }}>
                                <label><Upload size={14} /> Upload File</label>
                                <label
                                    htmlFor="document_file"
                                    className={`custom-file-upload-modern ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""}`}
                                >
                                    <FileUp size={18} />
                                    <span>{fileName || "Click to select .xlsx or .xls file"}</span>
                                </label>
                                <input
                                    id="document_file"
                                    name="document_file"
                                    type="file"
                                    accept=".xlsx, .xls"
                                    onChange={handleFileChange}
                                    style={{ display: "none" }}
                                />
                                {docErrors.document_file && <span className="error-message">{docErrors.document_file}</span>}
                            </div>

                            {/* References */}
                            <div className="expanded-content-attractive" style={{ marginTop: '16px', padding: '14px 16px', background: '#fafbff', borderRadius: '12px' }}>
                                <div className="expanded-content-title" style={{ marginBottom: '10px' }}>
                                    <Info size={13} />
                                    <span>References</span>
                                </div>
                                <ul style={{ margin: 0, paddingLeft: '18px', fontSize: '12px', color: '#475569', lineHeight: '1.8' }}>
                                    <li><strong>title</strong> — Site designation name (must be unique).</li>
                                    <li><strong>professional_type</strong> — must be one of: Key Professional, Sub Professional, Support Staff.</li>
                                    <li><strong>division</strong> — division name, must match an existing division exactly.</li>
                                    <li><strong>sub_company</strong> — sub company name associated with the division.</li>
                                </ul>
                            </div>

                            <div className="form-actions">
                                <div></div>
                                <div className="submit-buttons">
                                    <button className="btn-secondaryy" onClick={handleClose}>
                                        Cancel
                                    </button>
                                    <button className="btn-primaryy" onClick={handleUpload} disabled={loading}>
                                        {loading ? <Loader size={18} className="spinning" /> : <Upload size={18} />}
                                        <span>{loading ? 'Uploading...' : 'Upload'}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};


const UploadDepartment = ({ id, getdepartment }) => {



    const [show, setShow] = useState(false);
    const [fileName, setFileName] = useState("");
    const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});

    const bulktableRef = useRef(null);
    const handleDownload = () => {
        const table = bulktableRef.current;
        const wb = XLSX.utils.table_to_book(table, { sheet: "Department Details" });
        const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.ms-excel",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Department Details Format.xls";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleClose = () => {
        setFileName("")
        setExcelJson(null)
        setDocErrors({})
        setShow(false)
    };
    const handleShow = () => setShow(true);

    // Function to handle file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check for valid file type
            const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
            if (!validFileTypes.includes(file.type)) {
                setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
                setFileName("");
                return;
            }

            setFileName(file.name);
            readExcel(file); // Convert the file to JSON
        } else {
            setFileName("");
        }
    };

    const checkForDuplicates = (data) => {
        const title = new Map();
        const duplicates = [];

        // Track positions of each insurance number
        data.forEach((i, index) => {
            const department = i.title;
            if (title.has(department)) {
                // If the insurance number already exists, add the current position to its list
                title.get(department).push(index + 1); // index + 1 for 1-based position
            } else {
                // If it's the first time seeing this insurance number, initialize its position list
                title.set(department, [index + 1]);
            }
        });

        // Now, filter out only the numbers that appear more than once
        title.forEach((positions, department) => {
            if (positions.length > 1) {
                duplicates.push(`\n "${department}" Department is found in position(s) ${positions.join(", ")}`);
            }
        });

        return duplicates;
    };

    const readExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0]; // Use the first sheet
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

            const headers = json[0];
            const rows = json.slice(1);



            // Create a formatted JSON object based on headers and row values
            const formattedJson = rows.map((row) => {
                const obj = {};
                headers.forEach((header, index) => {

                    obj[header] = row[index] !== undefined ? row[index] : null;
                });
                return obj;
            });
            const duplicates = checkForDuplicates(formattedJson);

            if (duplicates.length > 0) {
                // Toast notification with line breaks for each duplicate
                toast.error(
                    `Duplicate Departments found:\n${duplicates.join("\n")}`,
                    {
                        autoClose: 5000, // Close toast after 5 seconds
                    }
                );
            }

            // Set the formatted JSON data to state
            setExcelJson(formattedJson);
        };
        reader.readAsArrayBuffer(file);
    };


    // Function to handle the upload button click
    const handleUpload = async () => {
        if (excelJson) {
            const loadingToastId = toast.loading("Uploading: Please wait...");
            const duplicates = checkForDuplicates(excelJson);

            if (duplicates.length > 0) {
                toast.error(`Duplicate Data found:\n ${duplicates.join(", ")}`, {
                    autoClose: 5000,
                });
            }
            try {
                const res = await axios.post(`${BASE_URL}/siteproject/departmentbulkuploadadd/`, excelJson);
                if (res.status === 200) {
                    await getdepartment();
                    handleClose();
                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                toast.dismiss(loadingToastId);
            }
        } else {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
        }
    };





    return (
        <>

            <button title="Upload" className="model-button   font-weight500   model-button-print" onClick={handleShow} style={{ margin: "2px" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                    <g fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                        <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                    </g>
                </svg>
            </button>

            <Modal show={show} dialogClassName="ourcompany-model">

                <Modal.Body>
                    <div className="flex-row align-center">

                        <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Upload Bulk Site Department Data in format :</Modal.Title> </h1>


                        <button onClick={handleDownload} className="model-button-download model-button font-weight500">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Format
                        </button>

                    </div>
                    <div className="table-css-white-background" style={{ display: "none" }}>
                        <table ref={bulktableRef} className="nested-table-lightblue">
                            <thead>
                                <tr className="custom-table-head-tr">
                                    <th className="align-left">title</th>
                                    <th className="align-center">sub_company</th>


                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th className="align-left">-</th>
                                    <th className="align-center">-</th>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="table-css-white-background scroll-container">
                        <div className="table-container scrollbar" style={{ width: "100%" }}>

                            <table className="nested-table-lightblue" style={{ margin: "0px" }}>
                                <thead>
                                    <tr className="custom-table-head-tr modal-padding-heading">
                                        <th className="table-heading-text">Title</th>
                                        <th className="table-heading-text">Sub Company</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {excelJson?.map((department, index) => (
                                        <tr key={index} className="modal-padding-heading">
                                            <th className="table-heading-text">{department.title}</th>
                                            <th className="table-heading-text">{department.sub_company}</th>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="flex-column field-cont-div">
                        <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
                            Upload File
                        </label>
                        <label
                            htmlFor="document_file"
                            className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                                }`}
                        >
                            <svg
                                className="pdf-input"
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                                    stroke="#707070"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </label>
                        <input
                            id="document_file"
                            name="document_file"
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileChange}
                            className="file-inputs align-center"
                            style={{ display: "none", position: "relative" }}
                        />
                        {fileName && <p className="file-name align-center">{fileName}</p>}
                        <br />
                        {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
                    </div>
                    <h4>References:</h4>
                    <div className="reference-container">
                        <div className="reference-section">
                            <p className="reference-title">General:</p>
                            <ul className="arrow-list">
                                <li>In title site department name should be filled.</li>
                                <li>Title should be unique.</li>

                            </ul>
                        </div>
                    </div>
                    <div className="button-models">
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Upload
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer position="top-center" autoClose={false} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};
// const UploadInventory = ({ id, getInventory, site_prcode }) => {



//     const [show, setShow] = useState(false);
//     const [fileName, setFileName] = useState("");
//     const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
//     const [docErrors, setDocErrors] = useState({});
//     const [docInputState, setDocInputState] = useState({});

//     const bulktableRef = useRef(null);
//     const handleDownload = () => {
//         const table = bulktableRef.current;
//         const wb = XLSX.utils.table_to_book(table, { sheet: "Inventory Details" });
//         const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

//         const blob = new Blob([s2ab(wbout)], {
//             type: "application/vnd.ms-excel",
//         });
//         const url = window.URL.createObjectURL(blob);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = "Inventory Details Format.xls";
//         a.click();
//         window.URL.revokeObjectURL(url);
//     };

//     const s2ab = (s) => {
//         const buf = new ArrayBuffer(s.length);
//         const view = new Uint8Array(buf);
//         for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
//         return buf;
//     };

//     const handleClose = () => {
//         setFileName("")
//         setExcelJson(null)
//         setDocErrors({})
//         setShow(false)
//     };
//     const handleShow = () => setShow(true);

//     // Function to handle file change
//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             // Check for valid file type
//             const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
//             if (!validFileTypes.includes(file.type)) {
//                 setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
//                 setFileName("");
//                 return;
//             }

//             setFileName(file.name);
//             readExcel(file); // Convert the file to JSON
//         } else {
//             setFileName("");
//         }
//     };

//     const readExcel = (file) => {
//         const reader = new FileReader();
//         reader.onload = (e) => {
//             const data = new Uint8Array(e.target.result);
//             const workbook = XLSX.read(data, { type: "array" });

//             const sheetName = workbook.SheetNames[0]; // Use the first sheet
//             const worksheet = workbook.Sheets[sheetName];
//             const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

//             const headers = json[0];
//             const rows = json.slice(1);

//             const convertToYYYYMMDD = (input) => {
//                 try {
//                     let date;

//                     // Handle Excel serial dates
//                     if (typeof input === "number") {
//                         const excelEpoch = new Date(1900, 0, 1); // Excel epoch starts on Jan 1, 1900
//                         const daysOffset = input - 1; // Subtract 1 because of leap year bug
//                         date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
//                     } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
//                         // Format: YYYY.MM.DD
//                         const [year, month, day] = input.split('.');
//                         date = new Date(`${year}-${month}-${day}`);
//                     } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
//                         // Format: DD.MM.YYYY
//                         const [day, month, year] = input.split('.');
//                         date = new Date(`${year}-${month}-${day}`);
//                     } else {
//                         // Default parsing for other formats
//                         date = new Date(input);
//                     }

//                     if (isNaN(date.getTime())) {
//                         throw new Error('Invalid date format');
//                     }

//                     // Format the date as YYYY-MM-DD
//                     const year = date.getFullYear();
//                     const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
//                     const day = String(date.getDate()).padStart(2, '0');

//                     return `${year}-${month}-${day}`;
//                 } catch (error) {
//                     return null; // Return null for invalid dates
//                 }
//             };

//             // Create a formatted JSON object based on headers and row values
//             const formattedJson = rows.map((row) => {
//                 const obj = {};
//                 headers.forEach((header, index) => {

//                     if (["purchase_date"].includes(header) && row[index] && typeof row[index] === "number") {
//                         obj[header] = convertToYYYYMMDD(row[index]); // Convert date
//                     } else {
//                         obj[header] = row[index] !== undefined ? row[index] : null;
//                     }
//                 });
//                 if (site_prcode) {
//                     obj["project"] = site_prcode;
//                 }
//                 return obj;
//             });

//             // Set the formatted JSON data to state
//             setExcelJson(formattedJson);
//         };
//         reader.readAsArrayBuffer(file);
//     };


//     // Function to handle the upload button click
//     const handleUpload = async () => {
//         if (excelJson) {
//             const loadingToastId = toast.loading("Uploading: Please wait...");

//             try {
//                 const res = await axios.post(`${BASE_URL}/siteproject/bulksiteinventory/`, excelJson);
//                 if (res.status === 200) {
//                     await getInventory();
//                     handleClose();
//                     toast.dismiss(loadingToastId);
//                     toast.success("Inventory Details uploaded successfully.");

//                 } else {
//                     toast.dismiss(loadingToastId);
//                     toast.error("Failed to add data!");
//                 }
//             } catch (err) {
//                 handleErrorToast(err);
//             } finally {
//                 toast.dismiss(loadingToastId);
//             }
//         } else {
//             setDocErrors({ document_file: "Please upload a valid Excel file." });
//         }
//     };





//     return (
//         <>

//             <button title="Upload" className="model-button   font-weight500   model-button-print" onClick={handleShow} style={{ margin: "2px" }}>
//                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
//                     <g fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
//                         <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
//                     </g>
//                 </svg>
//             </button>

//             <Modal show={show} dialogClassName="ourcompany-model">

//                 <Modal.Body>
//                     <div className="flex-row align-center">

//                         <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Upload Bulk Site Inventory Data in format :</Modal.Title> </h1>


//                         <button onClick={handleDownload} className="model-button-download model-button font-weight500">
//                             <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
//                                 <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
//                                     <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
//                                 </g>
//                             </svg>
//                             {"  "} Format
//                         </button>

//                     </div>
//                     <div className="table-css-white-background" style={{ display: "none" }}>
//                         <table ref={bulktableRef} className="nested-table-lightblue">
//                             <thead>
//                                 <tr className="custom-table-head-tr">
//                                     {site_prcode ? "" :
//                                         <th className="align-left">project</th>
//                                     }
//                                     <th className="align-left">emp_code</th>
//                                     <th className="align-left">item_name</th>
//                                     <th className="align-center">description</th>
//                                     <th className="align-center">quantity</th>
//                                     <th className="align-center">rate_per_item</th>
//                                     <th className="align-center">purchase_date</th>


//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr>
//                                     {site_prcode ? "" :
//                                         <th className="align-left">-</th>
//                                     }
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>
//                                     <th className="align-center">-</th>

//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>

//                     <div className="table-css-white-background scroll-container">
//                         <div className="table-container scrollbar" style={{ width: "100%" }}>

//                             <table className="nested-table-lightblue" style={{ margin: "0px" }}>
//                                 <thead>
//                                     <tr className="custom-table-head-tr">
//                                         {site_prcode ? "" :
//                                             <th className="align-left">project</th>
//                                         }
//                                         <th className="align-left">emp_code</th>
//                                         <th className="align-center">item_name</th>
//                                         <th className="align-center">description</th>
//                                         <th className="align-center">quantity</th>
//                                         <th className="align-center">rate_per_item</th>
//                                         <th className="align-center">purchase_date</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {excelJson?.map((inventory, index) => (
//                                         <tr key={index}>
//                                             {site_prcode ? "" :
//                                                 <th className="align-center">{inventory.project}</th>
//                                             }
//                                             <th className="align-left">{inventory.emp_code}</th>
//                                             <th className="align-left">{inventory.item_name}</th>
//                                             <th className="align-center">{inventory.description}</th>
//                                             <th className="align-center">{inventory.quantity}</th>
//                                             <th className="align-center">{inventory.rate_per_item}</th>
//                                             <th className="align-center">{inventory.purchase_date}</th>

//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>

//                     <div className="flex-column field-cont-div">
//                         <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
//                             Upload File
//                         </label>
//                         <label
//                             htmlFor="document_file"
//                             className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
//                                 }`}
//                         >
//                             <svg
//                                 className="pdf-input"
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 width="15"
//                                 height="15"
//                                 viewBox="0 0 20 20"
//                                 fill="none"
//                             >
//                                 <path
//                                     d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
//                                     stroke="#707070"
//                                     strokeWidth="2"
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                 />
//                             </svg>
//                         </label>
//                         <input
//                             id="document_file"
//                             name="document_file"
//                             type="file"
//                             accept=".xlsx, .xls"
//                             onChange={handleFileChange}
//                             className="file-inputs align-center"
//                             style={{ display: "none", position: "relative" }}
//                         />
//                         {fileName && <p className="file-name align-center">{fileName}</p>}
//                         <br />
//                         {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
//                     </div>
//                     <h4>References:</h4>
//                     <div className="reference-container">

//                     </div>
//                     <div className="flex-row justify-between" style={{ alignItems: "baseline" }}>
//                         <div>
//                             <p className="reference-title">General:</p>

//                             <ul className="arrow-list">

//                                 <li>In project field site project code should be filled. </li>
//                                 <li>Employee Code should be Valid </li>
//                                 <li>Employee Code should be Valid </li>
//                                 <li>All Dates should be in DD-MM-YYYY format</li>
//                                 <li>The item name should match exactly with the names in the Item List.</li>

//                             </ul>
//                         </div>

//                     </div>
//                     <div className="button-models">
//                         <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
//                             Cancel
//                         </button>
//                         <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
//                             <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
//                                 <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
//                                     <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
//                                 </g>
//                             </svg>
//                             {"  "} Upload
//                         </button>
//                     </div>
//                 </Modal.Body>
//             </Modal>
//             <ToastContainer position="top-center" autoClose={false} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//         </>
//     );
// };

const UploadInventory = ({ id, getInventory, site_prcode }) => {
    const [show, setShow] = useState(false);
    const [fileName, setFileName] = useState("");
    const [fileSize, setFileSize] = useState("");
    const [excelJson, setExcelJson] = useState(null);
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});
    const [isDragging, setIsDragging] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const fileInputRef = useRef(null);

    const formatFileSize = (bytes) => {
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    };

    const handleDownload = () => {
        const headers = [site_prcode ? null : "project", "emp_code", "item_name", "description", "quantity", "rate_per_item", "purchase_date"].filter(Boolean);

        const data = [
            headers,
            [],
            ["GENERAL INSTRUCTIONS:"],
            ["   • In Project field only fill site project code."],
            ["   • Employee code should be valid and existing."],
            ["   • The item name should match exactly with the names in the Item List."],
            ["   • Quantity and Rate per Item should be numeric values."],
            [],
            ["NOTE: All Dates should be in DD-MM-YYYY format."]
        ];

        const ws = XLSX.utils.aoa_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Inventory Format");

        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Inventory_Upload_Format.xlsx";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleClose = () => {
        setFileName("");
        setFileSize("");
        setExcelJson(null);
        setDocErrors({});
        setDocInputState({});
        setShow(false);
    };

    const handleShow = () => setShow(true);

    const handleRemoveFile = () => {
        setFileName("");
        setFileSize("");
        setExcelJson(null);
        setDocErrors({});
        setDocInputState({});
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const processFile = (file) => {
        if (!file) return;
        const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
        if (!validFileTypes.includes(file.type)) {
            setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
            setFileName("");
            setFileSize("");
            return;
        }

        setFileName(file.name);
        setFileSize(formatFileSize(file.size));
        setDocErrors({});
        setDocInputState({ document_file: "green" });
        readExcel(file);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        processFile(file);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const file = e.dataTransfer.files[0];
        processFile(file);
    };

    const readExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

            const headers = json[0];
            const rows = json.slice(1);

            const convertToYYYYMMDD = (input) => {
                try {
                    let date;

                    if (typeof input === "number") {
                        const excelEpoch = new Date(1900, 0, 1);
                        const daysOffset = input - 1;
                        date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
                    } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
                        const [year, month, day] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
                        const [day, month, year] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else {
                        date = new Date(input);
                    }

                    if (isNaN(date.getTime())) {
                        throw new Error('Invalid date format');
                    }

                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');

                    return `${year}-${month}-${day}`;
                } catch (error) {
                    return null;
                }
            };

            const formattedJson = rows.map((row) => {
                const obj = {};
                headers.forEach((header, index) => {
                    if (["purchase_date"].includes(header) && row[index] && typeof row[index] === "number") {
                        obj[header] = convertToYYYYMMDD(row[index]);
                    } else {
                        obj[header] = row[index] !== undefined ? row[index] : null;
                    }
                });
                if (site_prcode) {
                    obj["project"] = site_prcode;
                }
                return obj;
            });

            setExcelJson(formattedJson);
        };
        reader.readAsArrayBuffer(file);
    };

    const handleUpload = async () => {
        if (excelJson) {
            setShowProgressModal(true);
            setUploadProgress(0);

            const loadingToastId = toast.loading("Uploading: Please wait...");

            let progress = 0;
            const interval = setInterval(() => {
                progress += 10;
                if (progress >= 100) {
                    progress = 100;
                    clearInterval(interval);
                }
                setUploadProgress(progress);
            }, 100);

            try {
                const res = await axios.post(`${BASE_URL}/siteproject/bulksiteinventory/`, excelJson);
                if (res.status === 200) {
                    await getInventory();
                    toast.dismiss(loadingToastId);
                    toast.success("Inventory Details uploaded successfully.");
                    handleClose();
                } else {
                    toast.dismiss(loadingToastId);
                    toast.error("Failed to add data!");
                }
            } catch (err) {
                clearInterval(interval);
                setUploadProgress(0);
                handleErrorToast(err);
            } finally {
                clearInterval(interval);
                setTimeout(() => {
                    setShowProgressModal(false);
                }, 1500);
                toast.dismiss(loadingToastId);
            }
        } else {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
        }
    };

    return (
        <>
            <style>{`
                .ub-upload-zone {
                    border: 2px dashed #c7cdd6;
                    border-radius: 14px;
                    background: #fafbfd;
                    padding: 32px 20px;
                    text-align: center;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    position: relative;
                }
                .ub-upload-zone:hover {
                    border-color: #6366f1;
                    background: #f5f5ff;
                }
                .ub-upload-zone.dragging {
                    border-color: #6366f1;
                    background: #eef0ff;
                    transform: scale(1.01);
                }
                .ub-upload-zone.has-error {
                    border-color: #e11d48;
                    background: #fff1f2;
                }
                .ub-upload-icon-circle {
                    width: 56px;
                    height: 56px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #6366f1, #8b5cf6);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 14px;
                    color: white;
                    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.3);
                }
                .ub-upload-title {
                    font-size: 15px;
                    font-weight: 600;
                    color: #1f2937;
                    margin: 0 0 4px;
                }
                .ub-upload-subtitle {
                    font-size: 13px;
                    color: #6b7280;
                    margin: 0;
                }
                .ub-upload-browse {
                    color: #6366f1;
                    font-weight: 600;
                    text-decoration: underline;
                }
                .ub-file-card {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    background: #f0fdf4;
                    border: 1px solid #bbf7d0;
                    border-radius: 12px;
                    padding: 14px 16px;
                    margin-top: 12px;
                    animation: ub-fade-in 0.25s ease;
                }
                .ub-file-icon {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    background: #16a34a;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    flex-shrink: 0;
                }
                .ub-file-info {
                    flex: 1;
                    min-width: 0;
                }
                .ub-file-name {
                    font-size: 14px;
                    font-weight: 600;
                    color: #1f2937;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .ub-file-size {
                    font-size: 12px;
                    color: #6b7280;
                }
                .ub-file-remove {
                    background: none;
                    border: none;
                    cursor: pointer;
                    color: #9ca3af;
                    padding: 6px;
                    border-radius: 8px;
                    display: flex;
                    transition: all 0.15s ease;
                    flex-shrink: 0;
                }
                .ub-file-remove:hover {
                    background: #fee2e2;
                    color: #dc2626;
                }
                @keyframes ub-fade-in {
                    from { opacity: 0; transform: translateY(-4px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .ub-preview-wrap {
                    border: 1px solid #e5e7eb;
                    border-radius: 14px;
                    overflow: hidden;
                    margin-top: 8px;
                }
                .ub-preview-scroll {
                    overflow-x: auto;
                    max-height: 340px;
                    overflow-y: auto;
                }
                .ub-preview-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 13px;
                    white-space: nowrap;
                }
                .ub-preview-table thead th {
                    position: sticky;
                    top: 0;
                    background: #f8fafc;
                    color: #475569;
                    font-weight: 600;
                    text-align: left;
                    padding: 10px 14px;
                    border-bottom: 2px solid #e2e8f0;
                    z-index: 1;
                }
                .ub-preview-table tbody td {
                    padding: 9px 14px;
                    color: #334155;
                    border-bottom: 1px solid #f1f5f9;
                }
                .ub-preview-table tbody tr:nth-child(even) {
                    background: #fbfcfe;
                }
                .ub-preview-table tbody tr:hover {
                    background: #f0f4ff;
                }
                .ub-preview-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 10px 4px;
                }
                .ub-preview-badge {
                    background: #eef2ff;
                    color: #4338ca;
                    font-size: 12px;
                    font-weight: 600;
                    padding: 4px 10px;
                    border-radius: 999px;
                }
                .ub-download-row {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background: #f8fafc;
                    border: 1px solid #e5e7eb;
                    border-radius: 12px;
                    padding: 14px 16px;
                    margin-bottom: 18px;
                    gap: 12px;
                }
                .ub-download-row p {
                    margin: 0;
                    font-size: 13.5px;
                    color: #475569;
                }
            `}</style>

            <button title="Upload" className="btn-animated" onClick={handleShow} style={{ margin: "2px" }}>
                <UploadCloud size={16} style={{ marginRight: "6px" }} /> Bulk Upload
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Upload" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal model-width80vw" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Upload size={24} />
                            </div>
                            <div>
                                <Modal.Title>Upload Bulk Site Inventory Data</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Upload multiple inventory items at once using the Excel format</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body">

                        <div className="ub-download-row">
                            <p><FileText size={14} style={{ marginRight: '6px', verticalAlign: 'middle' }} />
                                Download the Excel template, fill in inventory details, then upload it below.
                            </p>
                            <button onClick={handleDownload} className="btn-primaryy" type="button" style={{ flexShrink: 0 }}>
                                <Download size={16} />
                                <span>Format</span>
                            </button>
                        </div>

                        <div className="section-title">
                            <Upload size={18} />
                            <h4>Upload File</h4>
                        </div>

                        <div
                            className={`ub-upload-zone ${isDragging ? 'dragging' : ''} ${docErrors.document_file ? 'has-error' : ''}`}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            onClick={() => fileInputRef.current?.click()}
                        >
                            <div className="ub-upload-icon-circle">
                                <Upload size={24} />
                            </div>
                            <p className="ub-upload-title">
                                Drag & drop your Excel file here
                            </p>
                            <p className="ub-upload-subtitle">
                                or <span className="ub-upload-browse">browse</span> to choose a file &nbsp;·&nbsp; .xlsx or .xls
                            </p>
                            <input
                                ref={fileInputRef}
                                id="document_file"
                                name="document_file"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                            />
                        </div>

                        {docErrors.document_file && (
                            <div className="tab-error-message" style={{ marginTop: '10px' }}>
                                <AlertCircle size={14} />
                                <span>{docErrors.document_file}</span>
                            </div>
                        )}

                        {fileName && !docErrors.document_file && (
                            <div className="ub-file-card">
                                <div className="ub-file-icon">
                                    <FileText size={20} />
                                </div>
                                <div className="ub-file-info">
                                    <div className="ub-file-name">{fileName}</div>
                                    <div className="ub-file-size">{fileSize}{excelJson ? ` · ${excelJson.length} records found` : ''}</div>
                                </div>
                                <button type="button" className="ub-file-remove" onClick={handleRemoveFile} title="Remove file">
                                    <X size={18} />
                                </button>
                            </div>
                        )}

                        {excelJson && excelJson.length > 0 && (
                            <>
                                <div className="ub-preview-header">
                                    <div className="section-title" style={{ marginBottom: 0 }}>
                                        <Package size={18} />
                                        <h4 style={{ margin: 0 }}>Preview</h4>
                                    </div>
                                    <span className="ub-preview-badge">{excelJson.length} items</span>
                                </div>

                                <div className="ub-preview-wrap">
                                    <div className="ub-preview-scroll  table-box scroll-container-table">
                                        <table className="ub-preview-table">
                                            <thead className="table-heading">
                                                <tr>
                                                    {site_prcode ? null : <th>Project</th>}
                                                    <th>Emp Code</th>
                                                    <th>Item Name</th>
                                                    <th>Description</th>
                                                    <th>Quantity</th>
                                                    <th>Rate per Item</th>
                                                    <th>Purchase Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {excelJson.map((inventory, index) => (
                                                    <tr key={index}>
                                                        {site_prcode ? null : <td>{inventory.project}</td>}
                                                        <td>{inventory.emp_code}</td>
                                                        <td>{inventory.item_name}</td>
                                                        <td>{inventory.description}</td>
                                                        <td>{inventory.quantity}</td>
                                                        <td>{inventory.rate_per_item}</td>
                                                        <td>{inventory.purchase_date}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="form-actions">
                            <button type="button" className="btn-secondaryy" onClick={handleClose}>
                                Cancel
                            </button>
                            <button type="button" className="btn-primaryy" onClick={handleUpload} disabled={!excelJson}>
                                <Upload size={18} />
                                <span>Upload</span>
                            </button>
                        </div>

                        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};


const UploadEotBulk = ({ id, getEotdata, site_prcode, workperformedby, contractor_name, letterData, projectId }) => {



    const [show, setShow] = useState(false);
    const [fileName, setFileName] = useState("");
    const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});
    const [trackRecordList, setTrackRecordList] = useState([]);


    const getLetters = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/letterrecordbclosestatus/${projectId}/${workperformedby}/eot/`);
            setTrackRecordList(res.data);
        } catch (error) {
            handleErrorToast(error);
        }
    }
    useEffect(() => {
        getLetters();
    }, [projectId, workperformedby])



    const bulktableRef = useRef(null);
    const handleDownload = () => {
        const table = bulktableRef.current;
        const wb = XLSX.utils.table_to_book(table, { sheet: "EOT Details" });
        const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.ms-excel",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "EOT Details Format.xls";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleClose = () => {
        setFileName("")
        setExcelJson(null)
        setDocErrors({})
        setShow(false)
    };
    const handleShow = () => setShow(true);

    // Function to handle file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check for valid file type
            const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
            if (!validFileTypes.includes(file.type)) {
                setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
                setFileName("");
                return;
            }

            setFileName(file.name);
            readExcel(file); // Convert the file to JSON
        } else {
            setFileName("");
        }
    };

    const checkForDuplicates = (data) => {
        const EOT = new Map();
        const duplicates = [];

        // Track positions of each insurance number
        data.forEach((i, index) => {
            const EotCode = i.eot_code;
            if (EOT.has(EotCode)) {
                // If the insurance number already exists, add the current position to its list
                EOT.get(EotCode).push(index + 1); // index + 1 for 1-based position
            } else {
                // If it's the first time seeing this insurance number, initialize its position list
                EOT.set(EotCode, [index + 1]);
            }
        });

        // Now, filter out only the numbers that appear more than once
        EOT.forEach((positions, EotCode) => {
            if (positions.length > 1) {
                duplicates.push(`\n Eot Code :${EotCode} is found in position(s) ${positions.join(", ")}`);
            }
        });

        return duplicates;
    };

    const readExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0]; // Use the first sheet
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

            const headers = json[0];
            const rows = json.slice(1);
            const convertToYYYYMMDD = (input) => {
                try {
                    let date;

                    // Handle Excel serial dates
                    if (typeof input === "number") {
                        const excelEpoch = new Date(1900, 0, 1); // Excel epoch starts on Jan 1, 1900
                        const daysOffset = input - 1; // Subtract 1 because of leap year bug
                        date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
                    } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
                        // Format: YYYY.MM.DD
                        const [year, month, day] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
                        // Format: DD.MM.YYYY
                        const [day, month, year] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else {
                        // Default parsing for other formats
                        date = new Date(input);
                    }

                    if (isNaN(date.getTime())) {
                        throw new Error('Invalid date format');
                    }

                    // Format the date as YYYY-MM-DD
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                    const day = String(date.getDate()).padStart(2, '0');

                    return `${year}-${month}-${day}`;
                } catch (error) {
                    return null; // Return null for invalid dates
                }
            };
            // Create a formatted JSON object based on headers and row values
            const formattedJson = rows.map((row) => {
                const obj = {};
                headers.forEach((header, index) => {

                    if (["process_initiate_date", "approved_date"].includes(header) && row[index] && typeof row[index] === "number") {
                        obj[header] = convertToYYYYMMDD(row[index]); // Convert date
                    } else {
                        obj[header] = row[index] !== undefined ? row[index] : null;
                    }
                });
                if (site_prcode) {
                    obj["project"] = site_prcode;
                }

                if (workperformedby) {
                    obj["workperformedby"] = workperformedby;

                }
                if (workperformedby === "contractor") {
                    if (contractor_name) {
                        obj["contractor"] = contractor_name;
                    }
                }
                if (workperformedby === "consultant") {
                    obj["contractor"] = null;
                }

                return obj;
            });

            const duplicates = checkForDuplicates(formattedJson);

            if (duplicates.length > 0) {
                // Toast notification with line breaks for each duplicate
                toast.error(
                    `Duplicate EOT found:\n${duplicates.join("\n")}`,
                    {
                        autoClose: 5000, // Close toast after 5 seconds
                    }
                );
            }

            // Set the formatted JSON data to state
            setExcelJson(formattedJson);
        };
        reader.readAsArrayBuffer(file);

    };

    // Function to handle the upload button click
    const handleUpload = async () => {
        if (!excelJson) {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
            return;
        }

        // Validate letter numbers in excelJson against trackRecordList
        const invalidRecords = excelJson.filter(
            (item) => !trackRecordList.some(
                (record) => String(record.letter_num).trim() === String(item.letter).trim()
            )
        );

        if (invalidRecords.length > 0) {
            // Handle invalid letter numbers
            const invalidLetters = invalidRecords.map((record) => record.letter).join(", ");
            toast.error(`The following letter numbers do not exist: ${invalidLetters}`);
            return;
        }

        const loadingToastId = toast.loading("Uploading: Please wait...");

        try {
            const res = await axios.post(`${BASE_URL}/siteproject/eotbulkupload/`, excelJson);
            if (res.status === 200) {
                await getEotdata(); // Refresh data after upload

                handleClose(); // Close modal or reset form
                toast.success("EOT Data added Successfully");
                toast.dismiss(loadingToastId);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };





    return (
        <>

            <button title="Upload" className="model-button   font-weight500   model-button-print equal-hieght" onClick={handleShow} style={{ margin: "2px" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                    <g fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                        <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                    </g>
                </svg>
            </button>

            <Modal show={show} dialogClassName="ourcompany-model">

                <Modal.Body>
                    <div className="flex-row align-center">

                        <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Upload Bulk EOT Data in format :</Modal.Title> </h1>


                        <button onClick={handleDownload} className="model-button-download model-button font-weight500">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Format
                        </button>

                    </div>
                    <div className="table-css-white-background" style={{ display: "none" }}>
                        <table ref={bulktableRef} className="nested-table-lightblue">
                            <thead>
                                <tr className="custom-table-head-tr">

                                    <th className="align-left">eot_code</th>
                                    <th className="align-left">process_initiate_date</th>
                                    <th className="align-left">approved_date</th>
                                    <th className="align-center">approved_days</th>
                                    <th className="align-center">letter</th>
                                    <th className="align-center">eot_status</th>



                                </tr>
                            </thead>
                            <tbody>
                                <tr>

                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="table-css-white-background scroll-container">
                        <div className="table-container scrollbar" style={{ width: "100%" }}>

                            <table className="nested-table-lightblue" style={{ margin: "0px" }}>
                                <thead>
                                    <tr className="custom-table-head-tr  modal-padding-heading">
                                        <th className="tablle-heading-text">EOT Code</th>
                                        <th className="tablle-heading-text">Process Initiate Date</th>
                                        <th className="table-heading-text">Approved Date</th>
                                        <th className="table-heading-text">Approved Days</th>
                                        <th className="table-heading-text">Letter</th>
                                        <th className="table-heading-text">EOT Status</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {excelJson?.map((inventory, index) => (
                                        <tr key={index} className="modal-padding-heading">
                                            <th className="tablle-heading-text">{inventory.eot_code}</th>
                                            <th className="tablle-heading-text">{inventory.process_initiate_date}</th>
                                            <th className="tablle-heading-text">{inventory.approved_date}</th>
                                            <th className="table-heading-text">{inventory.approved_days}</th>
                                            <th className="table-heading-text">{inventory.letter}</th>
                                            <th className="table-heading-text">{inventory.eot_status}</th>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="flex-column field-cont-div">
                        <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
                            Upload File
                        </label>
                        <label
                            htmlFor="document_file"
                            className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                                }`}
                        >
                            <svg
                                className="pdf-input"
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                                    stroke="#707070"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </label>
                        <input
                            id="document_file"
                            name="document_file"
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileChange}
                            className="file-inputs align-center"
                            style={{ display: "none", position: "relative" }}
                        />
                        {fileName && <p className="file-name align-center">{fileName}</p>}
                        <br />
                        {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
                    </div>

                    <h4>References:</h4>
                    <div className="reference-container">
                        <div className="reference-section">
                            <p className="reference-title">   For eot status use one of these:</p>
                            <ul className="arrow-list">
                                <li>pending </li>
                                <li>Approved </li>
                                <li>rejected </li>
                            </ul>
                        </div>

                        <div className="reference-section">
                            <p className="reference-title">   For Letters:</p>
                            <ul className="arrow-list">
                                <li>Add Letter number in letter field </li>
                                <li>Insert existing letter number only </li>
                            </ul>
                        </div>
                        <div className="reference-section">
                            <p className="reference-title">   For EOT:</p>
                            <ul className="arrow-list">
                                <li>EOT code should be unique </li>
                            </ul>
                        </div>
                        <div className="date-section">
                            <p className="date-text">All Dates should be in DD-MM-YYYY format</p>
                        </div>
                    </div>

                    <div className="button-models">
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Upload
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer position="top-center" autoClose={false} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};
const UploadcosBulk = ({ id, getCOSData, site_prcode, workperformedby, contractor_name, letterData, projectId }) => {



    const [show, setShow] = useState(false);
    const [fileName, setFileName] = useState("");
    const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});
    const [trackRecordList, setTrackRecordList] = useState([]);


    const getLetters = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/letterrecordbclosestatus/${projectId}/${workperformedby}/cos/`);
            setTrackRecordList(res.data);
        } catch (error) {
            handleErrorToast(error);
        }
    }
    useEffect(() => {
        getLetters();
    }, [projectId, workperformedby])

    const bulktableRef = useRef(null);
    const handleDownload = () => {
        const table = bulktableRef.current;
        const wb = XLSX.utils.table_to_book(table, { sheet: "COS Details" });
        const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.ms-excel",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "COS Details Format.xls";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleClose = () => {
        setFileName("")
        setExcelJson(null)
        setDocErrors({})
        setShow(false)
    };
    const handleShow = () => setShow(true);

    // Function to handle file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check for valid file type
            const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
            if (!validFileTypes.includes(file.type)) {
                setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
                setFileName("");
                return;
            }

            setFileName(file.name);
            readExcel(file); // Convert the file to JSON
        } else {
            setFileName("");
        }
    };

    const readExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0]; // Use the first sheet
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

            const headers = json[0];
            const rows = json.slice(1);
            const convertToYYYYMMDD = (input) => {
                try {
                    let date;

                    // Handle Excel serial dates
                    if (typeof input === "number") {
                        const excelEpoch = new Date(1900, 0, 1); // Excel epoch starts on Jan 1, 1900
                        const daysOffset = input - 1; // Subtract 1 because of leap year bug
                        date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
                    } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
                        // Format: YYYY.MM.DD
                        const [year, month, day] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
                        // Format: DD.MM.YYYY
                        const [day, month, year] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else {
                        // Default parsing for other formats
                        date = new Date(input);
                    }

                    if (isNaN(date.getTime())) {
                        throw new Error('Invalid date format');
                    }

                    // Format the date as YYYY-MM-DD
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                    const day = String(date.getDate()).padStart(2, '0');

                    return `${year}-${month}-${day}`;
                } catch (error) {
                    return null; // Return null for invalid dates
                }
            };


            const formattedJson = rows.map((row) => {
                const obj = {};
                headers.forEach((header, index) => {

                    if (["process_initiate_date", "approval_date"].includes(header) && row[index] && typeof row[index] === "number") {
                        obj[header] = convertToYYYYMMDD(row[index]); // Convert date
                    } else {
                        obj[header] = row[index] !== undefined ? row[index] : null;
                    }
                });
                if (site_prcode) {
                    obj["project"] = site_prcode;
                }

                if (workperformedby) {
                    obj["workperformedby"] = workperformedby;

                }
                if (workperformedby === "contractor") {
                    if (contractor_name) {
                        obj["contractor"] = contractor_name;
                    }
                }
                return obj;
            });

            // Set the formatted JSON data to state
            setExcelJson(formattedJson);
        };
        reader.readAsArrayBuffer(file);
    };
    const existingLetters = trackRecordList.map(record => record.letter_num);
    console.log(existingLetters);
    console.log(excelJson?.letter)
    // Function to handle the upload button click
    const handleUpload = async () => {
        if (!excelJson) {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
            return;
        }

        // Validate letter numbers in excelJson against trackRecordList
        const invalidRecords = excelJson.filter(
            (item) => !trackRecordList.some(
                (record) => String(record.letter_num).trim() === String(item.letter).trim()
            )
        );

        if (invalidRecords.length > 0) {
            // Handle invalid letter numbers
            const invalidLetters = invalidRecords.map((record) => record.letter).join(", ");
            toast.error(`The following letter numbers do not exist: ${invalidLetters}`);
            return;
        }

        const loadingToastId = toast.loading("Uploading: Please wait...");

        try {
            const res = await axios.post(`${BASE_URL}/siteproject/cosbulkupload/`, excelJson);
            if (res.status === 200) {
                await getCOSData(); // Refresh data after upload
                handleClose(); // Close modal or reset form
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };





    return (
        <>

            <button title="Upload" className="model-button   font-weight500   model-button-print equal-hieght" onClick={handleShow} style={{ margin: "2px" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                    <g fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                        <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                    </g>
                </svg>
            </button>

            <Modal show={show} dialogClassName="ourcompany-model">

                <Modal.Body>
                    <div className="flex-row align-center">

                        <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Upload Bulk COS Data in format :</Modal.Title> </h1>


                        <button onClick={handleDownload} className="model-button-download model-button font-weight500">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Format
                        </button>

                    </div>
                    <div className="table-css-white-background" style={{ display: "none" }}>
                        <table ref={bulktableRef} className="nested-table-lightblue">
                            <thead>
                                <tr className="custom-table-head-tr">
                                    <th className="align-left">cos_code</th>
                                    <th className="align-center">letter</th>
                                    <th className="align-center">process_initiate_date</th>
                                    <th className="align-left">approval_date</th>
                                    <th className="align-left">amount</th>
                                    <th className="align-left">cos_status</th>


                                </tr>
                            </thead>
                            <tbody>
                                <tr>

                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="table-css-white-background">
                        <table className="nested-table-lightblue">
                            <thead>
                                <tr className="custom-table-head-tr">

                                    <th className="align-left">cos_code</th>
                                    <th className="align-center">letter</th>
                                    <th className="align-center">process_initiate_date</th>
                                    <th className="align-left">approval_date</th>
                                    <th className="align-center">amount</th>
                                    <th className="align-center">cos_status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {excelJson?.map((inventory, index) => (
                                    <tr key={index}>
                                        <th className="align-left">{inventory.cos_code}</th>
                                        <th className="align-center">{inventory.letter}</th>
                                        <th className="align-center">{inventory.process_initiate_date}</th>
                                        <th className="align-left">{inventory.approval_date}</th>
                                        <th className="align-left">{inventory.amount}</th>
                                        <th className="align-left">{inventory.cos_status}</th>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="flex-column field-cont-div">
                        <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
                            Upload File
                        </label>
                        <label
                            htmlFor="document_file"
                            className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                                }`}
                        >
                            <svg
                                className="pdf-input"
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                                    stroke="#707070"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </label>
                        <input
                            id="document_file"
                            name="document_file"
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileChange}
                            className="file-inputs align-center"
                            style={{ display: "none", position: "relative" }}
                        />
                        {fileName && <p className="file-name align-center">{fileName}</p>}
                        <br />
                        {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
                    </div>
                    <h4>References:</h4>
                    <div className="reference-container">
                        <div className="reference-section">
                            <p className="reference-title">   For cos status use one of these:</p>
                            <ul className="arrow-list">
                                <li>pending </li>
                                <li>Approved </li>
                                <li>rejected </li>
                            </ul>
                        </div>
                        <div className="reference-section">
                            <p className="reference-title">   For Letters:</p>
                            <ul className="arrow-list">
                                <li>Add Letter number in letter field </li>
                                <li>Insert existing letter number only </li>
                            </ul>
                        </div>
                        <div className="reference-section">
                            <p className="reference-title">   For COS:</p>
                            <ul className="arrow-list">
                                <li>COS code should be unique </li>
                            </ul>
                        </div>
                        <div className="date-section">
                            <p className="date-text">All Dates should be in DD-MM-YYYY format</p>
                        </div>
                    </div>
                    <div className="button-models">
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Upload
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer position="top-center" autoClose={false} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};
const UploadMilestoneBulk = ({ id, getMileStoneData, site_prcode, workperformedby, contractor_name, projectId }) => {



    const [show, setShow] = useState(false);
    const [fileName, setFileName] = useState("");
    const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});
    const [trackRecordList, setTrackRecordList] = useState([]);

    const bulktableRef = useRef(null);
    const handleDownload = () => {
        const table = bulktableRef.current;
        const wb = XLSX.utils.table_to_book(table, { sheet: "MileStones Details" });
        const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.ms-excel",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "MileStones Details Format.xls";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleClose = () => {
        setFileName("")
        setExcelJson(null)
        setDocErrors({})
        setShow(false)
    };
    const handleShow = () => setShow(true);

    // Function to handle file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check for valid file type
            const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
            if (!validFileTypes.includes(file.type)) {
                setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
                setFileName("");
                return;
            }

            setFileName(file.name);
            readExcel(file); // Convert the file to JSON
        } else {
            setFileName("");
        }
    };

    const readExcel = (file) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0]; // Use the first sheet
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

            const headers = json[0];
            const rows = json.slice(1);

            // Function to convert Excel dates or general date formats to YYYY-MM-DD
            const convertToYYYYMMDD = (input) => {
                try {
                    let date;

                    // Handle Excel serial dates
                    if (typeof input === "number") {
                        const excelEpoch = new Date(1900, 0, 1); // Excel epoch starts on Jan 1, 1900
                        const daysOffset = input - 1; // Subtract 1 because of leap year bug
                        date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
                    } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
                        // Format: YYYY.MM.DD
                        const [year, month, day] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
                        // Format: DD.MM.YYYY
                        const [day, month, year] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else {
                        // Default parsing for other formats
                        date = new Date(input);
                    }

                    if (isNaN(date.getTime())) {
                        throw new Error('Invalid date format');
                    }

                    // Format the date as YYYY-MM-DD
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                    const day = String(date.getDate()).padStart(2, '0');

                    return `${year}-${month}-${day}`;
                } catch (error) {
                    return null; // Return null for invalid dates
                }
            };

            // Create a formatted JSON object based on headers and row values
            const formattedJson = rows.map((row) => {
                const obj = {};

                headers.forEach((header, index) => {
                    if (["milestone_as_per_actual", "milestone_as_per_reschedule", "milestone_date"].includes(header) && row[index]) {
                        obj[header] = convertToYYYYMMDD(row[index]); // Convert date
                    } else {
                        obj[header] = row[index] !== undefined ? row[index] : null;
                    }
                });

                if (typeof site_prcode !== "undefined") {
                    obj["project"] = site_prcode;
                }

                if (typeof workperformedby !== "undefined") {
                    obj["workperformedby"] = workperformedby;

                    if (workperformedby === "contractor" && typeof contractor_name !== "undefined") {
                        obj["contractor"] = contractor_name;
                    }
                }

                return obj;
            });

            // Set the formatted JSON data to state
            setExcelJson(formattedJson);
        };

        reader.readAsArrayBuffer(file);
    };



    const handleUpload = async () => {
        if (!excelJson) {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
            return;
        }

        // // Validate letter numbers in excelJson against trackRecordList
        // const invalidRecords = excelJson.filter(
        //     (item) => !trackRecordList.some(
        //         (record) => String(record.letter_num).trim() === String(item.letter).trim()
        //     )
        // );

        // if (invalidRecords.length > 0) {
        //     // Handle invalid letter numbers
        //     const invalidLetters = invalidRecords.map((record) => record.letter).join(", ");
        //     toast.error(`The following letter numbers do not exist: ${invalidLetters}`);
        //     return;
        // }

        const loadingToastId = toast.loading("Uploading: Please wait...");

        try {
            const res = await axios.post(`${BASE_URL}/siteproject/milestoneupload/`, excelJson);
            if (res.status === 200) {
                await getMileStoneData(); // Refresh data after upload
                handleClose(); // Close modal or reset form
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };





    return (
        <>

            <button title="Upload" className="model-button   font-weight500   model-button-print" onClick={handleShow} style={{ margin: "2px" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                    <g fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                        <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                    </g>
                </svg>
            </button>

            <Modal show={show} dialogClassName="ourcompany-model">

                <Modal.Body>
                    <div className="flex-row align-center">

                        <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Upload Bulk MileStone Data in format :</Modal.Title> </h1>


                        <button onClick={handleDownload} className="model-button-download model-button font-weight500">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Format
                        </button>

                    </div>
                    <div className="table-css-white-background" style={{ display: "none" }}>
                        <table ref={bulktableRef} className="nested-table-lightblue">
                            <thead>
                                <tr className="custom-table-head-tr">
                                    <th className="align-left">name</th>
                                    <th className="align-center">milestone_date</th>
                                    <th className="align-center">milestone_as_per_actual</th>
                                    <th className="align-left">milestone_as_per_reschedule</th>
                                    <th className="align-left">day</th>


                                </tr>
                            </thead>
                            <tbody>
                                <tr>

                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="table-css-white-background scroll-container">
                        <div className="table-container scrollbar" style={{ width: "100%" }}>

                            <table className="nested-table-lightblue" style={{ margin: "0px" }}>
                                <thead>
                                    <tr className="custom-table-head-tr  modal-padding-heading">

                                        <th className="table-heading-text">name</th>
                                        <th className="table-heading-text">milestone_date</th>
                                        <th className="table-heading-text">milestone_as_per_actual</th>
                                        <th className="table-heading-text">milestone_as_per_reschedule</th>
                                        <th className="table-heading-text">day</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {excelJson?.map((i, index) => (
                                        <tr key={index} className="modal-padding-heading">
                                            <th className="table-heading-text">{i.name}</th>
                                            <th className="table-heading-text">{i.milestone_date}</th>
                                            <th className="table-heading-text">{i.milestone_as_per_actual}</th>
                                            <th className="table-heading-text">{i.milestone_as_per_reschedule}</th>
                                            <th className="table-heading-text">{i.day}</th>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="flex-column field-cont-div">
                        <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
                            Upload File
                        </label>
                        <label
                            htmlFor="document_file"
                            className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                                }`}
                        >
                            <svg
                                className="pdf-input"
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                                    stroke="#707070"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </label>
                        <input
                            id="document_file"
                            name="document_file"
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileChange}
                            className="file-inputs align-center"
                            style={{ display: "none", position: "relative" }}
                        />
                        {fileName && <p className="file-name align-center">{fileName}</p>}
                        <br />
                        {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
                    </div>
                    <h4>References:</h4>
                    <div className="reference-container">

                        <div className="reference-section">
                            <ul className="arrow-list">
                                <li>All Dates should be in DD-MM-YYYY format</li>

                            </ul>
                        </div>

                    </div>
                    <div className="button-models">
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Upload
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer position="top-center" autoClose={false} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};
const UploadItemsBulk = ({ id, getItem }) => {



    const [show, setShow] = useState(false);
    const [fileName, setFileName] = useState("");
    const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});

    const bulktableRef = useRef(null);
    const handleDownload = () => {
        const table = bulktableRef.current;
        const wb = XLSX.utils.table_to_book(table, { sheet: "Items Details" });
        const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.ms-excel",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Items Details Format.xls";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleClose = () => {
        setFileName("")
        setExcelJson(null)
        setDocErrors({})
        setShow(false)
    };
    const handleShow = () => setShow(true);

    // Function to handle file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check for valid file type
            const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
            if (!validFileTypes.includes(file.type)) {
                setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
                setFileName("");
                return;
            }

            setFileName(file.name);
            readExcel(file); // Convert the file to JSON
        } else {
            setFileName("");
        }
    };

    const readExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0]; // Use the first sheet
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

            const headers = json[0];
            const rows = json.slice(1);



            // Create a formatted JSON object based on headers and row values
            const formattedJson = rows.map((row) => {
                const obj = {};
                headers.forEach((header, index) => {

                    obj[header] = row[index] !== undefined ? row[index] : null;
                });
                return obj;
            });

            // Set the formatted JSON data to state
            setExcelJson(formattedJson);
        };
        reader.readAsArrayBuffer(file);
    };


    // Function to handle the upload button click
    const handleUpload = async () => {
        if (excelJson) {
            const loadingToastId = toast.loading("Uploading: Please wait...");

            try {
                const res = await axios.post(`${BASE_URL}/siteproject/bulksiteinventoryitems/`, excelJson);
                if (res.status === 200) {
                    await getItem();
                    handleClose();
                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                toast.dismiss(loadingToastId);
            }
        } else {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
        }
    };





    return (
        <>

            <button title="Upload" className="model-button   font-weight500   model-button-print" onClick={handleShow} style={{ margin: "2px" }}>
                <UploadIcon />
            </button>

            <Modal show={show} dialogClassName="ourcompany-model">

                <Modal.Body>
                    <div className="flex-row align-center">

                        <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Upload Bulk Site Item List Data in format :</Modal.Title> </h1>


                        <button onClick={handleDownload} className="model-button-download model-button font-weight500">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Format
                        </button>

                    </div>
                    <div className="table-css-white-background" style={{ display: "none" }}>
                        <table ref={bulktableRef} className="nested-table-lightblue">
                            <thead>
                                <tr className="custom-table-head-tr">
                                    <th className="align-center">sub_company</th>
                                    <th className="align-left">item_name</th>


                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th className="align-left">-</th>
                                    <th className="align-center">-</th>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="table-css-white-background">
                        <table className="nested-table-lightblue">
                            <thead>
                                <tr className="custom-table-head-tr">
                                    <th className="align-center">sub_company</th>
                                    <th className="align-left">item_name</th>

                                </tr>
                            </thead>
                            <tbody>
                                {excelJson?.map((item, index) => (
                                    <tr key={index}>
                                        <th className="align-center">{item.sub_company}</th>
                                        <th className="align-left">{item.item_name}</th>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="flex-column field-cont-div">
                        <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
                            Upload File
                        </label>
                        <label
                            htmlFor="document_file"
                            className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                                }`}
                        >
                            <svg
                                className="pdf-input"
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                                    stroke="#707070"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </label>
                        <input
                            id="document_file"
                            name="document_file"
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileChange}
                            className="file-inputs align-center"
                            style={{ display: "none", position: "relative" }}
                        />
                        {fileName && <p className="file-name align-center">{fileName}</p>}
                        <br />
                        {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
                    </div>
                    <div className="button-models">
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Upload
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer position="top-center" autoClose={false} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const UploadBillingBulk = ({ id, getBilling, site_prcode, workperformedby, contractor_name, projectId }) => {



    const [show, setShow] = useState(false);
    const [fileName, setFileName] = useState("");
    const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});
    const [trackRecordList, setTrackRecordList] = useState([]);


    const getLetters = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/letterrecordbclosestatus/${projectId}/${workperformedby}/billing/`);
            setTrackRecordList(res.data);
        } catch (error) {
            handleErrorToast(error);
        }
    }
    useEffect(() => {
        getLetters();
    }, [projectId, workperformedby])

    const bulktableRef = useRef(null);
    const handleDownload = () => {
        const table = bulktableRef.current;
        const wb = XLSX.utils.table_to_book(table, { sheet: "Billing Details" });
        const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.ms-excel",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Billing Details Format.xls";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleClose = () => {
        setFileName("")
        setExcelJson(null)
        setDocErrors({})
        setShow(false)
    };
    const handleShow = () => setShow(true);

    // Function to handle file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check for valid file type
            const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
            if (!validFileTypes.includes(file.type)) {
                setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
                setFileName("");
                return;
            }

            setFileName(file.name);
            readExcel(file); // Convert the file to JSON
        } else {
            setFileName("");
        }
    };

    const readExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0]; // Use the first sheet
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

            const headers = json[0];
            const rows = json.slice(1);

            const convertToYYYYMMDD = (input) => {
                try {
                    let date;

                    // Handle Excel serial dates
                    if (typeof input === "number") {
                        const excelEpoch = new Date(1900, 0, 1); // Excel epoch starts on Jan 1, 1900
                        const daysOffset = input - 1; // Subtract 1 because of leap year bug
                        date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
                    } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
                        // Format: YYYY.MM.DD
                        const [year, month, day] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
                        // Format: DD.MM.YYYY
                        const [day, month, year] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else {
                        // Default parsing for other formats
                        date = new Date(input);
                    }

                    if (isNaN(date.getTime())) {
                        throw new Error('Invalid date format');
                    }

                    // Format the date as YYYY-MM-DD
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                    const day = String(date.getDate()).padStart(2, '0');

                    return `${year}-${month}-${day}`;
                } catch (error) {
                    return null; // Return null for invalid dates
                }
            };

            // Create a formatted JSON object based on headers and row values
            const formattedJson = rows.map((row) => {
                const obj = {};
                headers.forEach((header, index) => {

                    if (["submitted_bill_date", "bill_period_start", "bill_period_end", "site_recomended_bill_date", "recomended_bill_date"].includes(header) && row[index] && typeof row[index] === "number") {
                        obj[header] = convertToYYYYMMDD(row[index]); // Convert date
                    } else {
                        obj[header] = row[index] !== undefined ? row[index] : null;
                    }
                });
                if (site_prcode) {
                    obj["project"] = site_prcode;
                }



                if (contractor_name) {
                    obj["contractor"] = contractor_name;
                }

                return obj;
            });

            // Set the formatted JSON data to state
            setExcelJson(formattedJson);
        };
        reader.readAsArrayBuffer(file);
    };

    // Function to handle the upload button click
    const handleUpload = async () => {
        if (!excelJson) {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
            return;
        }



        const loadingToastId = toast.loading("Uploading: Please wait...");

        try {
            const res = await axios.post(`${BASE_URL}/siteproject/bulkbillingdetail/`, excelJson);
            if (res.status === 200) {
                await getBilling(); // Refresh data after upload
                handleClose(); // Close modal or reset form
            }
        } catch (err) {
            handleErrorToast(err);
            console.log(err)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    console.log(site_prcode);
    console.log(contractor_name)
    console.log(excelJson)





    return (
        <>

            <button title="Upload" className="model-button   font-weight500   model-button-print" onClick={handleShow} style={{ margin: "2px" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                    <g fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                        <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                    </g>
                </svg>
            </button>

            <Modal show={show} dialogClassName="ourcompany-model">

                <Modal.Body>
                    <div className="flex-row align-center">

                        <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Upload Bulk Billing Data in format :</Modal.Title> </h1>


                        <button onClick={handleDownload} className="model-button-download model-button font-weight500">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Format
                        </button>

                    </div>
                    <div className="table-css-white-background" style={{ display: "none" }}>
                        <table ref={bulktableRef} className="nested-table-lightblue">
                            <thead>
                                <tr className="custom-table-head-tr">
                                    <th className="align-left">bill_num</th>
                                    <th className="align-center">bill_type</th>
                                    <th className="align-center">bill_catagory</th>
                                    <th className="align-center">bill_period_start</th>
                                    <th className="align-center">bill_period_end</th>
                                    <th className="align-center">submitted_bill_date</th>
                                    <th className="align-center">work_done_amt</th>
                                    <th className="align-center">escalation</th>
                                    <th className="align-center">gst</th>
                                    <th className="align-center">contractor_deduction_amt</th>
                                    <th className="align-center">submitted_bill_amount</th>
                                    <th className="align-center">submitted_percentage</th>
                                    <th className="align-center">site_percentage_amt</th>
                                    <th className="align-center">submitted_letter_num</th>
                                    <th className="align-center">site_recomended_bill_date</th>
                                    <th className="align-center">site_ld_amount</th>
                                    <th className="align-center">site_withheld_amt</th>
                                    <th className="align-center">site_work_done_amt</th>
                                    <th className="align-center">site_escalation</th>
                                    <th className="align-center">site_gst</th>
                                    <th className="align-center">site_deduction_amount</th>
                                    <th className="align-center">site_recommended_bill_amount</th>
                                    <th className="align-center">site_recommended_percentage</th>
                                    <th className="align-center">site_percentage_amt</th>
                                    <th className="align-center">site_released_withheld_amt</th>
                                    <th className="align-center">remark</th>
                                    <th className="align-center">recomended_bill_date</th>
                                    <th className="align-right">ho_work_done_amt</th>
                                    <th className="align-right">ho_escalation</th>
                                    <th className="align-right">ho_gst</th>
                                    <th className="align-right">deduction_amount</th>
                                    <th className="align-right">recommended_bill_amount</th>
                                    <th className="align-right">recommended_percentage</th>
                                    <th className="align-right">ho_percentage_amt</th>
                                    <th className="align-right">ld_amount</th>
                                    <th className="align-right">withheld_amt</th>
                                    <th className="align-right">released_withheld_amt</th>
                                    <th className="align-right">recomended_letter_num</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th className="align-left">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-right">-</th>
                                    <th className="align-right">-</th>
                                    <th className="align-right">-</th>
                                    <th className="align-right">-</th>
                                    <th className="align-right">-</th>
                                    <th className="align-right">-</th>
                                    <th className="align-right">-</th>
                                    <th className="align-right">-</th>
                                    <th className="align-right">-</th>
                                    <th className="align-right">-</th>
                                    <th className="align-right">-</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="table-css-white-background">
                        <table className="nested-table-lightblue">
                            <thead>
                                <tr className="custom-table-head-tr">
                                    <th className="align-left">bill_num</th>
                                    <th className="align-center">bill_type</th>
                                    <th className="align-center">bill_catagory</th>
                                    <th className="align-center">bill_period_start</th>
                                    <th className="align-center">bill_period_end</th>
                                    <th className="align-center">submitted_bill_date</th>
                                    <th className="align-center">work_done_amt</th>
                                    <th className="align-center">escalation</th>
                                    <th className="align-center">gst</th>
                                    <th className="align-center">contractor_deduction_amt</th>
                                    <th className="align-center">submitted_bill_amount</th>
                                    <th className="align-center">submitted_percentage</th>
                                    <th className="align-center">site_percentage_amt</th>
                                    <th className="align-center">submitted_letter_num</th>
                                    <th className="align-center">site_recomended_bill_date</th>
                                    <th className="align-center">site_ld_amount</th>
                                    <th className="align-center">site_withheld_amt</th>
                                    <th className="align-center">site_work_done_amt</th>
                                    <th className="align-center">site_escalation</th>
                                    <th className="align-center">site_gst</th>
                                    <th className="align-center">site_deduction_amount</th>
                                    <th className="align-center">site_recommended_bill_amount</th>
                                    <th className="align-center">site_recommended_percentage</th>
                                    <th className="align-center">site_percentage_amt</th>
                                    <th className="align-center">site_released_withheld_amt</th>
                                    <th className="align-center">remark</th>
                                    <th className="align-center">recomended_bill_date</th>
                                    <th className="align-right">ho_work_done_amt</th>
                                    <th className="align-right">ho_escalation</th>
                                    <th className="align-right">ho_gst</th>
                                    <th className="align-right">deduction_amount</th>
                                    <th className="align-right">recommended_bill_amount</th>
                                    <th className="align-right">recommended_percentage</th>
                                    <th className="align-right">ho_percentage_amt</th>
                                    <th className="align-right">ld_amount</th>
                                    <th className="align-right">withheld_amt</th>
                                    <th className="align-right">released_withheld_amt</th>
                                    <th className="align-right">recomended_letter_num</th>
                                </tr>
                            </thead>
                            <tbody>
                                {excelJson?.map((bills, index) => (
                                    <tr key={index}>
                                        <th className="align-left">{bills.bill_num}</th>
                                        <th className="align-center">{bills.bill_type}</th>
                                        <th className="align-center">{bills.bill_catagory}</th>
                                        <th className="align-center">{bills.bill_period_start}</th>
                                        <th className="align-center">{bills.bill_period_end}</th>
                                        <th className="align-center">{bills.submitted_bill_date}</th>
                                        <th className="align-center">{bills.work_done_amt}</th>
                                        <th className="align-center">{bills.escalation}</th>
                                        <th className="align-center">{bills.gst}</th>
                                        <th className="align-center">{bills.contractor_deduction_amt}</th>
                                        <th className="align-center">{bills.submitted_bill_amount}</th>
                                        <th className="align-center">{bills.submitted_percentage}</th>
                                        <th className="align-center">{bills.site_percentage_amt}</th>
                                        <th className="align-center">{bills.submitted_letter_num}</th>
                                        <th className="align-center">{bills.site_recomended_bill_date}</th>
                                        <th className="align-center">{bills.site_ld_amount}</th>
                                        <th className="align-center">{bills.site_withheld_amt}</th>
                                        <th className="align-center">{bills.site_work_done_amt}</th>
                                        <th className="align-center">{bills.site_escalation}</th>
                                        <th className="align-center">{bills.site_gst}</th>
                                        <th className="align-center">{bills.site_deduction_amount}</th>
                                        <th className="align-center">{bills.site_recommended_bill_amount}</th>
                                        <th className="align-center">{bills.site_recommended_percentage}</th>
                                        <th className="align-center">{bills.site_percentage_amt}</th>
                                        <th className="align-center">{bills.site_released_withheld_amt}</th>
                                        <th className="align-center">{bills.remark}</th>
                                        <th className="align-center">{bills.recomended_bill_date}</th>
                                        <th className="align-right">{bills.ho_work_done_amt}</th>
                                        <th className="align-right">{bills.ho_escalation}</th>
                                        <th className="align-right">{bills.ho_gst}</th>
                                        <th className="align-right">{bills.deduction_amount}</th>
                                        <th className="align-right">{bills.recommended_bill_amount}</th>
                                        <th className="align-right">{bills.recommended_percentage}</th>
                                        <th className="align-right">{bills.ho_percentage_amt}</th>
                                        <th className="align-right">{bills.ld_amount}</th>
                                        <th className="align-right">{bills.withheld_amt}</th>
                                        <th className="align-right">{bills.released_withheld_amt}</th>
                                        <th className="align-right">{bills.recomended_letter_num}</th>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="flex-column field-cont-div">
                        <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
                            Upload File
                        </label>
                        <label
                            htmlFor="document_file"
                            className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                                }`}
                        >
                            <svg
                                className="pdf-input"
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                                    stroke="#707070"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </label>
                        <input
                            id="document_file"
                            name="document_file"
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileChange}
                            className="file-inputs align-center"
                            style={{ display: "none", position: "relative" }}
                        />
                        {fileName && <p className="file-name align-center">{fileName}</p>}
                        <br />
                        {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
                    </div>
                    {/* <h4>References:</h4>
                    <div className="flex-row justify-between" style={{ alignItems: "baseline" }}>
                        <div>
                            <ul>
                                <li>Employee Code should be Valid </li>
                                <li>All Dates should be in YYYY/MM/DD format</li>
                                <li>The item name should match exactly with the names in the Item List.</li>

                            </ul>
                        </div>

                    </div> */}
                    <div className="button-models">
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Upload
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer position="top-center" autoClose={false} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const UploadInsuranceBulk = ({ getInsurance, site_prcode, workperformedby, projectData }) => {



    const [show, setShow] = useState(false);
    const [fileName, setFileName] = useState("");
    const [excelJson, setExcelJson] = useState(null);
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});
    const bulktableRef = useRef(null);
    const handleDownload = () => {
        const table = bulktableRef.current;
        const wb = XLSX.utils.table_to_book(table, { sheet: "Insurance Details" });
        const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.ms-excel",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Insurance Details Format.xls";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleClose = () => {
        setFileName("")
        setExcelJson(null)
        setDocErrors({})
        setShow(false)
    };
    const handleShow = () => setShow(true);

    // Function to handle file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check for valid file type
            const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
            if (!validFileTypes.includes(file.type)) {
                setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
                setFileName("");
                return;
            }

            setFileName(file.name);
            readExcel(file); // Convert the file to JSON
        } else {
            setFileName("");
        }
    };

    // The checkForDuplicates function outside
    const checkForDuplicates = (data) => {
        const insuranceNumbers = new Map();
        const duplicates = [];

        // Track positions of each insurance number
        data.forEach((i, index) => {
            const policyNumber = i.insurance_policy_num;
            if (insuranceNumbers.has(policyNumber)) {
                // If the insurance number already exists, add the current position to its list
                insuranceNumbers.get(policyNumber).push(index + 1); // index + 1 for 1-based position
            } else {
                // If it's the first time seeing this insurance number, initialize its position list
                insuranceNumbers.set(policyNumber, [index + 1]);
            }
        });

        // Now, filter out only the numbers that appear more than once
        insuranceNumbers.forEach((positions, policyNumber) => {
            if (positions.length > 1) {
                duplicates.push(`\nPolicy Number:${policyNumber} is found in position(s) ${positions.join(", ")}`);
            }
        });

        return duplicates;
    };

    // The readExcel function
    const readExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0]; // Use the first sheet
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

            const headers = json[0];
            const rows = json.slice(1);

            // Date conversion function
            const convertToYYYYMMDD = (input) => {
                try {
                    let date;

                    // Handle Excel serial dates
                    if (typeof input === "number") {
                        const excelEpoch = new Date(1900, 0, 1); // Excel epoch starts on Jan 1, 1900
                        const daysOffset = input - 1; // Subtract 1 because of leap year bug
                        date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
                    } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
                        // Format: YYYY.MM.DD
                        const [year, month, day] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
                        // Format: DD.MM.YYYY
                        const [day, month, year] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else {
                        // Default parsing for other formats
                        date = new Date(input);
                    }

                    if (isNaN(date.getTime())) {
                        throw new Error('Invalid date format');
                    }

                    // Format the date as YYYY-MM-DD
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                    const day = String(date.getDate()).padStart(2, '0');

                    return `${year}-${month}-${day}`;
                } catch (error) {
                    return null; // Return null for invalid dates
                }
            };

            // Create a formatted JSON object based on headers and row values
            const formattedJson = rows.map((row) => {
                const obj = {};
                headers.forEach((header, index) => {

                    if (["insurance_policy_start_date", "insurance_policy_valid_upto_date"].includes(header) && row[index] && typeof row[index] === "number") {
                        obj[header] = convertToYYYYMMDD(row[index]); // Convert date
                    } else {
                        obj[header] = row[index] !== undefined ? row[index] : null;
                    }
                });
                // Optional additional fields if available
                if (site_prcode) {
                    obj["project"] = site_prcode;
                }

                if (workperformedby) {
                    obj["workperformedby"] = workperformedby;
                }

                return obj;
            });

            // Check for duplicates using the external function
            const duplicates = checkForDuplicates(formattedJson);

            if (duplicates.length > 0) {
                // Toast notification with line breaks for each duplicate
                toast.error(
                    `Duplicate Insurance Numbers found:\n${duplicates.join("\n")}`,
                    {
                        autoClose: 5000, // Close toast after 5 seconds
                    }
                );
            }

            // Set the formatted JSON data to state
            setExcelJson(formattedJson);
        };
        reader.readAsArrayBuffer(file);
    };

    const existingPolicy = projectData?.insurance?.map(record => record.insurance_policy_num);


    const handleUpload = async () => {
        if (!excelJson) {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
            return;
        }
        const duplicates = checkForDuplicates(excelJson);

        if (duplicates.length > 0) {
            toast.error(`Duplicate Data found! Policy Number ${duplicates.join(", ")}`, {
                autoClose: 5000,
            });
        }


        const duplicatePolicies = excelJson.filter(
            (item) => existingPolicy.includes(String(item.insurance_policy_num).trim())
        );

        if (duplicatePolicies.length > 0) {
            const duplicateNumbers = duplicatePolicies
                .map((record) => record.insurance_policy_num)
                .join(", ");
            toast.error(<>The  policy <b>{duplicateNumbers}</b> already exist in <b>{site_prcode}</b> </>);
            return;
        }

        const loadingToastId = toast.loading("Uploading: Please wait...");

        try {
            const res = await axios.post(`${BASE_URL}/siteproject/insurancebulk/`, excelJson);
            if (res.status === 200) {
                await getInsurance(); // Refresh data after upload
                handleClose(); // Close modal or reset form
                toast.success("Insurance data uploaded successfully.");
                toast.dismiss(loadingToastId);

            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };


    console.log(site_prcode)





    return (
        <>

            <button title="Upload" className="model-button   font-weight500   model-button-print" onClick={handleShow} style={{ margin: "2px" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                    <g fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                        <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                    </g>
                </svg>
            </button>

            <Modal show={show} dialogClassName="ourcompany-model">

                <Modal.Body>
                    <div className="flex-row align-center">

                        <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Upload Bulk Insurance Data in format :</Modal.Title> </h1>


                        <button onClick={handleDownload} className="model-button-download model-button font-weight500">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Format
                        </button>

                    </div>
                    <div className="table-css-white-background" style={{ display: "none" }}>
                        <table ref={bulktableRef} className="nested-table-lightblue">
                            <thead>
                                <tr className="custom-table-head-tr">

                                    <th className="align-left">insurance_policy_num</th>
                                    <th className="align-left">insurance_name</th>
                                    <th className="align-center">insurance_company_name</th>
                                    <th className="align-left">insurance_policy_start_date</th>
                                    <th className="align-center">insurance_policy_valid_upto_date</th>
                                    <th className="align-center">insurance_amount</th>



                                </tr>
                            </thead>
                            <tbody>
                                <tr>

                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="table-css-white-background scroll-container"
                    >
                        <div className="table-container scrollbar" style={{ width: "100%" }}>
                            <table className="nested-table-lightblue" style={{ margin: "0px" }}>
                                <thead className="table-heading">

                                    <tr className="custom-table-head-tr modal-padding-heading">

                                        <th className="table-heading-text">Insurance Policy Number</th>
                                        <th className="table-heading-text">Insurance Name</th>
                                        <th className="table-heading-text">Insurance Company Name</th>
                                        <th className="table-heading-text">Policy Start Date</th>
                                        <th className="table-heading-text">Policy Valid Upto</th>
                                        <th className="table-heading-text">Insurance Amount</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {excelJson?.map((inventory, index) => (
                                        <tr key={index} className="modal-padding-heading">

                                            <th className="table-heading-text">{inventory.insurance_policy_num}</th>
                                            <th className="table-heading-text">{inventory.insurance_name}</th>
                                            <th className="table-heading-text">{inventory.insurance_company_name}</th>
                                            <th className="table-heading-text">{inventory.insurance_policy_start_date}</th>
                                            <th className="table-heading-text">{inventory.insurance_policy_valid_upto_date}</th>
                                            <th className="table-heading-text">{inventory.insurance_amount}</th>


                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="flex-column field-cont-div">
                        <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
                            Upload File
                        </label>
                        <label
                            htmlFor="document_file"
                            className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                                }`}
                        >
                            <svg
                                className="pdf-input"
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                                    stroke="#707070"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </label>
                        <input
                            id="document_file"
                            name="document_file"
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileChange}
                            className="file-inputs align-center"
                            style={{ display: "none", position: "relative" }}
                        />
                        {fileName && <p className="file-name align-center">{fileName}</p>}
                        <br />
                        {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
                    </div>
                    <h4>References:</h4>
                    <div className="reference-container">
                        <div className="reference-section">
                            <p className="reference-title">General:</p>
                            <ul className="arrow-list">

                                <li>Insurance policy number should be unique</li>
                                <li>All Dates should be in DD-MM-YYYY format</li>

                            </ul>
                        </div>
                    </div>
                    <div className="button-models">
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Upload
                        </button>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>

        </>
    );
};
const UploadBGBulk = ({ getBankGuarantee, site_prcode, workperformedby, projectData }) => {



    const [show, setShow] = useState(false);
    const [fileName, setFileName] = useState("");
    const [excelJson, setExcelJson] = useState(null);
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});




    const bulktableRef = useRef(null);
    const handleDownload = () => {
        const table = bulktableRef.current;
        const wb = XLSX.utils.table_to_book(table, { sheet: "Bank Guarantee Details" });
        const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.ms-excel",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Bank Guarantee Details Format.xls";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleClose = () => {
        setFileName("")
        setExcelJson(null)
        setDocErrors({})
        setShow(false)
    };
    const handleShow = () => setShow(true);

    // Function to handle file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check for valid file type
            const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
            if (!validFileTypes.includes(file.type)) {
                setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
                setFileName("");
                return;
            }

            setFileName(file.name);
            readExcel(file); // Convert the file to JSON
        } else {
            setFileName("");
        }
    };

    const readExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0]; // Use the first sheet
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

            const headers = json[0];
            const rows = json.slice(1);

            const convertToYYYYMMDD = (input) => {
                try {
                    let date;

                    // Handle Excel serial dates
                    if (typeof input === "number") {
                        const excelEpoch = new Date(1900, 0, 1); // Excel epoch starts on Jan 1, 1900
                        const daysOffset = input - 1; // Subtract 1 because of leap year bug
                        date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
                    } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
                        // Format: YYYY.MM.DD
                        const [year, month, day] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
                        // Format: DD.MM.YYYY
                        const [day, month, year] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else {
                        // Default parsing for other formats
                        date = new Date(input);
                    }

                    if (isNaN(date.getTime())) {
                        throw new Error('Invalid date format');
                    }

                    // Format the date as YYYY-MM-DD
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                    const day = String(date.getDate()).padStart(2, '0');

                    return `${year}-${month}-${day}`;
                } catch (error) {
                    return null; // Return null for invalid dates
                }
            };

            // Create a formatted JSON object based on headers and row values
            const formattedJson = rows.map((row) => {
                const obj = {};
                headers.forEach((header, index) => {

                    if (["bg_date", "bg_expiry_date", "bg_release_date"].includes(header) && row[index] && typeof row[index] === "number") {
                        obj[header] = convertToYYYYMMDD(row[index]); // Convert date
                    } else {
                        obj[header] = row[index] !== undefined ? row[index] : null;
                    }
                });
                if (site_prcode) {
                    obj["project"] = site_prcode;
                }

                if (workperformedby) {
                    obj["workperformedby"] = workperformedby;

                }
                return obj;
            });

            // Set the formatted JSON data to state
            setExcelJson(formattedJson);
        };
        reader.readAsArrayBuffer(file);
    };
    // Function to handle the upload button click

    const existingBG = projectData?.bgdetails?.map(record => record.bg_num);

    const handleUpload = async () => {
        if (!excelJson) {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
            return;
        }
        const duplicateBG = excelJson.filter(
            (item) => existingBG.includes(String(item.bg_num).trim())
        );

        if (duplicateBG.length > 0) {
            const duplicateNumbers = duplicateBG
                .map((record) => record.bg_num)
                .join(", ");
            toast.error(<>The  BG <b>{duplicateNumbers}</b> already exist in <b>{site_prcode}</b> </>);
            return;
        }




        const loadingToastId = toast.loading("Uploading: Please wait...");

        try {
            const res = await axios.post(`${BASE_URL}/siteproject/bgbulkupload/`, excelJson);
            if (res.status === 200) {
                await getBankGuarantee(); // Refresh data after upload
                handleClose(); // Close modal or reset form
                toast.success("BG data uploaded successfully.");
                toast.dismiss(loadingToastId);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    console.log(site_prcode)





    return (
        <>

            <button title="Upload" className="model-button   font-weight500   model-button-print" onClick={handleShow} style={{ margin: "2px" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                    <g fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                        <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                    </g>
                </svg>
            </button>

            <Modal show={show} dialogClassName="ourcompany-model">

                <Modal.Body>
                    <div className="flex-row align-center">

                        <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Upload Bulk Bank Guarantee Data in format :</Modal.Title> </h1>


                        <button onClick={handleDownload} className="model-button-download model-button font-weight500">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Format
                        </button>

                    </div>
                    <div className="table-css-white-background" style={{ display: "none" }}>
                        <table ref={bulktableRef} className="nested-table-lightblue">
                            <thead>
                                <tr className="custom-table-head-tr">

                                    <th className="align-left">bg_num</th>
                                    <th className="align-left">bank_name</th>
                                    <th className="align-center">bg_date</th>
                                    <th className="align-left">bg_expiry_date</th>
                                    <th className="align-center">bg_release_date</th>
                                    <th className="align-center">bg_amount</th>
                                    <th className="align-center">bg_remark</th>



                                </tr>
                            </thead>
                            <tbody>
                                <tr>

                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="table-css-white-background">
                        <table className="nested-table-lightblue">
                            <thead>
                                <tr className="custom-table-head-tr">

                                    <th className="align-center">bg_num</th>
                                    <th className="align-left">bank_name</th>
                                    <th className="align-center">bg_date</th>
                                    <th className="align-left">bg_expiry_date</th>
                                    <th className="align-center">bg_release_date</th>
                                    <th className="align-center">bg_amount</th>
                                    <th className="align-center">bg_remark</th>

                                </tr>
                            </thead>
                            <tbody>
                                {excelJson?.map((inventory, index) => (
                                    <tr key={index}>

                                        <th className="align-left">{inventory.bg_num}</th>
                                        <th className="align-left">{inventory.bank_name}</th>
                                        <th className="align-center">{inventory.bg_date}</th>
                                        <th className="align-left">{inventory.bg_expiry_date}</th>
                                        <th className="align-center">{inventory.bg_release_date}</th>
                                        <th className="align-center">{inventory.bg_amount}</th>
                                        <th className="align-center">{inventory.bg_remark}</th>


                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="flex-column field-cont-div">
                        <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
                            Upload File
                        </label>
                        <label
                            htmlFor="document_file"
                            className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                                }`}
                        >
                            <svg
                                className="pdf-input"
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                                    stroke="#707070"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </label>
                        <input
                            id="document_file"
                            name="document_file"
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileChange}
                            className="file-inputs align-center"
                            style={{ display: "none", position: "relative" }}
                        />
                        {fileName && <p className="file-name align-center">{fileName}</p>}
                        <br />
                        {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
                    </div>
                    <h4>References:</h4>
                    <div className="flex-row justify-between" style={{ alignItems: "baseline" }}>
                        <div>
                            <ul>

                                <li>Bank Guarantee Number Should be Unique</li>
                                <li>All Dates should be in YYYY/MM/DD format</li>

                            </ul>
                        </div>

                    </div>
                    <div className="button-models">
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Upload
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer position="top-center" autoClose={false} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};
const UploadBulkContractor = ({ getdetails, getContractor, site_prcode, getProject }) => {



    const [show, setShow] = useState(false);
    const [fileName, setFileName] = useState("");
    const [excelJson, setExcelJson] = useState(null);
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});




    const bulktableRef = useRef(null);
    const handleDownload = () => {
        const table = bulktableRef.current;
        const wb = XLSX.utils.table_to_book(table, { sheet: "Contractor Details Details" });
        const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.ms-excel",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Contractor Details Details Format.xls";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleClose = () => {
        setFileName("")
        setExcelJson(null)
        setDocErrors({})
        setShow(false)
    };
    const handleShow = () => setShow(true);

    // Function to handle file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check for valid file type
            const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
            if (!validFileTypes.includes(file.type)) {
                setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
                setFileName("");
                return;
            }

            setFileName(file.name);
            readExcel(file); // Convert the file to JSON
        } else {
            setFileName("");
        }
    };

    const readExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0]; // Use the first sheet
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

            const headers = json[0];
            const rows = json.slice(1);

            const convertToYYYYMMDD = (input) => {
                try {
                    let date;

                    // Handle Excel serial dates
                    if (typeof input === "number") {
                        const excelEpoch = new Date(1900, 0, 1); // Excel epoch starts on Jan 1, 1900
                        const daysOffset = input - 1; // Subtract 1 because of leap year bug
                        date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
                    } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
                        // Format: YYYY.MM.DD
                        const [year, month, day] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
                        // Format: DD.MM.YYYY
                        const [day, month, year] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else {
                        // Default parsing for other formats
                        date = new Date(input);
                    }

                    if (isNaN(date.getTime())) {
                        throw new Error('Invalid date format');
                    }

                    // Format the date as YYYY-MM-DD
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                    const day = String(date.getDate()).padStart(2, '0');

                    return `${year}-${month}-${day}`;
                } catch (error) {
                    return null; // Return null for invalid dates
                }
            };

            // Create a formatted JSON object based on headers and row values
            const formattedJson = rows.map((row) => {
                const obj = {};
                headers.forEach((header, index) => {

                    if (["contractor_bid_due_date", "loa_award_date", "agreement_date", "commencement_date", "actual_completion_date", "schedule_completion_date", "actual_construction_completion_date", "schedule_construction_completion_date"].includes(header) && row[index] && typeof row[index] === "number") {
                        obj[header] = convertToYYYYMMDD(row[index]); // Convert date
                    } else {
                        obj[header] = row[index] !== undefined ? row[index] : null;
                    }
                });
                if (site_prcode) {
                    obj["project"] = site_prcode;
                }


                return obj;
            });

            // Set the formatted JSON data to state
            setExcelJson(formattedJson);
        };
        reader.readAsArrayBuffer(file);
    };
    // Function to handle the upload button click


    const handleUpload = async () => {
        if (!excelJson) {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
            return;
        }





        const loadingToastId = toast.loading("Uploading: Please wait...");

        try {
            const res = await axios.post(`${BASE_URL}/siteproject/bulkcontractor/`, excelJson);
            if (res.status === 200) {
                await getContractor(); // Refresh data after upload
                handleClose(); // Close modal or reset form
                toast.success("Contractor data uploaded successfully.");
                toast.dismiss(loadingToastId);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    console.log(site_prcode)





    return (
        <>

            <button title="Upload" className="model-button   font-weight500   model-button-print" onClick={handleShow} style={{ margin: "2px" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                    <g fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                        <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                    </g>
                </svg>
            </button>

            <Modal show={show} dialogClassName="ourcompany-model">

                <Modal.Body>
                    <div className="flex-row align-center">

                        <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Upload Bulk Contractor Data in format :</Modal.Title> </h1>


                        <button onClick={handleDownload} className="model-button-download model-button font-weight500">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Format
                        </button>

                    </div>
                    <div className="table-css-white-background" style={{ display: "none" }}>
                        <table ref={bulktableRef} className="nested-table-lightblue">
                            <thead>
                                <tr className="custom-table-head-tr">

                                    <th className="align-left">name</th>
                                    <th className="align-left">cost</th>
                                    <th className="align-center">project_length</th>
                                    <th className="align-left">contractor_bid_due_date</th>
                                    <th className="align-center">loa_award_date</th>
                                    <th className="align-center">agreement_date</th>
                                    <th className="align-center">project_duration</th>
                                    <th className="align-center">commencement_date</th>
                                    <th className="align-center">actual_completion_date</th>
                                    <th className="align-center">schedule_completion_date</th>
                                    <th className="align-center">actual_construction_completion_date</th>
                                    <th className="align-center">schedule_construction_completion_date</th>
                                    <th className="align-center">contractor_address</th>



                                </tr>
                            </thead>
                            <tbody>
                                <tr>

                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="table-css-white-background">
                        <table className="nested-table-lightblue">
                            <thead>
                                <tr className="custom-table-head-tr">

                                    <th className="align-center">name</th>
                                    <th className="align-left">cost</th>
                                    <th className="align-center">project_length</th>
                                    <th className="align-left">contractor_bid_due_date</th>
                                    <th className="align-center">loa_award_date</th>
                                    <th className="align-center">agreement_date</th>
                                    <th className="align-center">commencement_date</th>
                                    <th className="align-center">actual_completion_date</th>
                                    <th className="align-center">schedule_completion_date</th>
                                    <th className="align-center">actual_construction_completion_date</th>
                                    <th className="align-center">schedule_construction_completion_date</th>
                                    <th className="align-center">contractor_address</th>

                                </tr>
                            </thead>
                            <tbody>
                                {excelJson?.map((inventory, index) => (
                                    <tr key={index}>

                                        <th className="align-left">{inventory.name}</th>
                                        <th className="align-left">{inventory.cost}</th>
                                        <th className="align-center">{inventory.project_length}</th>
                                        <th className="align-left">{inventory.contractor_bid_due_date}</th>
                                        <th className="align-center">{inventory.loa_award_date}</th>
                                        <th className="align-center">{inventory.agreement_date}</th>
                                        <th className="align-center">{inventory.commencement_date}</th>
                                        <th className="align-center">{inventory.actual_completion_date}</th>
                                        <th className="align-center">{inventory.schedule_completion_date}</th>
                                        <th className="align-center">{inventory.actual_construction_completion_date}</th>
                                        <th className="align-center">{inventory.schedule_construction_completion_date}</th>
                                        <th className="align-center">{inventory.contractor_address}</th>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="flex-column field-cont-div">
                        <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
                            Upload File
                        </label>
                        <label
                            htmlFor="document_file"
                            className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                                }`}
                        >
                            <svg
                                className="pdf-input"
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                                    stroke="#707070"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </label>
                        <input
                            id="document_file"
                            name="document_file"
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileChange}
                            className="file-inputs align-center"
                            style={{ display: "none", position: "relative" }}
                        />
                        {fileName && <p className="file-name align-center">{fileName}</p>}
                        <br />
                        {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
                    </div>
                    <h4>References:</h4>
                    <div className="flex-row justify-between" style={{ alignItems: "baseline" }}>
                        <div>
                            <ul>

                                <li>All Dates should be in YYYY/MM/DD format</li>

                            </ul>
                        </div>

                    </div>
                    <div className="button-models">
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Upload
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer position="top-center" autoClose={false} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};
const UploadSiteProgressBulk = ({ getProgress, site_prcode, contractor_name }) => {



    const [show, setShow] = useState(false);
    const [fileName, setFileName] = useState("");
    const [excelJson, setExcelJson] = useState(null);
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});




    const bulktableRef = useRef(null);
    const handleDownload = () => {
        const table = bulktableRef.current;
        const wb = XLSX.utils.table_to_book(table, { sheet: "Site Progress Details Details" });
        const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.ms-excel",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Site Progress Details Details Format.xls";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleClose = () => {
        setFileName("")
        setExcelJson(null)
        setDocErrors({})
        setShow(false)
    };
    const handleShow = () => setShow(true);

    // Function to handle file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check for valid file type
            const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
            if (!validFileTypes.includes(file.type)) {
                setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
                setFileName("");
                return;
            }

            setFileName(file.name);
            readExcel(file); // Convert the file to JSON
        } else {
            setFileName("");
        }
    };

    const readExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0]; // Use the first sheet
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

            const headers = json[0];
            const rows = json.slice(1);

            const convertToYYYYMMDD = (input) => {
                try {
                    let date;

                    // Handle Excel serial dates
                    if (typeof input === "number") {
                        const excelEpoch = new Date(1900, 0, 1); // Excel epoch starts on Jan 1, 1900
                        const daysOffset = input - 1; // Subtract 1 because of leap year bug
                        date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
                    } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
                        // Format: YYYY.MM.DD
                        const [year, month, day] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
                        // Format: DD.MM.YYYY
                        const [day, month, year] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else {
                        // Default parsing for other formats
                        date = new Date(input);
                    }

                    if (isNaN(date.getTime())) {
                        throw new Error('Invalid date format');
                    }

                    // Format the date as YYYY-MM-DD
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                    const day = String(date.getDate()).padStart(2, '0');

                    return `${year}-${month}-${day}`;
                } catch (error) {
                    return null; // Return null for invalid dates
                }
            };

            // Create a formatted JSON object based on headers and row values
            const formattedJson = rows.map((row) => {
                const obj = {};
                headers.forEach((header, index) => {

                    if (["bg_date", "bg_expiry_date", "bg_release_date"].includes(header) && row[index] && typeof row[index] === "number") {
                        obj[header] = convertToYYYYMMDD(row[index]); // Convert date
                    } else {
                        obj[header] = row[index] !== undefined ? row[index] : null;
                    }
                });
                if (site_prcode) {
                    obj["project"] = site_prcode;
                }
                if (contractor_name) {
                    obj["contractor"] = contractor_name;
                }


                return obj;
            });

            // Set the formatted JSON data to state
            setExcelJson(formattedJson);
        };
        reader.readAsArrayBuffer(file);
    };
    // Function to handle the upload button click


    const handleUpload = async () => {
        if (!excelJson) {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
            return;
        }




        const loadingToastId = toast.loading("Uploading: Please wait...");

        try {
            const res = await axios.post(`${BASE_URL}/siteproject/progressbulkupload/`, excelJson);
            if (res.status === 200) {
                await getProgress(); // Refresh data after upload
                handleClose(); // Close modal or reset form
                toast.success("Progress uploaded successfully.");
                toast.dismiss(loadingToastId);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    console.log(site_prcode)





    return (
        <>

            <button title="Upload" className="model-button   font-weight500   model-button-print" onClick={handleShow} style={{ margin: "2px" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                    <g fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                        <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                    </g>
                </svg>
            </button>

            <Modal show={show} dialogClassName="ourcompany-model">

                <Modal.Body>
                    <div className="flex-row align-center">

                        <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Upload Bulk Site Progress Data in format :</Modal.Title> </h1>


                        <button onClick={handleDownload} className="model-button-download model-button font-weight500">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Format
                        </button>

                    </div>
                    <div className="table-css-white-background" style={{ display: "none" }}>
                        <table ref={bulktableRef} className="nested-table-lightblue" style={{ margin: "0px" }}>
                            <thead>
                                <tr className="custom-table-head-tr">

                                    <th className="align-left">month</th>
                                    <th className="align-left">year</th>
                                    <th className="align-left">physical_progress</th>
                                    <th className="align-center">financial_progress</th>



                                </tr>
                            </thead>
                            <tbody>
                                <tr>

                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>
                                    <th className="align-center">-</th>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="table-css-white-background scroll-container">
                        <div className="table-container scrollbar" style={{ width: "100%" }}>

                            <table className="nested-table-lightblue" style={{ margin: "0px" }}>
                                <thead>
                                    <tr className="custom-table-head-tr modal-padding-heading">


                                        <th className="table-heading-text">month</th>
                                        <th className="table-heading-text">year</th>
                                        <th className="table-heading-text">physical_progress</th>
                                        <th className="table-heading-text">financial_progress</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {excelJson?.map((inventory, index) => (
                                        <tr key={index} className="modal-padding-heading">

                                            <th className="table-heading-text">{inventory.month}</th>
                                            <th className="table-heading-text">{inventory.year}</th>
                                            <th className="table-heading-text">{inventory.physical_progress}</th>
                                            <th className="table-heading-text">{inventory.financial_progress}</th>


                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>



                    <div className="flex-column field-cont-div">
                        <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
                            Upload File
                        </label>
                        <label
                            htmlFor="document_file"
                            className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                                }`}
                        >
                            <svg
                                className="pdf-input"
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                                    stroke="#707070"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </label>
                        <input
                            id="document_file"
                            name="document_file"
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileChange}
                            className="file-inputs align-center"
                            style={{ display: "none", position: "relative" }}
                        />
                        {fileName && <p className="file-name align-center">{fileName}</p>}
                        <br />
                        {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
                    </div>
                    <h4>References:</h4>

                    <div className="reference-container">
                        <div className="reference-section">
                            <p className="reference-title">General:</p>
                            <ul className="arrow-list">
                                <li>Month should be in number</li>
                                <li>All progress percentage should be in ascending order</li>

                            </ul>
                        </div>
                    </div>
                    <div className="button-models">
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} Upload
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer position="top-center" autoClose={false} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const DownloadSiteProject = ({ projectList }) => {
    const downloadXLSX = () => {
        if (!projectList || projectList.length === 0) {
            alert("No data available to download!");
            return;
        }
        console.log(projectList, 'Ansh')
        // Define the headers
        const data = [
            ["S.No", "Project Code", "Project Name", "Progress (%)", "Change of Scope", "Extension of Time", "Contractor Name", "Construction Cost (CR)"]
        ];

        // Process data
        projectList.forEach((project, index) => {
            if (project?.contractors?.length > 0) {
                project.contractors.forEach((contractor) => {
                    const progress = contractor.latest_progress?.physical_progress || "-";
                    const cost = contractor.cost ? `₹ ${contractor.cost}` : "-";
                    const changeOfScope = project.change_of_scope || "-";
                    const extensionOfTime = project.extension_of_time || "-";

                    data.push([
                        index + 1,
                        project.site_prcode,
                        project.project_short_name,
                        progress,
                        changeOfScope,
                        extensionOfTime,
                        contractor.name || "-",
                        cost
                    ]);
                });
            } else {
                data.push([
                    index + 1,
                    project.site_prcode,
                    project.project_name,
                    "-",
                    "-",
                    "-",
                    "No Contractor Data",
                    "-"
                ]);
            }
        });

        // Convert data to a worksheet
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(data);
        const colWidths = data.map((col, i) => ({
            wch: Math.max(...data.map(row => (row[i] || "").toString().length), col.length)
        }));

        ws['!cols'] = colWidths;
        XLSX.utils.book_append_sheet(wb, ws, "Projects");

        // Create and trigger the download
        XLSX.writeFile(wb, "project_data.xlsx");
    };

    return (
        <>
            <button onClick={downloadXLSX} title="Download" className="model-button font-weight500 model-button-print" style={{ margin: "2px" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                    <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                        <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                    </g>
                </svg>
            </button>
        </>
    );
};



// ─── helpers ────────────────────────────────────────────────────────────────

const buildProjectRows = (data) =>
    data.map((p, idx) => ({
        "S.No": idx + 1,
        "Site PR Code": p.site_prcode || "",
        "Short Name": p.project_short_name || "",
        "Project Name": p.project_name || "",
        Location: p.location || "",
        "Client Name": p.client_name || "",
        "Work Type": p.work_type || "",
        Status: p.status || "",
        "Contract Mode": p.contract_mode || "",
        "Our Role": p.our_role || "",
        Lead: p.lead || "",
        JV: p.jv || "",
        Association: p.association || "",
        RO: p.ro || "",
        "RO Address": p.ro_address || "",
        "PIU Address": p.piu_address || "",
        "Site Office Address": p.site_office_address || "",
        "Project Length (km)": p.project_length || "",
        "Project Duration (months)": p.project_duration || "",
        "Construction Duration (months)": p.construction_duration || "",
        "O&M Duration (months)": p.om_duration || "",
        "Consultancy Fees": p.consultancy_fees || "",
        "Our Share": p.our_share || "",
        "JV Share": p.jv_share ?? "",
        "LOA Award Date": p.loa_award_date || "",
        "Agreement Date": p.agreement_date || "",
        "Commencement Date": p.commencement_date || p.mobilization || "",
        "Schedule Completion Date": p.schedule_completion_date || "",
        "Schedule Completion Date (EOT)": p.schedule_completion_date_with_eot || "",
        "Actual Completion Date": p.actual_completion_date || "",
        "Schedule Construction Completion Date": p.schedule_construction_completion_date || "",
        "Schedule Construction Completion Date (EOT)": p.schedule_construction_completion_date_with_eot || "",
        "Actual Construction Completion Date": p.actual_construction_completion_date || "",
        "Project Completion Date": p.project_completion_date || "",
        "EOT Days": p.EOT_days ?? "",
        "Coordinator Names": (p.coordinator_names || []).join(", "),
        "Coordinator Emp Codes": (p.coordinator_emp_codes || []).join(", "),
        "Authority Engineer Name": p.authority_engineer_name || "",
        "Concern Person Name": p.concern_person_name || "",
        "Authorized IE/AE": p.athorized_IE_AE || "",
        "GST No": p.gst_no || "",
        "PAN No": p.pan_no || "",
        "Tender ID": p.tender_id || "",
        Remark: p.remark || "",
        "Project Key Point": p.project_key_point || "",
        "Imprest Amount": p.imprest_amount ?? "",
        Escalation: p.esclation || "",
        "Our Services": p.our_services || "",
        "Project Status": p.project_status || "",
        "Created At": p.created_at ? new Date(p.created_at).toLocaleDateString("en-IN") : "",
        "Admin Approval for Delete": p.admin_approval_for_dlt ? "Yes" : "No",
        Lock: p.lock ? "Yes" : "No",
    }));
const buildContractorRows = (data, projectData) => {
    // Build a quick lookup map from project id → project object
    const projectMap = {};
    projectData.forEach((p) => {
        projectMap[p.id] = p;
    });

    return data.map((c, idx) => {
        // Match contractor's project id to project list
        const matchedProject = projectMap[c.project] || null;

        return {
            "S.No": idx + 1,
            // ── Fetched from project API via id match ──
            "Site PR Code": matchedProject?.site_prcode || "",
            "Short Name": matchedProject?.project_short_name || "",
            // ── Contractor fields ──
            "Contractor Name": c.name || "",
            "Cost": c.cost || "",
            "Cost with COS": c.cost_with_cos ?? "",
            "Project Length": c.project_length ?? "",
            "Project Duration": c.project_duration ?? "",
            "Construction Duration": c.construction_duration ?? "",
            "O&M Duration": c.OM_duration ?? "",
            "Contractor Bid Due Date": c.contractor_bid_due_date || "",
            "LOA Award Date": c.loa_award_date || "",
            "Agreement Date": c.agreement_date || "",
            "Commencement Date": c.commencement_date || "",
            "Schedule Completion Date": c.schedule_completion_date || "",
            "Schedule Completion Date (EOT)": c.schedule_completion_date_with_eot || "",
            "Actual Completion Date": c.actual_completion_date || "",
            "Schedule Construction Completion Date": c.schedule_construction_completion_date || "",
            "Schedule Construction Completion Date (EOT)": c.schedule_construction_completion_date_with_eot || "",
            "Actual Construction Completion Date": c.actual_construction_completion_date || "",
            "Contractor Address": c.contractor_address || "",
            "Withheld Release": c.withheld_release ?? "",
            "Contractor Status": c.contractor_status || "",
            "EOT Days": c.EOT_Days ?? "",
            "Lock": c.lock ? "Yes" : "No",
            "Created At": c.created_at ? new Date(c.created_at).toLocaleDateString("en-IN") : "",
        };
    });
};
const buildInsuranceRows = (data) =>
    data.map((ins, idx) => ({
        "S.No": idx + 1,
        "Site PR Code": ins.site_pr_code || "",
        "Short Name": ins.site_project_short_name || "",
        "Insurance Name": ins.insurance_name || "",
        "Insurance Company": ins.insurance_company_name || "",
        "Policy Number": ins.insurance_policy_num || "",
        "Insurance Amount": ins.insurance_amount ?? "",
        "Policy Start Date": ins.insurance_policy_start_date || "",
        "Policy Valid Upto": ins.insurance_policy_valid_upto_date || "",
        Status: ins.status || "",
        "File URL": ins.insurance_file_upload ? "📄 Open File" : "", // ← display text, link applied separately
        Lock: ins.lock ? "Yes" : "No",
        "Created At": ins.created_at ? new Date(ins.created_at).toLocaleDateString("en-IN") : "",
        _fileUrl: ins.insurance_file_upload || "", // ← raw URL stored separately for linking
    }));

const buildBgRows = (data) =>
    data.map((bg, idx) => ({
        "S.No": idx + 1,
        "Site Project Code": bg.site_pr_code,
        "Project Short Name": bg.site_project_short_name,
        "Bank Name": bg.bank_name || "",
        "BG Number": bg.bg_num || "",
        "BG Amount": bg.bg_amount ?? "",
        "BG Date": bg.bg_date || "",
        "BG Expiry Date": bg.bg_expiry_date || "",
        "BG Release Date": bg.bg_release_date || "",
        "Remark": bg.bg_remark || "",
        "Status": bg.status || "",
        "File URL": bg.bg_document ? "📄 Open File" : "",
        "Lock": bg.lock ? "Yes" : "No",
        "Created At": bg.created_at ? new Date(bg.created_at).toLocaleDateString("en-IN") : "",
        _fileUrl: bg.bg_document || "",
    }));

const buildEOTRows = (data, type) => {
    const filtered = data.filter((e) =>
        type === "contractor"
            ? e.workperformedby === "contractor"
            : e.workperformedby !== "contractor"
    );

    return filtered.map((e, idx) => ({
        "S.No": idx + 1,
        "Project Code": e.project_code || "",
        "Short Name": e.project_short_name || "",
        "Work Performed By": e.workperformedby || "",

        "Contractor Name": e.contractor_name || "",
        "EOT Code": e.eot_code || "",
        "Process Initiate Date": e.process_initiate_date || "",
        "AE IE Response Date": e.ae_approved_date || "",
        "AE IE Observation Date": e.ae_ie_observation_date || "",
        "AE IE Rejected Date": e.ae_reject_date || "",
        "Client Approved Date": e.approved_date || "",
        "Client Rejected Date": e.client_rejected_date || "",

        "Days For Approval": e.days || "",
        "AE Approved Days": e.ae_approved_days || "",
        "Client Approved Days": e.approved_days || "",
        "AE EOT Status": e.ae_eot_status || "",

        "Client EOT Status": e.eot_status || "",


        "Lock": e.lock ? "Yes" : "No",
        "Created At": e.created_at
            ? new Date(e.created_at).toLocaleDateString("en-IN")
            : "",
    }));
};

const buildCOSRows = (data, type) => {
    const filtered = data.filter((e) =>
        type === "contractor"
            ? e.workperformedby === "contractor"
            : e.workperformedby !== "contractor"
    );

    return filtered.map((c, idx) => {
        const isNegative = c.cos_type === "negativecos";

        // Helper: prefix "-" if negative cos
        const negVal = (val) => {
            if (val === null || val === undefined || val === "") return "";
            return isNegative ? `-${val}` : `${val}`;
        };

        return {
            "S.No": idx + 1,
            "Project Code": c.project_code || "",
            "Short Name": c.project_short_name || "",
            "Work Performed By": c.workperformedby || "",
            "Contractor Name": c.contractor_name || "",
            "COS Code": c.cos_code || "",
            "COS Type": c.cos_type || "",

            "Amount": negVal(c.amount),
            "Negative Amount": c.negativeamount || "",
            "AE Recommended Amount": negVal(c.ae_approved_amount),   // ← negative prefix
            "In Principle Amount By Client": negVal(c.in_principle_amount_byclient), // ← negative prefix
            "Client Approved Amount": negVal(c.approved_amount),
            "Process Initiate Date": c.process_initiate_date || "",
            "AE Recommended Date": c.ae_approval_date || "",
            "AE Reject Date": c.ae_ie_rejected_date || "",
            "AE IE Observation Date": c.ae_ie_observation_date || "",
            "AE IE Rejected Date": c.ae_ie_rejected_date || "",
            "Client In Principle Date": c.client_in_principle_date || "",
            "Client Approval Date": c.approval_date || "",
            "Client Rejected Date": c.client_rejected_date || "",
            "AE COS Status": c.ae_cos_status || "",
            "COS Status": c.cos_status || "",
            "Lock": c.lock ? "Yes" : "No",
            "Created At": c.created_at
                ? new Date(c.created_at).toLocaleDateString("en-IN")
                : "",
        };
    });
};
const buildMilestoneRows = (data) =>
    data.map((m, idx) => ({
        "S.No": idx + 1,
        "Site PR Code": m.site_prcode || "",
        "Project Name": m.project_name || "",
        "Contractor Name": m.contractor_name || "",
        "Milestone Name": m.name || "",
        "Milestone Date": m.milestone_date || "",
        "Milestone As Per Reschedule": m.milestone_as_per_reschedule || "",
        "Milestone As Per Actual": m.milestone_as_per_actual || "",
        "Day": m.day || "",
        "Reschedule Gap Days": m.rescedule_gap_days || "",
        "Actual Gap Days": m.actual_gap_days || "",
        "Lock": m.lock ? "Yes" : "No",
        "Created At": m.created_at
            ? new Date(m.created_at).toLocaleDateString("en-IN")
            : "",
    }));

const autoColWidths = (rows) =>
    Object.keys(rows[0])
        .filter((k) => !k.startsWith("_")) // skip private fields
        .map((key) => ({
            wch: Math.max(key.length, ...rows.map((r) => String(r[key] ?? "").length)) + 2,
        }));

// Apply clickable hyperlinks to the "File URL" column
// headerRowIndex: the Excel row (0-indexed) where the column header sits
const applyFileUrlLinks = (ws, rows, headerRowIndex, urlColName = "File URL") => {
    const visibleKeys = Object.keys(rows[0]).filter((k) => !k.startsWith("_"));
    const urlColIndex = visibleKeys.indexOf(urlColName);
    if (urlColIndex === -1) return;

    rows.forEach((row, rowIdx) => {
        const url = row._fileUrl;
        if (!url) return;

        const cellRef = XLSX.utils.encode_cell({
            r: headerRowIndex + 1 + rowIdx,
            c: urlColIndex,
        });

        if (ws[cellRef]) {
            ws[cellRef].l = { Target: url, Tooltip: "Click to open file" };
        }
    });
};
const makeSheet = (rows, freezeCols = 3) => {
    // Strip private fields before writing
    const cleanRows = rows.map((r) =>
        Object.fromEntries(Object.entries(r).filter(([k]) => !k.startsWith("_")))
    );
    const ws = XLSX.utils.json_to_sheet(cleanRows);
    ws["!cols"] = autoColWidths(rows);
    ws["!freeze"] = { xSplit: freezeCols, ySplit: 1 };
    return ws;
};

const makeInsuranceSheet = (rows, freezeCols = 3) => {
    const ws = makeSheet(rows, freezeCols);
    // Header is at row 0, data starts at row 1
    applyFileUrlLinks(ws, rows, 0);
    return ws;
};
const makeBgSheet = (rows, freezeCols = 2) => {
    const ws = makeSheet(rows, freezeCols);
    applyFileUrlLinks(ws, rows, 0);
    return ws;
};

const makeCombinedSheet = ({
    projectRows,
    insuranceRows,
    bgRows,
    contractorRows,
    contractorEOTRows,
    consultantEOTRows,
    contractorCOSRows,
    consultantCOSRows,
    contractorMilestoneRows,
    consultantMilestoneRows,
}) => {
    const wb_aoa = [];
    const merges = [];

    const getVisibleKeys = (rows) =>
        rows ? Object.keys(rows[0]).filter((k) => !k.startsWith("_")) : [];

    const visibleProjectKeys = getVisibleKeys(projectRows);
    const visibleInsuranceKeys = getVisibleKeys(insuranceRows);
    const visibleBGKeys = getVisibleKeys(bgRows);
    const visibleContractorKeys = getVisibleKeys(contractorRows);
    const visibleContractorEOTKeys = getVisibleKeys(contractorEOTRows);
    const visibleConsultantEOTKeys = getVisibleKeys(consultantEOTRows);
    const visibleContractorCOSKeys = getVisibleKeys(contractorCOSRows);
    const visibleConsultantCOSKeys = getVisibleKeys(consultantCOSRows);
    const visibleContractorMilestoneKeys = getVisibleKeys(contractorMilestoneRows);
    const visibleConsultantMilestoneKeys = getVisibleKeys(consultantMilestoneRows);

    const totalCols = Math.max(
        visibleProjectKeys.length,
        visibleInsuranceKeys.length,
        visibleBGKeys.length,
        visibleContractorKeys.length,
        visibleContractorEOTKeys.length,
        visibleConsultantEOTKeys.length,
        visibleContractorCOSKeys.length,
        visibleConsultantCOSKeys.length,
        visibleContractorMilestoneKeys.length,
        visibleConsultantMilestoneKeys.length,
        0
    );

    const addSectionHeader = (label) => {
        const startRow = wb_aoa.length;
        for (let i = 0; i < 4; i++) {
            const row = new Array(totalCols).fill("");
            if (i === 1) row[0] = label;
            wb_aoa.push(row);
            merges.push({
                s: { r: startRow + i, c: 0 },
                e: { r: startRow + i, c: totalCols - 1 },
            });
        }
    };

    const addTableHeader = (keys) => {
        wb_aoa.push([...keys, ...new Array(totalCols - keys.length).fill("")]);
    };

    const addSection = (rows, keys, label) => {
        if (!rows) return;
        wb_aoa.push(new Array(totalCols).fill(""));
        addSectionHeader(label);
        addTableHeader(keys);
        rows.forEach((r) => wb_aoa.push(keys.map((k) => r[k] ?? "")));
    };

    let insuranceDataHeaderRow = null;
    let bgDataHeaderRow = null;

    // Project — no leading spacer
    if (projectRows) {
        addSectionHeader("PROJECT DETAILS");
        addTableHeader(visibleProjectKeys);
        projectRows.forEach((r) => wb_aoa.push(visibleProjectKeys.map((k) => r[k] ?? "")));
    }

    // Insurance — track header row for hyperlinks
    if (insuranceRows) {
        wb_aoa.push(new Array(totalCols).fill(""));
        addSectionHeader("INSURANCE DETAILS");
        insuranceDataHeaderRow = wb_aoa.length;
        addTableHeader(visibleInsuranceKeys);
        insuranceRows.forEach((r) => wb_aoa.push(visibleInsuranceKeys.map((k) => r[k] ?? "")));
    }

    // BG — track header row for hyperlinks
    if (bgRows) {
        wb_aoa.push(new Array(totalCols).fill(""));
        addSectionHeader("BG DETAILS");
        bgDataHeaderRow = wb_aoa.length;
        addTableHeader(visibleBGKeys);
        bgRows.forEach((r) => wb_aoa.push(visibleBGKeys.map((k) => r[k] ?? "")));
    }

    addSection(contractorRows, visibleContractorKeys, "CONTRACTOR DETAILS");
    addSection(contractorEOTRows, visibleContractorEOTKeys, "CONTRACTOR EOT DETAILS");
    addSection(consultantEOTRows, visibleConsultantEOTKeys, "CONSULTANT EOT DETAILS");
    addSection(contractorCOSRows, visibleContractorCOSKeys, "CONTRACTOR COS DETAILS");
    addSection(consultantCOSRows, visibleConsultantCOSKeys, "CONSULTANT COS DETAILS");
    addSection(contractorMilestoneRows, visibleContractorMilestoneKeys, "CONTRACTOR MILESTONE DETAILS");
    addSection(consultantMilestoneRows, visibleConsultantMilestoneKeys, "CONSULTANT MILESTONE DETAILS");

    const ws = XLSX.utils.aoa_to_sheet(wb_aoa);
    ws["!merges"] = merges;
    ws["!freeze"] = { xSplit: 3, ySplit: 0 };

    if (insuranceRows && insuranceDataHeaderRow !== null)
        applyFileUrlLinks(ws, insuranceRows, insuranceDataHeaderRow, "File URL");

    if (bgRows && bgDataHeaderRow !== null)
        applyFileUrlLinks(ws, bgRows, bgDataHeaderRow, "BG Document");

    const allVisibleKeys = [
        ...new Set([
            ...visibleProjectKeys,
            ...visibleInsuranceKeys,
            ...visibleBGKeys,
            ...visibleContractorKeys,
            ...visibleContractorEOTKeys,
            ...visibleConsultantEOTKeys,
            ...visibleContractorCOSKeys,
            ...visibleConsultantCOSKeys,
            ...visibleContractorMilestoneKeys,
            ...visibleConsultantMilestoneKeys,
        ]),
    ];

    ws["!cols"] = allVisibleKeys.map((key) => ({
        wch: Math.max(
            key.length,
            ...(projectRows || []).map((r) => String(r[key] ?? "").length),
            ...(insuranceRows || []).map((r) => String(r[key] ?? "").length),
            ...(bgRows || []).map((r) => String(r[key] ?? "").length),
            ...(contractorRows || []).map((r) => String(r[key] ?? "").length),
            ...(contractorEOTRows || []).map((r) => String(r[key] ?? "").length),
            ...(consultantEOTRows || []).map((r) => String(r[key] ?? "").length),
            ...(contractorCOSRows || []).map((r) => String(r[key] ?? "").length),
            ...(consultantCOSRows || []).map((r) => String(r[key] ?? "").length),
            ...(contractorMilestoneRows || []).map((r) => String(r[key] ?? "").length),
            ...(consultantMilestoneRows || []).map((r) => String(r[key] ?? "").length),
        ) + 2,
    }));

    return ws;
};

// ─── Modal Component ────────────────────────────────────────────────────────

const DownloadModal = ({ onClose, onDownload, loading }) => {
    const [selected, setSelected] = useState([]);
    const [mode, setMode] = useState(null); // 'combined' | 'separate' | null

    const options = [
        { id: "project", label: "Project Details", icon: FileText, color: "#3b82f6", bg: "#eff6ff" },
        { id: "insurance", label: "Insurance Details", icon: Shield, color: "#10b981", bg: "#d1fae5" },
        { id: "bg", label: "BG Details", icon: Landmark, color: "#f59e0b", bg: "#fed7aa" },
        { id: "contractor", label: "Contractor Details", icon: Building2, color: "#6366f1", bg: "#e0e7ff" },
        { id: "contractorEOT", label: "Contractor EOT", icon: Clock, color: "#ef4444", bg: "#fee2e2" },
        { id: "consultantEOT", label: "Consultant EOT", icon: Clock, color: "#ef4444", bg: "#fee2e2" },
        { id: "contractorCOS", label: "Contractor COS", icon: FileCheck, color: "#8b5cf6", bg: "#ede9fe" },
        { id: "consultantCOS", label: "Consultant COS", icon: FileCheck, color: "#8b5cf6", bg: "#ede9fe" },
        { id: "contractorMilestone", label: "Milestone", icon: Flag, color: "#ec4899", bg: "#fce7f3" },
    ];

    const toggle = (id) => {
        setSelected((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
        setMode(null);
    };

    const handleDownload = () => {
        if (selected.length === 0) return;
        onDownload({ selected, mode: selected.length > 1 ? mode : "separate" });
    };

    const showModeChoice = selected.length > 1 && !mode;
    const readyToDownload = selected.length > 0 && (selected.length === 1 || mode);
    const selectedCount = selected.length;

    return (
        <div
            onClick={onClose}
            className="download-modal-overlay"
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className="download-modal-container"
            >
                {/* Header */}
                <div className="download-modal-header">
                    <div className="download-modal-title">
                        <div className="download-modal-icon">
                            <DownloadCloud size={25} />
                        </div>
                        <div>
                            <h3>Download Data</h3>
                            <p>Select the data you want to export</p>
                        </div>
                    </div>
                    <button onClick={onClose} className="download-modal-close">
                        <X size={20} />
                    </button>
                </div>

                {/* Step 1 — Select datasets */}
                <div className="download-step">
                    <div className="download-step-title">
                        <span className="step-number">1</span>
                        <span>Select what to download</span>
                    </div>
                    <div className="download-options-grid">
                        {options.map((opt) => {
                            const checked = selected.includes(opt.id);
                            const Icon = opt.icon;
                            return (
                                <label
                                    key={opt.id}
                                    className={`download-option ${checked ? 'checked' : ''}`}
                                    style={{
                                        borderColor: checked ? opt.color : '#e2e8f0',
                                        background: checked ? opt.bg : '#ffffff'
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={checked}
                                        onChange={() => toggle(opt.id)}
                                    />
                                    <div className="download-option-icon" style={{ color: opt.color, background: `${opt.color}10` }}>
                                        <Icon size={16} />
                                    </div>
                                    <span className="download-option-label">{opt.label}</span>
                                </label>
                            );
                        })}
                    </div>
                </div>

                {/* Step 2 — Mode choice (only if >1 selected) */}
                {selected.length > 1 && (
                    <div className="download-step">
                        <div className="download-step-title">
                            <span className="step-number">2</span>
                            <span>How do you want to download?</span>
                        </div>
                        <div className="download-mode-grid">
                            <div
                                onClick={() => setMode("combined")}
                                className={`download-mode ${mode === "combined" ? 'active' : ''}`}
                            >
                                <div className="download-mode-icon">
                                    <FileArchive size={24} />
                                </div>
                                <div className="download-mode-content">
                                    <h4>One Excel File</h4>
                                    <p>All data in a single workbook with section headers</p>
                                </div>
                                {mode === "combined" && <div className="mode-check">✓</div>}
                            </div>
                            <div
                                onClick={() => setMode("separate")}
                                className={`download-mode ${mode === "separate" ? 'active' : ''}`}
                            >
                                <div className="download-mode-icon">
                                    <HardDrive size={24} />
                                </div>
                                <div className="download-mode-content">
                                    <h4>Separate Files</h4>
                                    <p>Each dataset as its own Excel inside a ZIP</p>
                                </div>
                                {mode === "separate" && <div className="mode-check">✓</div>}
                            </div>
                        </div>
                    </div>
                )}

                {/* Selection Summary */}
                {selectedCount > 0 && (
                    <div className="download-summary">
                        <span className="summary-badge">
                            {selectedCount} item{selectedCount !== 1 ? 's' : ''} selected
                        </span>
                        {selectedCount > 1 && mode && (
                            <span className="summary-badge mode-badge">
                                {mode === 'combined' ? 'Combined file' : 'Separate files'}
                            </span>
                        )}
                    </div>
                )}

                {/* Actions */}
                <div className="download-actions">
                    <button onClick={onClose} className="btn-cancell">
                        Cancel
                    </button>
                    <button
                        onClick={handleDownload}
                        disabled={!readyToDownload || loading}
                        className="btn-download"
                    >
                        {loading ? (
                            <>
                                <div className="spinner-small"></div>
                                <span>Downloading...</span>
                            </>
                        ) : (
                            <>
                                <Download size={16} />
                                <span>Download</span>
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

// ─── Main Component ─────────────────────────────────────────────────────────

const DownloadProjectAllDetails = () => {
    const [downloadProject, setDownloadProject] = useState([]);
    const [downloadContractor, setDownloadContractor] = useState([]);
    const [downloadInsurance, setDownloadInsurance] = useState([]);
    const [downloadbg, setDownloadbg] = useState([]);
    const [downloadEOT, setDownloadEOT] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [downloadCOS, setDownloadCOS] = useState([]);
    const [downloadMilestone, setDownloadMilestone] = useState([]);

    const getProjectDetails = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/project/`);
            setDownloadProject(response.data);
        } catch (error) {
            handleErrorToast(error);
        }
    };
    const getContractorDetails = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/contractor/`);
            setDownloadContractor(response.data);
        } catch (error) {
            handleErrorToast(error);
        }
    };

    const getInsurance = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/insurance/`);
            setDownloadInsurance(response.data);
        } catch (error) {
            handleErrorToast(error);
        }
    };
    const getIbg = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/bgfilter/null/null/null/null/null/`);
            setDownloadbg(response.data);
        } catch (error) {
            handleErrorToast(error);
        }
    };
    const getEOT = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/eot/`);
            setDownloadEOT(response.data);
        } catch (error) {
            handleErrorToast(error);
        }
    };
    const getCOS = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/cos/`);
            setDownloadCOS(response.data);
        } catch (error) {
            handleErrorToast(error);
        }
    };
    const getMilestone = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/milestone/`);
            setDownloadMilestone(response.data);
        } catch (error) {
            handleErrorToast(error);
        }
    };

    useEffect(() => {
        setFetching(true);
        Promise.all([getProjectDetails(), getInsurance(), getIbg(), getContractorDetails(), getEOT(), getCOS(), getMilestone()]).finally(() => setFetching(false));
    }, []);
    const handleDownload = async ({ selected, mode }) => {
        setLoading(true);
        const today = new Date().toISOString().slice(0, 10);

        try {
            const hasProject = selected.includes("project") && downloadProject.length > 0;
            const hasInsurance = selected.includes("insurance") && downloadInsurance.length > 0;
            const hasBg = selected.includes("bg") && downloadbg.length > 0;
            const hasContractor = selected.includes("contractor") && downloadContractor.length > 0;
            const hasContractorEOT = selected.includes("contractorEOT") && downloadEOT.length > 0;
            const hasConsultantEOT = selected.includes("consultantEOT") && downloadEOT.length > 0;
            const hasContractorCOS = selected.includes("contractorCOS") && downloadCOS.length > 0;
            const hasConsultantCOS = selected.includes("consultantCOS") && downloadCOS.length > 0;
            const hasContractorMilestone = selected.includes("contractorMilestone") && downloadMilestone.length > 0;

            const projectRows = hasProject ? buildProjectRows(downloadProject) : null;
            const insuranceRows = hasInsurance ? buildInsuranceRows(downloadInsurance) : null;
            const bgRows = hasBg ? buildBgRows(downloadbg) : null;
            const contractorRows = hasContractor ? buildContractorRows(downloadContractor, downloadProject) : null;
            const contractorEOTRows = hasContractorEOT ? buildEOTRows(downloadEOT, "contractor") : null;
            const consultantEOTRows = hasConsultantEOT ? buildEOTRows(downloadEOT, "consultant") : null;
            const contractorCOSRows = hasContractorCOS ? buildCOSRows(downloadCOS, "contractor") : null;
            const consultantCOSRows = hasConsultantCOS ? buildCOSRows(downloadCOS, "consultant") : null;
            const contractorMilestoneRows = hasContractorMilestone ? buildMilestoneRows(downloadMilestone, "contractor") : null;

            if (mode === "combined" && selected.length > 1) {
                const wb = XLSX.utils.book_new();
                const ws = makeCombinedSheet({
                    projectRows,
                    insuranceRows,
                    bgRows,
                    contractorRows,
                    contractorEOTRows,
                    consultantEOTRows,
                    contractorCOSRows,
                    consultantCOSRows,
                    contractorMilestoneRows,
                });
                XLSX.utils.book_append_sheet(wb, ws, "All Data");
                XLSX.writeFile(wb, `All_Data_${today}.xlsx`);

            } else {
                if (selected.length === 1) {
                    if (projectRows) {
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, makeSheet(projectRows), "Projects");
                        XLSX.writeFile(wb, `Project_Details_${today}.xlsx`);
                    } else if (insuranceRows) {
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, makeInsuranceSheet(insuranceRows), "Insurance");
                        XLSX.writeFile(wb, `Insurance_Details_${today}.xlsx`);
                    } else if (bgRows) {
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, makeBgSheet(bgRows), "BG Details");
                        XLSX.writeFile(wb, `BG_Details_${today}.xlsx`);
                    } else if (contractorRows) {
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, makeSheet(contractorRows, 2), "Contractors");
                        XLSX.writeFile(wb, `Contractor_Details_${today}.xlsx`);
                    } else if (contractorEOTRows) {
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, makeSheet(contractorEOTRows, 2), "Contractor EOT");
                        XLSX.writeFile(wb, `Contractor_EOT_${today}.xlsx`);
                    } else if (consultantEOTRows) {
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, makeSheet(consultantEOTRows, 2), "Consultant EOT");
                        XLSX.writeFile(wb, `Consultant_EOT_${today}.xlsx`);
                    } else if (contractorCOSRows) {
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, makeSheet(contractorCOSRows, 2), "Contractor COS");
                        XLSX.writeFile(wb, `Contractor_COS_${today}.xlsx`);
                    } else if (consultantCOSRows) {
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, makeSheet(consultantCOSRows, 2), "Consultant COS");
                        XLSX.writeFile(wb, `Consultant_COS_${today}.xlsx`);
                    } else if (contractorMilestoneRows) {
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, makeSheet(contractorMilestoneRows, 2), "Contractor Milestone");
                        XLSX.writeFile(wb, `Contractor_Milestone_${today}.xlsx`);
                    }

                } else {
                    const zip = new JSZip();

                    const addToZip = (rows, sheetName, fileName, sheetFn = makeSheet, freezeCols = 3) => {
                        if (!rows) return;
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, sheetFn(rows, freezeCols), sheetName);
                        zip.file(fileName, XLSX.write(wb, { bookType: "xlsx", type: "array" }));
                    };

                    addToZip(projectRows, "Projects", `Project_Details_${today}.xlsx`);
                    addToZip(insuranceRows, "Insurance", `Insurance_Details_${today}.xlsx`, makeInsuranceSheet);
                    addToZip(bgRows, "BG Details", `BG_Details_${today}.xlsx`, makeBgSheet);
                    addToZip(contractorRows, "Contractors", `Contractor_Details_${today}.xlsx`, makeSheet, 2);
                    addToZip(contractorEOTRows, "Contractor EOT", `Contractor_EOT_${today}.xlsx`, makeSheet, 2);
                    addToZip(consultantEOTRows, "Consultant EOT", `Consultant_EOT_${today}.xlsx`, makeSheet, 2);
                    addToZip(contractorCOSRows, "Contractor COS", `Contractor_COS_${today}.xlsx`, makeSheet, 2);
                    addToZip(consultantCOSRows, "Consultant COS", `Consultant_COS_${today}.xlsx`, makeSheet, 2);
                    addToZip(contractorMilestoneRows, "Contractor Milestone", `Contractor_Milestone_${today}.xlsx`, makeSheet, 2);

                    const content = await zip.generateAsync({ type: "blob" });
                    const url = URL.createObjectURL(content);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = `Download_${today}.zip`;
                    a.click();
                    URL.revokeObjectURL(url);
                }
            }

            setShowModal(false);
        } catch (err) {
            console.error("Download failed:", err);
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <button
                onClick={() => setShowModal(true)}
                disabled={fetching}
                className="btn-animated"
            >
                {fetching ? "Loading…" : (
                    <>
                        <Download size={18} />
                    </>
                )}
            </button>

            {showModal && (
                <DownloadModal
                    onClose={() => setShowModal(false)}
                    onDownload={handleDownload}
                    loading={loading}
                />
            )}
        </>
    );
};







const DownloadOfficeBill = ({ projectList }) => {
    const tableRef = useRef(null);

    const downloadExcel = () => {
        if (!projectList || projectList.length === 0) {
            toast.error("No data available to download!");
            return;
        }

        const header = [
            "S.No", "Project Name", "Date", "Owner Name", "Days", "Months", "Year",
            "Office Rent Basic Amount", "Tds Amount", "Office Rent Total Amount",
            "Name Of Account Holder", "Bank", "Account No", "IFSC Code"
        ];

        const data = projectList.map((project, index) => [
            index + 1,
            project.project_short_name,
            project.date,
            project.owner_name,
            project.days,
            project.months,
            project.year,
            formatCurrencyIndian(project.rent_amt || 0),
            formatCurrencyIndian(project.tds_amt || 0),
            formatCurrencyIndian(project.total_amt || 0),
            project.account_holder_name,
            project.bank_name,
            project.account_no,
            project.ifsc_code
        ]);

        const wb = XLSX.utils.book_new();

        const ws = XLSX.utils.aoa_to_sheet([header, ...data]);

        const colWidths = header.map((col, i) => ({
            wch: Math.max(...data.map(row => (row[i] || "").toString().length), col.length)
        }));

        ws['!cols'] = colWidths;

        XLSX.utils.book_append_sheet(wb, ws, "Office Billing");

        XLSX.writeFile(wb, "officebilling.xlsx");
    };

    return (
        <button title="Download Office Billing" className="btn-animated" onClick={downloadExcel}>
            <Download size={16} style={{ marginRight: "6px" }} /> Download
        </button>
    );
};

const DownloadVehicleBill = ({ projectList }) => {
    const tableRef = useRef(null);


    const downloadExcel = () => {
        console.log(projectList, 'Vehicle Bill')
        if (!projectList || projectList.length === 0) {
            alert("No data available to download!");
            return;
        }


        const header = [
            "S.No", "Vehicle No", "Vehicle Name", "Fixed Details KM", "Fixed Details Amount", "Extra Amt/Km Above Fixed KM0", "Extra Details KM",
            "Extra Details Amount", "Total Details KM", "Total Details Amount",
            "Name Of Account Holder", "Bank", "Account No", "IFSC Code"
        ];


        const data = projectList.map((project, index) => [

            index + 1,
            project.vehicle_num,
            project.vehicle_name,
            project.fixed_km,
            project.fixed_bill_amt,
            project.extra_amt_above_fix_km,
            project.extra_km,
            // formatCurrencyIndian(project.rent_amt || 0),
            // formatCurrencyIndian(project.tds_amt || 0),
            // formatCurrencyIndian(project.total_amt || 0),
            project.extra_amt_above_fix_km,
            project.total_km,
            formatCurrencyIndian(Number(project?.vehicle_details?.fixed_bill_amt) + Number(project?.vehicle_details?.extra_amt_above_fix_km) * Number(project?.extra_km)),
            project.vehicle_details.account_holder_name,
            project.vehicle_details.bank_name,
            project.vehicle_details.account_num,
            project.vehicle_details.ifsc_code
        ]);


        const wb = XLSX.utils.book_new();


        const ws = XLSX.utils.aoa_to_sheet([header, ...data]);


        const colWidths = header.map((col, i) => ({
            wch: Math.max(...data.map(row => (row[i] || "").toString().length), col.length)
        }));

        ws['!cols'] = colWidths;


        XLSX.utils.book_append_sheet(wb, ws, "Vehicle Billing");

        XLSX.writeFile(wb, "Vehicle Billing.xlsx");
    };

    return (
        <button onClick={downloadExcel} title="Download" className="model-button font-weight500 model-button-print" style={{ margin: "2px" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                </g>
            </svg>
        </button>
    );
};

const DownloadInvoiceBilling = ({ projectList }) => {
    const tableRef = useRef(null);


    const downloadExcel = () => {
        console.log(projectList, 'Vehicle Bill')
        if (!projectList || projectList.length === 0) {
            alert("No data available to download!");
            return;
        }


        const header = [
            "S.No", "invoice_number", "month", "year",
        ];


        const data = projectList.map((project, index) => [

            index + 1,
            project.invoice_number,
            project.month,
            project.year,

        ]);


        const wb = XLSX.utils.book_new();


        const ws = XLSX.utils.aoa_to_sheet([header, ...data]);


        const colWidths = header.map((col, i) => ({
            wch: Math.max(...data.map(row => (row[i] || "").toString().length), col.length)
        }));

        ws['!cols'] = colWidths;


        XLSX.utils.book_append_sheet(wb, ws, "Vehicle Billing");

        XLSX.writeFile(wb, "Vehicle Billing.xlsx");
    };

    return (
        <button onClick={downloadExcel} title="Download" className="model-button font-weight500 model-button-print" style={{ margin: "2px" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                </g>
            </svg>
        </button>
    );
};

const DownloadImprestBill = ({ projectList }) => {
    const tableRef = useRef(null);

    console.log(projectList, 'projectlist')
    const downloadExcel = () => {
        console.log(projectList, 'Imprest Bill')
        if (!projectList || projectList.length === 0) {
            alert("No data available to download!");
            return;
        }


        const header = [
            "S.No",
            "Imprest Date",

            "Imprest Name",
            "Approved Stationary",
            "Approved Electronics",
            "Approved Grocery",
            "Approved Others",
            "Total Amount",

            // "Total Amount",
            "Employee Account Details",

            // "Bank", "Account No", "IFSC Code"
        ];
        // approved others remaining

        const data = projectList.map((project, index) => [
            index + 1,
            formatDate(project.date),
            project.imprest_name,
            project.stationary_item,
            project.electronic_item,
            project.grocery,
            // project?.other_details
            //     ?.reduce((sum, other) => sum + (parseFloat(other?.amount) || 0), 0)
            //     .toLocaleString(),
            project.no_of_days,
            // formatCurrencyIndian(project.rent_amt || 0),
            // formatCurrencyIndian(project.tds_amt || 0),
            // formatCurrencyIndian(project.total_amt || 0),
            formatCurrencyIndian(
                Number(project.stationary_item || '0') +
                Number(project.electronic_item || 0) +
                Number(project.grocery || 0) +
                (project.other_details?.length > 0
                    ? project.other_details.reduce(
                        (total, other) =>
                            total + Number(other.approved_other || 0),
                        0
                    )
                    : 0)
            ),

            project.emp_account_details,


            // project.vehicle_details.bank_name,
            // project.vehicle_details.account_num,
            // project.vehicle_details.ifsc_code
        ]);


        const wb = XLSX.utils.book_new();


        const ws = XLSX.utils.aoa_to_sheet([header, ...data]);


        const colWidths = header.map((col, i) => ({
            wch: Math.max(...data.map(row => (row[i] || "").toString().length), col.length)
        }));

        ws['!cols'] = colWidths;


        XLSX.utils.book_append_sheet(wb, ws, "Imprest Bill");

        XLSX.writeFile(wb, "imprestbilling.xlsx");
    };

    return (
        <button
            className="clearbutton"
            title="Download Excel"
            onClick={downloadExcel}
            style={{
                padding: "10px",
                background: "black"
            }}
        >
            <DownloadCloud size={19} />
        </button>
    );
};

const DownloadExpenseBill = ({ projectList }) => {
    const tableRef = useRef(null);

    console.log(projectList)
    const downloadExcel = () => {
        console.log(projectList, 'Vehicle Bill')
        if (!projectList || projectList.length === 0) {
            alert("No data available to download!");
            return;
        }

        const header = [
            "S.No", "Date", "Project Name", "Expense Against Imprest", "Approved Stationary",
            "Approved Electronics",
            "Approved Grocery",
            "Approved Others",
            "Total Amount",
            "Utilized Amount",
            "Remaining Money",
            "Employee Account Details",
        ];


        const data = projectList.map((i, index) => [
            index + 1,
            formatDate(i.date),
            i.project_name,
            i.name,
            formatCurrencyIndian(i.approved_stationary_item || 0),
            formatCurrencyIndian(i.approved_electronic_item || 0),
            formatCurrencyIndian(i.approved_grocery || 0),

            formatCurrencyIndian(
                i?.other_details?.reduce(
                    (sum, other) =>
                        sum + (parseFloat(other.approved_other) || 0),
                    0
                )
            ),
            formatCurrencyIndian(
                Number(i.stationary_item || '0') +
                Number(i.electronic_item || 0) +
                Number(i.grocery || 0) +
                (i.other_details?.length > 0
                    ? i.other_details.reduce(
                        (total, other) =>
                            total + Number(other.approved_other || 0),
                        0
                    )
                    : 0)
            ),
            // i.utilized_amount ? formatRoundoff2D(i.utilized_amount) : '-',
            // i.remaining_amount ? formatRoundoff2D(i.remaining_amount) : '-',
            // formatCurrencyIndian(i.rent_amt || 0),
            // formatCurrencyIndian(i.tds_amt || 0),
            // formatCurrencyIndian(i.total_amt || 0),


        ]);


        const wb = XLSX.utils.book_new();


        const ws = XLSX.utils.aoa_to_sheet([header, ...data]);


        const colWidths = header.map((col, i) => ({
            wch: Math.max(...data.map(row => (row[i] || "").toString().length), col.length)
        }));

        ws['!cols'] = colWidths;


        XLSX.utils.book_append_sheet(wb, ws, "Vehicle Billing");

        XLSX.writeFile(wb, "officebilling.xlsx");
    };

    return (


        <button
            className="clearbutton"
            onClick={downloadExcel}
            style={{
                padding: "10px"
            }}
        >
            <span className="transition"></span>
            <span className="gradient"></span>
            <span className="label"> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                </g>
            </svg></span>
        </button>


    );
};

const DownloadInvoiceBill = ({ projectList }) => {
    const tableRef = useRef(null);


    const downloadExcel = () => {
        console.log(projectList, 'Vehicle Bill')
        if (!projectList || projectList.length === 0) {
            alert("No data available to download!");
            return;
        }


        const header = [
            "S.No", "Invoice Number", "Month", "Year",
            // "Fixed Details Amount", "Extra Amt/Km Above Fixed KM0", "Extra Details KM",
            // "Extra Details Amount", "Total Details KM", "Total Details Amount",
            "Name Of Account Holder", "Bank", "Account No", "IFSC Code"
        ];


        const data = projectList.map((project, index) => [
            index + 1,
            project.vehicle_num,
            project.vehicle_name,
            project.fixed_km,
            project.fixed_bill_amt,
            project.extra_amt_above_fix_km,
            project.extra_km,
            // formatCurrencyIndian(project.rent_amt || 0),
            // formatCurrencyIndian(project.tds_amt || 0),
            // formatCurrencyIndian(project.total_amt || 0),
            project.extra_amt_above_fix_km,
            project.total_km,
            formatCurrencyIndian(Number(project?.vehicle_details?.fixed_bill_amt) + Number(project?.vehicle_details?.extra_amt_above_fix_km) * Number(project?.extra_km)),
            project.vehicle_details.account_holder_name,
            project.vehicle_details.bank_name,
            project.vehicle_details.account_num,
            project.vehicle_details.ifsc_code
        ]);


        const wb = XLSX.utils.book_new();


        const ws = XLSX.utils.aoa_to_sheet([header, ...data]);


        const colWidths = header.map((col, i) => ({
            wch: Math.max(...data.map(row => (row[i] || "").toString().length), col.length)
        }));

        ws['!cols'] = colWidths;


        XLSX.utils.book_append_sheet(wb, ws, "Vehicle Billing");

        XLSX.writeFile(wb, "officebilling.xlsx");
    };

    return (
        <button onClick={downloadExcel} title="Download" className="model-button font-weight500 model-button-print" style={{ margin: "2px" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                </g>
            </svg>
        </button>
    );
};








export { UploadBulkContractor, UploadOfficeRentBulk, UploadSiteProgressBulk, UploadBGBulk, UploadItemsBulk, UploadInsuranceBulk, UploadBillingBulk, UploadInventory, UploadSiteProject, UploadLetterBulk, UploadDepartment, VehicleModelBulk, UploadDesignation, UploadEotBulk, UploadcosBulk, UploadMilestoneBulk, DownloadSiteProject, DownloadProjectAllDetails, DownloadOfficeBill, DownloadVehicleBill, DownloadImprestBill, DownloadExpenseBill, DownloadInvoiceBilling }